webpackJsonp([72698250460545],{

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * matchesSelector v2.0.2
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	
	( function( window, factory ) {
	  /*global define: false, module: false */
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.matchesSelector = factory();
	  }
	
	}( window, function factory() {
	  'use strict';
	
	  var matchesMethod = ( function() {
	    var ElemProto = window.Element.prototype;
	    // check for the standard method name first
	    if ( ElemProto.matches ) {
	      return 'matches';
	    }
	    // check un-prefixed
	    if ( ElemProto.matchesSelector ) {
	      return 'matchesSelector';
	    }
	    // check vendor prefixes
	    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
	
	    for ( var i=0; i < prefixes.length; i++ ) {
	      var prefix = prefixes[i];
	      var method = prefix + 'MatchesSelector';
	      if ( ElemProto[ method ] ) {
	        return method;
	      }
	    }
	  })();
	
	  return function matchesSelector( elem, selector ) {
	    return elem[ matchesMethod ]( selector );
	  };
	
	}));


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.1.0
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  // copy over to avoid interference if .off() in listener
	  listeners = listeners.slice(0);
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  for ( var i=0; i < listeners.length; i++ ) {
	    var listener = listeners[i]
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	  }
	
	  return this;
	};
	
	proto.allOff = function() {
	  delete this._events;
	  delete this._onceEvents;
	};
	
	return EvEmitter;
	
	}));


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Fizzy UI utils v2.0.7
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(417)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
	      return factory( window, matchesSelector );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('desandro-matches-selector')
	    );
	  } else {
	    // browser global
	    window.fizzyUIUtils = factory(
	      window,
	      window.matchesSelector
	    );
	  }
	
	}( window, function factory( window, matchesSelector ) {
	
	'use strict';
	
	var utils = {};
	
	// ----- extend ----- //
	
	// extends objects
	utils.extend = function( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	};
	
	// ----- modulo ----- //
	
	utils.modulo = function( num, div ) {
	  return ( ( num % div ) + div ) % div;
	};
	
	// ----- makeArray ----- //
	
	var arraySlice = Array.prototype.slice;
	
	// turn element or nodeList into an array
	utils.makeArray = function( obj ) {
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    return obj;
	  }
	  // return empty array if undefined or null. #6
	  if ( obj === null || obj === undefined ) {
	    return [];
	  }
	
	  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	  if ( isArrayLike ) {
	    // convert nodeList to array
	    return arraySlice.call( obj );
	  }
	
	  // array of single index
	  return [ obj ];
	};
	
	// ----- removeFrom ----- //
	
	utils.removeFrom = function( ary, obj ) {
	  var index = ary.indexOf( obj );
	  if ( index != -1 ) {
	    ary.splice( index, 1 );
	  }
	};
	
	// ----- getParent ----- //
	
	utils.getParent = function( elem, selector ) {
	  while ( elem.parentNode && elem != document.body ) {
	    elem = elem.parentNode;
	    if ( matchesSelector( elem, selector ) ) {
	      return elem;
	    }
	  }
	};
	
	// ----- getQueryElement ----- //
	
	// use element as selector string
	utils.getQueryElement = function( elem ) {
	  if ( typeof elem == 'string' ) {
	    return document.querySelector( elem );
	  }
	  return elem;
	};
	
	// ----- handleEvent ----- //
	
	// enable .ontype to trigger from .addEventListener( elem, 'type' )
	utils.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	// ----- filterFindElements ----- //
	
	utils.filterFindElements = function( elems, selector ) {
	  // make array of elems
	  elems = utils.makeArray( elems );
	  var ffElems = [];
	
	  elems.forEach( function( elem ) {
	    // check that elem is an actual element
	    if ( !( elem instanceof HTMLElement ) ) {
	      return;
	    }
	    // add elem if no selector
	    if ( !selector ) {
	      ffElems.push( elem );
	      return;
	    }
	    // filter & find items if we have a selector
	    // filter
	    if ( matchesSelector( elem, selector ) ) {
	      ffElems.push( elem );
	    }
	    // find children
	    var childElems = elem.querySelectorAll( selector );
	    // concat childElems to filterFound array
	    for ( var i=0; i < childElems.length; i++ ) {
	      ffElems.push( childElems[i] );
	    }
	  });
	
	  return ffElems;
	};
	
	// ----- debounceMethod ----- //
	
	utils.debounceMethod = function( _class, methodName, threshold ) {
	  threshold = threshold || 100;
	  // original method
	  var method = _class.prototype[ methodName ];
	  var timeoutName = methodName + 'Timeout';
	
	  _class.prototype[ methodName ] = function() {
	    var timeout = this[ timeoutName ];
	    clearTimeout( timeout );
	
	    var args = arguments;
	    var _this = this;
	    this[ timeoutName ] = setTimeout( function() {
	      method.apply( _this, args );
	      delete _this[ timeoutName ];
	    }, threshold );
	  };
	};
	
	// ----- docReady ----- //
	
	utils.docReady = function( callback ) {
	  var readyState = document.readyState;
	  if ( readyState == 'complete' || readyState == 'interactive' ) {
	    // do async to allow for other scripts to run. metafizzy/flickity#441
	    setTimeout( callback );
	  } else {
	    document.addEventListener( 'DOMContentLoaded', callback );
	  }
	};
	
	// ----- htmlInit ----- //
	
	// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
	utils.toDashed = function( str ) {
	  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
	    return $1 + '-' + $2;
	  }).toLowerCase();
	};
	
	var console = window.console;
	/**
	 * allow user to initialize classes via [data-namespace] or .js-namespace class
	 * htmlInit( Widget, 'widgetName' )
	 * options are parsed from data-namespace-options
	 */
	utils.htmlInit = function( WidgetClass, namespace ) {
	  utils.docReady( function() {
	    var dashedNamespace = utils.toDashed( namespace );
	    var dataAttr = 'data-' + dashedNamespace;
	    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
	    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
	    var elems = utils.makeArray( dataAttrElems )
	      .concat( utils.makeArray( jsDashElems ) );
	    var dataOptionsAttr = dataAttr + '-options';
	    var jQuery = window.jQuery;
	
	    elems.forEach( function( elem ) {
	      var attr = elem.getAttribute( dataAttr ) ||
	        elem.getAttribute( dataOptionsAttr );
	      var options;
	      try {
	        options = attr && JSON.parse( attr );
	      } catch ( error ) {
	        // log error, do not initialize
	        if ( console ) {
	          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
	          ': ' + error );
	        }
	        return;
	      }
	      // initialize
	      var instance = new WidgetClass( elem, options );
	      // make available via $().data('namespace')
	      if ( jQuery ) {
	        jQuery.data( elem, namespace, instance );
	      }
	    });
	
	  });
	};
	
	// -----  ----- //
	
	return utils;
	
	}));


/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(38),
	      __webpack_require__(28)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
	      return factory( window, Flickity, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('./flickity'),
	      require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    factory(
	      window,
	      window.Flickity,
	      window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, utils ) {
	
	'use strict';
	
	// append cells to a document fragment
	function getCellsFragment( cells ) {
	  var fragment = document.createDocumentFragment();
	  cells.forEach( function( cell ) {
	    fragment.appendChild( cell.element );
	  });
	  return fragment;
	}
	
	// -------------------------- add/remove cell prototype -------------------------- //
	
	var proto = Flickity.prototype;
	
	/**
	 * Insert, prepend, or append cells
	 * @param {Element, Array, NodeList} elems
	 * @param {Integer} index
	 */
	proto.insert = function( elems, index ) {
	  var cells = this._makeCells( elems );
	  if ( !cells || !cells.length ) {
	    return;
	  }
	  var len = this.cells.length;
	  // default to append
	  index = index === undefined ? len : index;
	  // add cells with document fragment
	  var fragment = getCellsFragment( cells );
	  // append to slider
	  var isAppend = index == len;
	  if ( isAppend ) {
	    this.slider.appendChild( fragment );
	  } else {
	    var insertCellElement = this.cells[ index ].element;
	    this.slider.insertBefore( fragment, insertCellElement );
	  }
	  // add to this.cells
	  if ( index === 0 ) {
	    // prepend, add to start
	    this.cells = cells.concat( this.cells );
	  } else if ( isAppend ) {
	    // append, add to end
	    this.cells = this.cells.concat( cells );
	  } else {
	    // insert in this.cells
	    var endCells = this.cells.splice( index, len - index );
	    this.cells = this.cells.concat( cells ).concat( endCells );
	  }
	
	  this._sizeCells( cells );
	  this.cellChange( index, true );
	};
	
	proto.append = function( elems ) {
	  this.insert( elems, this.cells.length );
	};
	
	proto.prepend = function( elems ) {
	  this.insert( elems, 0 );
	};
	
	/**
	 * Remove cells
	 * @param {Element, Array, NodeList} elems
	 */
	proto.remove = function( elems ) {
	  var cells = this.getCells( elems );
	  if ( !cells || !cells.length ) {
	    return;
	  }
	
	  var minCellIndex = this.cells.length - 1;
	  // remove cells from collection & DOM
	  cells.forEach( function( cell ) {
	    cell.remove();
	    var index = this.cells.indexOf( cell );
	    minCellIndex = Math.min( index, minCellIndex );
	    utils.removeFrom( this.cells, cell );
	  }, this );
	
	  this.cellChange( minCellIndex, true );
	};
	
	/**
	 * logic to be run after a cell's size changes
	 * @param {Element} elem - cell's element
	 */
	proto.cellSizeChange = function( elem ) {
	  var cell = this.getCell( elem );
	  if ( !cell ) {
	    return;
	  }
	  cell.getSize();
	
	  var index = this.cells.indexOf( cell );
	  this.cellChange( index );
	};
	
	/**
	 * logic any time a cell is changed: added, removed, or size changed
	 * @param {Integer} changedCellIndex - index of the changed cell, optional
	 */
	proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
	  var prevSelectedElem = this.selectedElement;
	  this._positionCells( changedCellIndex );
	  this._getWrapShiftCells();
	  this.setGallerySize();
	  // update selectedIndex
	  // try to maintain position & select previous selected element
	  var cell = this.getCell( prevSelectedElem );
	  if ( cell ) {
	    this.selectedIndex = this.getCellSlideIndex( cell );
	  }
	  this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );
	
	  this.emitEvent( 'cellChange', [ changedCellIndex ] );
	  // position slider
	  this.select( this.selectedIndex );
	  // do not position slider after lazy load
	  if ( isPositioningSlider ) {
	    this.positionSliderAtSelected();
	  }
	};
	
	// -----  ----- //
	
	return Flickity;
	
	}));


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(28)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( utils ) {
	      return factory( window, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.animatePrototype = factory(
	      window,
	      window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, utils ) {
	
	'use strict';
	
	// -------------------------- animate -------------------------- //
	
	var proto = {};
	
	proto.startAnimation = function() {
	  if ( this.isAnimating ) {
	    return;
	  }
	
	  this.isAnimating = true;
	  this.restingFrames = 0;
	  this.animate();
	};
	
	proto.animate = function() {
	  this.applyDragForce();
	  this.applySelectedAttraction();
	
	  var previousX = this.x;
	
	  this.integratePhysics();
	  this.positionSlider();
	  this.settle( previousX );
	  // animate next frame
	  if ( this.isAnimating ) {
	    var _this = this;
	    requestAnimationFrame( function animateFrame() {
	      _this.animate();
	    });
	  }
	};
	
	proto.positionSlider = function() {
	  var x = this.x;
	  // wrap position around
	  if ( this.options.wrapAround && this.cells.length > 1 ) {
	    x = utils.modulo( x, this.slideableWidth );
	    x = x - this.slideableWidth;
	    this.shiftWrapCells( x );
	  }
	
	  x = x + this.cursorPosition;
	  // reverse if right-to-left and using transform
	  x = this.options.rightToLeft ? -x : x;
	  var value = this.getPositionValue( x );
	  // use 3D tranforms for hardware acceleration on iOS
	  // but use 2D when settled, for better font-rendering
	  this.slider.style.transform = this.isAnimating ?
	    'translate3d(' + value + ',0,0)' : 'translateX(' + value + ')';
	
	  // scroll event
	  var firstSlide = this.slides[0];
	  if ( firstSlide ) {
	    var positionX = -this.x - firstSlide.target;
	    var progress = positionX / this.slidesWidth;
	    this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
	  }
	};
	
	proto.positionSliderAtSelected = function() {
	  if ( !this.cells.length ) {
	    return;
	  }
	  this.x = -this.selectedSlide.target;
	  this.velocity = 0; // stop wobble
	  this.positionSlider();
	};
	
	proto.getPositionValue = function( position ) {
	  if ( this.options.percentPosition ) {
	    // percent position, round to 2 digits, like 12.34%
	    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 )+ '%';
	  } else {
	    // pixel positioning
	    return Math.round( position ) + 'px';
	  }
	};
	
	proto.settle = function( previousX ) {
	  // keep track of frames where x hasn't moved
	  if ( !this.isPointerDown && Math.round( this.x * 100 ) == Math.round( previousX * 100 ) ) {
	    this.restingFrames++;
	  }
	  // stop animating if resting for 3 or more frames
	  if ( this.restingFrames > 2 ) {
	    this.isAnimating = false;
	    delete this.isFreeScrolling;
	    // render position with translateX when settled
	    this.positionSlider();
	    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
	  }
	};
	
	proto.shiftWrapCells = function( x ) {
	  // shift before cells
	  var beforeGap = this.cursorPosition + x;
	  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
	  // shift after cells
	  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
	  this._shiftCells( this.afterShiftCells, afterGap, 1 );
	};
	
	proto._shiftCells = function( cells, gap, shift ) {
	  for ( var i=0; i < cells.length; i++ ) {
	    var cell = cells[i];
	    var cellShift = gap > 0 ? shift : 0;
	    cell.wrapShift( cellShift );
	    gap -= cell.size.outerWidth;
	  }
	};
	
	proto._unshiftCells = function( cells ) {
	  if ( !cells || !cells.length ) {
	    return;
	  }
	  for ( var i=0; i < cells.length; i++ ) {
	    cells[i].wrapShift( 0 );
	  }
	};
	
	// -------------------------- physics -------------------------- //
	
	proto.integratePhysics = function() {
	  this.x += this.velocity;
	  this.velocity *= this.getFrictionFactor();
	};
	
	proto.applyForce = function( force ) {
	  this.velocity += force;
	};
	
	proto.getFrictionFactor = function() {
	  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
	};
	
	proto.getRestingPosition = function() {
	  // my thanks to Steven Wittens, who simplified this math greatly
	  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
	};
	
	proto.applyDragForce = function() {
	  if ( !this.isDraggable || !this.isPointerDown ) {
	    return;
	  }
	  // change the position to drag position by applying force
	  var dragVelocity = this.dragX - this.x;
	  var dragForce = dragVelocity - this.velocity;
	  this.applyForce( dragForce );
	};
	
	proto.applySelectedAttraction = function() {
	  // do not attract if pointer down or no slides
	  var dragDown = this.isDraggable && this.isPointerDown;
	  if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
	    return;
	  }
	  var distance = this.selectedSlide.target * -1 - this.x;
	  var force = distance * this.options.selectedAttraction;
	  this.applyForce( force );
	};
	
	return proto;
	
	}));


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(220)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( getSize ) {
	      return factory( window, getSize );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('get-size')
	    );
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.Cell = factory(
	      window,
	      window.getSize
	    );
	  }
	
	}( window, function factory( window, getSize ) {
	
	'use strict';
	
	function Cell( elem, parent ) {
	  this.element = elem;
	  this.parent = parent;
	
	  this.create();
	}
	
	var proto = Cell.prototype;
	
	proto.create = function() {
	  this.element.style.position = 'absolute';
	  this.element.setAttribute( 'aria-selected', 'false' );
	  this.x = 0;
	  this.shift = 0;
	};
	
	proto.destroy = function() {
	  // reset style
	  this.element.style.position = '';
	  var side = this.parent.originSide;
	  this.element.removeAttribute('aria-selected');
	  this.element.style[ side ] = '';
	};
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	proto.setPosition = function( x ) {
	  this.x = x;
	  this.updateTarget();
	  this.renderPosition( x );
	};
	
	// setDefaultTarget v1 method, backwards compatibility, remove in v3
	proto.updateTarget = proto.setDefaultTarget = function() {
	  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
	  this.target = this.x + this.size[ marginProperty ] +
	    this.size.width * this.parent.cellAlign;
	};
	
	proto.renderPosition = function( x ) {
	  // render position of cell with in slider
	  var side = this.parent.originSide;
	  this.element.style[ side ] = this.parent.getPositionValue( x );
	};
	
	/**
	 * @param {Integer} factor - 0, 1, or -1
	**/
	proto.wrapShift = function( shift ) {
	  this.shift = shift;
	  this.renderPosition( this.x + this.parent.slideableWidth * shift );
	};
	
	proto.remove = function() {
	  this.element.parentNode.removeChild( this.element );
	};
	
	return Cell;
	
	}));


/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(38),
	      __webpack_require__(702),
	      __webpack_require__(28)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unidragger, utils ) {
	      return factory( window, Flickity, Unidragger, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('./flickity'),
	      require('unidragger'),
	      require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    window.Flickity = factory(
	      window,
	      window.Flickity,
	      window.Unidragger,
	      window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, Unidragger, utils ) {
	
	'use strict';
	
	// ----- defaults ----- //
	
	utils.extend( Flickity.defaults, {
	  draggable: '>1',
	  dragThreshold: 3,
	});
	
	// ----- create ----- //
	
	Flickity.createMethods.push('_createDrag');
	
	// -------------------------- drag prototype -------------------------- //
	
	var proto = Flickity.prototype;
	utils.extend( proto, Unidragger.prototype );
	proto._touchActionValue = 'pan-y';
	
	// --------------------------  -------------------------- //
	
	var isTouch = 'createTouch' in document;
	var isTouchmoveScrollCanceled = false;
	
	proto._createDrag = function() {
	  this.on( 'activate', this.onActivateDrag );
	  this.on( 'uiChange', this._uiChangeDrag );
	  this.on( 'childUIPointerDown', this._childUIPointerDownDrag );
	  this.on( 'deactivate', this.unbindDrag );
	  this.on( 'cellChange', this.updateDraggable );
	  // TODO updateDraggable on resize? if groupCells & slides change
	  // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
	  // #457, RubaXa/Sortable#973
	  if ( isTouch && !isTouchmoveScrollCanceled ) {
	    window.addEventListener( 'touchmove', function() {});
	    isTouchmoveScrollCanceled = true;
	  }
	};
	
	proto.onActivateDrag = function() {
	  this.handles = [ this.viewport ];
	  this.bindHandles();
	  this.updateDraggable();
	};
	
	proto.onDeactivateDrag = function() {
	  this.unbindHandles();
	  this.element.classList.remove('is-draggable');
	};
	
	proto.updateDraggable = function() {
	  // disable dragging if less than 2 slides. #278
	  if ( this.options.draggable == '>1' ) {
	    this.isDraggable = this.slides.length > 1;
	  } else {
	    this.isDraggable = this.options.draggable;
	  }
	  if ( this.isDraggable ) {
	    this.element.classList.add('is-draggable');
	  } else {
	    this.element.classList.remove('is-draggable');
	  }
	};
	
	// backwards compatibility
	proto.bindDrag = function() {
	  this.options.draggable = true;
	  this.updateDraggable();
	};
	
	proto.unbindDrag = function() {
	  this.options.draggable = false;
	  this.updateDraggable();
	};
	
	proto._uiChangeDrag = function() {
	  delete this.isFreeScrolling;
	};
	
	proto._childUIPointerDownDrag = function( event ) {
	  // allow focus & preventDefault even when not draggable
	  // so child UI elements keep focus on carousel. #721
	  event.preventDefault();
	  this.pointerDownFocus( event );
	};
	
	// -------------------------- pointer events -------------------------- //
	
	proto.pointerDown = function( event, pointer ) {
	  if ( !this.isDraggable ) {
	    this._pointerDownDefault( event, pointer );
	    return;
	  }
	  var isOkay = this.okayPointerDown( event );
	  if ( !isOkay ) {
	    return;
	  }
	
	  this._pointerDownPreventDefault( event );
	  this.pointerDownFocus( event );
	  // blur
	  if ( document.activeElement != this.element ) {
	    // do not blur if already focused
	    this.pointerDownBlur();
	  }
	
	  // stop if it was moving
	  this.dragX = this.x;
	  this.viewport.classList.add('is-pointer-down');
	  // track scrolling
	  this.pointerDownScroll = getScrollPosition();
	  window.addEventListener( 'scroll', this );
	
	  this._pointerDownDefault( event, pointer );
	};
	
	// default pointerDown logic, used for staticClick
	proto._pointerDownDefault = function( event, pointer ) {
	  // track start event position
	  this.pointerDownPointer = pointer;
	  // bind move and end events
	  this._bindPostStartEvents( event );
	  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
	};
	
	var focusNodes = {
	  INPUT: true,
	  TEXTAREA: true,
	  SELECT: true,
	};
	
	proto.pointerDownFocus = function( event ) {
	  var isFocusNode = focusNodes[ event.target.nodeName ];
	  if ( !isFocusNode ) {
	    this.focus();
	  }
	};
	
	proto._pointerDownPreventDefault = function( event ) {
	  var isTouchStart = event.type == 'touchstart';
	  var isTouchPointer = event.pointerType == 'touch';
	  var isFocusNode = focusNodes[ event.target.nodeName ];
	  if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
	    event.preventDefault();
	  }
	};
	
	// ----- move ----- //
	
	proto.hasDragStarted = function( moveVector ) {
	  return Math.abs( moveVector.x ) > this.options.dragThreshold;
	};
	
	// ----- up ----- //
	
	proto.pointerUp = function( event, pointer ) {
	  delete this.isTouchScrolling;
	  this.viewport.classList.remove('is-pointer-down');
	  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
	  this._dragPointerUp( event, pointer );
	};
	
	proto.pointerDone = function() {
	  window.removeEventListener( 'scroll', this );
	  delete this.pointerDownScroll;
	};
	
	// -------------------------- dragging -------------------------- //
	
	proto.dragStart = function( event, pointer ) {
	  if ( !this.isDraggable ) {
	    return;
	  }
	  this.dragStartPosition = this.x;
	  this.startAnimation();
	  window.removeEventListener( 'scroll', this );
	  this.dispatchEvent( 'dragStart', event, [ pointer ] );
	};
	
	proto.pointerMove = function( event, pointer ) {
	  var moveVector = this._dragPointerMove( event, pointer );
	  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
	  this._dragMove( event, pointer, moveVector );
	};
	
	proto.dragMove = function( event, pointer, moveVector ) {
	  if ( !this.isDraggable ) {
	    return;
	  }
	  event.preventDefault();
	
	  this.previousDragX = this.dragX;
	  // reverse if right-to-left
	  var direction = this.options.rightToLeft ? -1 : 1;
	  if ( this.options.wrapAround ) {
	    // wrap around move. #589
	    moveVector.x = moveVector.x % this.slideableWidth;
	  }
	  var dragX = this.dragStartPosition + moveVector.x * direction;
	
	  if ( !this.options.wrapAround && this.slides.length ) {
	    // slow drag
	    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
	    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
	    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
	    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
	  }
	
	  this.dragX = dragX;
	
	  this.dragMoveTime = new Date();
	  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
	};
	
	proto.dragEnd = function( event, pointer ) {
	  if ( !this.isDraggable ) {
	    return;
	  }
	  if ( this.options.freeScroll ) {
	    this.isFreeScrolling = true;
	  }
	  // set selectedIndex based on where flick will end up
	  var index = this.dragEndRestingSelect();
	
	  if ( this.options.freeScroll && !this.options.wrapAround ) {
	    // if free-scroll & not wrap around
	    // do not free-scroll if going outside of bounding slides
	    // so bounding slides can attract slider, and keep it in bounds
	    var restingX = this.getRestingPosition();
	    this.isFreeScrolling = -restingX > this.slides[0].target &&
	      -restingX < this.getLastSlide().target;
	  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
	    // boost selection if selected index has not changed
	    index += this.dragEndBoostSelect();
	  }
	  delete this.previousDragX;
	  // apply selection
	  // TODO refactor this, selecting here feels weird
	  // HACK, set flag so dragging stays in correct direction
	  this.isDragSelect = this.options.wrapAround;
	  this.select( index );
	  delete this.isDragSelect;
	  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
	};
	
	proto.dragEndRestingSelect = function() {
	  var restingX = this.getRestingPosition();
	  // how far away from selected slide
	  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
	  // get closet resting going up and going down
	  var positiveResting = this._getClosestResting( restingX, distance, 1 );
	  var negativeResting = this._getClosestResting( restingX, distance, -1 );
	  // use closer resting for wrap-around
	  var index = positiveResting.distance < negativeResting.distance ?
	    positiveResting.index : negativeResting.index;
	  return index;
	};
	
	/**
	 * given resting X and distance to selected cell
	 * get the distance and index of the closest cell
	 * @param {Number} restingX - estimated post-flick resting position
	 * @param {Number} distance - distance to selected cell
	 * @param {Integer} increment - +1 or -1, going up or down
	 * @returns {Object} - { distance: {Number}, index: {Integer} }
	 */
	proto._getClosestResting = function( restingX, distance, increment ) {
	  var index = this.selectedIndex;
	  var minDistance = Infinity;
	  var condition = this.options.contain && !this.options.wrapAround ?
	    // if contain, keep going if distance is equal to minDistance
	    function( d, md ) { return d <= md; } : function( d, md ) { return d < md; };
	  while ( condition( distance, minDistance ) ) {
	    // measure distance to next cell
	    index += increment;
	    minDistance = distance;
	    distance = this.getSlideDistance( -restingX, index );
	    if ( distance === null ) {
	      break;
	    }
	    distance = Math.abs( distance );
	  }
	  return {
	    distance: minDistance,
	    // selected was previous index
	    index: index - increment
	  };
	};
	
	/**
	 * measure distance between x and a slide target
	 * @param {Number} x
	 * @param {Integer} index - slide index
	 */
	proto.getSlideDistance = function( x, index ) {
	  var len = this.slides.length;
	  // wrap around if at least 2 slides
	  var isWrapAround = this.options.wrapAround && len > 1;
	  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
	  var slide = this.slides[ slideIndex ];
	  if ( !slide ) {
	    return null;
	  }
	  // add distance for wrap-around slides
	  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index / len ) : 0;
	  return x - ( slide.target + wrap );
	};
	
	proto.dragEndBoostSelect = function() {
	  // do not boost if no previousDragX or dragMoveTime
	  if ( this.previousDragX === undefined || !this.dragMoveTime ||
	    // or if drag was held for 100 ms
	    new Date() - this.dragMoveTime > 100 ) {
	    return 0;
	  }
	
	  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
	  var delta = this.previousDragX - this.dragX;
	  if ( distance > 0 && delta > 0 ) {
	    // boost to next if moving towards the right, and positive velocity
	    return 1;
	  } else if ( distance < 0 && delta < 0 ) {
	    // boost to previous if moving towards the left, and negative velocity
	    return -1;
	  }
	  return 0;
	};
	
	// ----- staticClick ----- //
	
	proto.staticClick = function( event, pointer ) {
	  // get clickedCell, if cell was clicked
	  var clickedCell = this.getParentCell( event.target );
	  var cellElem = clickedCell && clickedCell.element;
	  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
	  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
	};
	
	// ----- scroll ----- //
	
	proto.onscroll = function() {
	  var scroll = getScrollPosition();
	  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
	  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
	  // cancel click/tap if scroll is too much
	  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
	    this._pointerDone();
	  }
	};
	
	// ----- utils ----- //
	
	function getScrollPosition() {
	  return {
	    x: window.pageXOffset,
	    y: window.pageYOffset
	  };
	}
	
	// -----  ----- //
	
	return Flickity;
	
	}));


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(94),
	      __webpack_require__(220),
	      __webpack_require__(28),
	      __webpack_require__(442),
	      __webpack_require__(449),
	      __webpack_require__(441)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
	      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('ev-emitter'),
	      require('get-size'),
	      require('fizzy-ui-utils'),
	      require('./cell'),
	      require('./slide'),
	      require('./animate')
	    );
	  } else {
	    // browser global
	    var _Flickity = window.Flickity;
	
	    window.Flickity = factory(
	      window,
	      window.EvEmitter,
	      window.getSize,
	      window.fizzyUIUtils,
	      _Flickity.Cell,
	      _Flickity.Slide,
	      _Flickity.animatePrototype
	    );
	  }
	
	}( window, function factory( window, EvEmitter, getSize,
	  utils, Cell, Slide, animatePrototype ) {
	
	'use strict';
	
	// vars
	var jQuery = window.jQuery;
	var getComputedStyle = window.getComputedStyle;
	var console = window.console;
	
	function moveElements( elems, toElem ) {
	  elems = utils.makeArray( elems );
	  while ( elems.length ) {
	    toElem.appendChild( elems.shift() );
	  }
	}
	
	// -------------------------- Flickity -------------------------- //
	
	// globally unique identifiers
	var GUID = 0;
	// internal store of all Flickity intances
	var instances = {};
	
	function Flickity( element, options ) {
	  var queryElement = utils.getQueryElement( element );
	  if ( !queryElement ) {
	    if ( console ) {
	      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
	    }
	    return;
	  }
	  this.element = queryElement;
	  // do not initialize twice on same element
	  if ( this.element.flickityGUID ) {
	    var instance = instances[ this.element.flickityGUID ];
	    instance.option( options );
	    return instance;
	  }
	
	  // add jQuery
	  if ( jQuery ) {
	    this.$element = jQuery( this.element );
	  }
	  // options
	  this.options = utils.extend( {}, this.constructor.defaults );
	  this.option( options );
	
	  // kick things off
	  this._create();
	}
	
	Flickity.defaults = {
	  accessibility: true,
	  // adaptiveHeight: false,
	  cellAlign: 'center',
	  // cellSelector: undefined,
	  // contain: false,
	  freeScrollFriction: 0.075, // friction when free-scrolling
	  friction: 0.28, // friction when selecting
	  namespaceJQueryEvents: true,
	  // initialIndex: 0,
	  percentPosition: true,
	  resize: true,
	  selectedAttraction: 0.025,
	  setGallerySize: true
	  // watchCSS: false,
	  // wrapAround: false
	};
	
	// hash of methods triggered on _create()
	Flickity.createMethods = [];
	
	var proto = Flickity.prototype;
	// inherit EventEmitter
	utils.extend( proto, EvEmitter.prototype );
	
	proto._create = function() {
	  // add id for Flickity.data
	  var id = this.guid = ++GUID;
	  this.element.flickityGUID = id; // expando
	  instances[ id ] = this; // associate via id
	  // initial properties
	  this.selectedIndex = 0;
	  // how many frames slider has been in same position
	  this.restingFrames = 0;
	  // initial physics properties
	  this.x = 0;
	  this.velocity = 0;
	  this.originSide = this.options.rightToLeft ? 'right' : 'left';
	  // create viewport & slider
	  this.viewport = document.createElement('div');
	  this.viewport.className = 'flickity-viewport';
	  this._createSlider();
	
	  if ( this.options.resize || this.options.watchCSS ) {
	    window.addEventListener( 'resize', this );
	  }
	
	  // add listeners from on option
	  for ( var eventName in this.options.on ) {
	    var listener = this.options.on[ eventName ];
	    this.on( eventName, listener );
	  }
	
	  Flickity.createMethods.forEach( function( method ) {
	    this[ method ]();
	  }, this );
	
	  if ( this.options.watchCSS ) {
	    this.watchCSS();
	  } else {
	    this.activate();
	  }
	
	};
	
	/**
	 * set options
	 * @param {Object} opts
	 */
	proto.option = function( opts ) {
	  utils.extend( this.options, opts );
	};
	
	proto.activate = function() {
	  if ( this.isActive ) {
	    return;
	  }
	  this.isActive = true;
	  this.element.classList.add('flickity-enabled');
	  if ( this.options.rightToLeft ) {
	    this.element.classList.add('flickity-rtl');
	  }
	
	  this.getSize();
	  // move initial cell elements so they can be loaded as cells
	  var cellElems = this._filterFindCellElements( this.element.children );
	  moveElements( cellElems, this.slider );
	  this.viewport.appendChild( this.slider );
	  this.element.appendChild( this.viewport );
	  // get cells from children
	  this.reloadCells();
	
	  if ( this.options.accessibility ) {
	    // allow element to focusable
	    this.element.tabIndex = 0;
	    // listen for key presses
	    this.element.addEventListener( 'keydown', this );
	  }
	
	  this.emitEvent('activate');
	
	  var index;
	  var initialIndex = this.options.initialIndex;
	  if ( this.isInitActivated ) {
	    index = this.selectedIndex;
	  } else if ( initialIndex !== undefined ) {
	    index = this.cells[ initialIndex ] ? initialIndex : 0;
	  } else {
	    index = 0;
	  }
	  // select instantly
	  this.select( index, false, true );
	  // flag for initial activation, for using initialIndex
	  this.isInitActivated = true;
	  // ready event. #493
	  this.dispatchEvent('ready');
	};
	
	// slider positions the cells
	proto._createSlider = function() {
	  // slider element does all the positioning
	  var slider = document.createElement('div');
	  slider.className = 'flickity-slider';
	  slider.style[ this.originSide ] = 0;
	  this.slider = slider;
	};
	
	proto._filterFindCellElements = function( elems ) {
	  return utils.filterFindElements( elems, this.options.cellSelector );
	};
	
	// goes through all children
	proto.reloadCells = function() {
	  // collection of item elements
	  this.cells = this._makeCells( this.slider.children );
	  this.positionCells();
	  this._getWrapShiftCells();
	  this.setGallerySize();
	};
	
	/**
	 * turn elements into Flickity.Cells
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - collection of new Flickity Cells
	 */
	proto._makeCells = function( elems ) {
	  var cellElems = this._filterFindCellElements( elems );
	
	  // create new Flickity for collection
	  var cells = cellElems.map( function( cellElem ) {
	    return new Cell( cellElem, this );
	  }, this );
	
	  return cells;
	};
	
	proto.getLastCell = function() {
	  return this.cells[ this.cells.length - 1 ];
	};
	
	proto.getLastSlide = function() {
	  return this.slides[ this.slides.length - 1 ];
	};
	
	// positions all cells
	proto.positionCells = function() {
	  // size all cells
	  this._sizeCells( this.cells );
	  // position all cells
	  this._positionCells( 0 );
	};
	
	/**
	 * position certain cells
	 * @param {Integer} index - which cell to start with
	 */
	proto._positionCells = function( index ) {
	  index = index || 0;
	  // also measure maxCellHeight
	  // start 0 if positioning all cells
	  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
	  var cellX = 0;
	  // get cellX
	  if ( index > 0 ) {
	    var startCell = this.cells[ index - 1 ];
	    cellX = startCell.x + startCell.size.outerWidth;
	  }
	  var len = this.cells.length;
	  for ( var i=index; i < len; i++ ) {
	    var cell = this.cells[i];
	    cell.setPosition( cellX );
	    cellX += cell.size.outerWidth;
	    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
	  }
	  // keep track of cellX for wrap-around
	  this.slideableWidth = cellX;
	  // slides
	  this.updateSlides();
	  // contain slides target
	  this._containSlides();
	  // update slidesWidth
	  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
	};
	
	/**
	 * cell.getSize() on multiple cells
	 * @param {Array} cells
	 */
	proto._sizeCells = function( cells ) {
	  cells.forEach( function( cell ) {
	    cell.getSize();
	  });
	};
	
	// --------------------------  -------------------------- //
	
	proto.updateSlides = function() {
	  this.slides = [];
	  if ( !this.cells.length ) {
	    return;
	  }
	
	  var slide = new Slide( this );
	  this.slides.push( slide );
	  var isOriginLeft = this.originSide == 'left';
	  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';
	
	  var canCellFit = this._getCanCellFit();
	
	  this.cells.forEach( function( cell, i ) {
	    // just add cell if first cell in slide
	    if ( !slide.cells.length ) {
	      slide.addCell( cell );
	      return;
	    }
	
	    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
	      ( cell.size.outerWidth - cell.size[ nextMargin ] );
	
	    if ( canCellFit.call( this, i, slideWidth ) ) {
	      slide.addCell( cell );
	    } else {
	      // doesn't fit, new slide
	      slide.updateTarget();
	
	      slide = new Slide( this );
	      this.slides.push( slide );
	      slide.addCell( cell );
	    }
	  }, this );
	  // last slide
	  slide.updateTarget();
	  // update .selectedSlide
	  this.updateSelectedSlide();
	};
	
	proto._getCanCellFit = function() {
	  var groupCells = this.options.groupCells;
	  if ( !groupCells ) {
	    return function() {
	      return false;
	    };
	  } else if ( typeof groupCells == 'number' ) {
	    // group by number. 3 -> [0,1,2], [3,4,5], ...
	    var number = parseInt( groupCells, 10 );
	    return function( i ) {
	      return ( i % number ) !== 0;
	    };
	  }
	  // default, group by width of slide
	  // parse '75%
	  var percentMatch = typeof groupCells == 'string' &&
	    groupCells.match(/^(\d+)%$/);
	  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
	  return function( i, slideWidth ) {
	    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
	  };
	};
	
	// alias _init for jQuery plugin .flickity()
	proto._init =
	proto.reposition = function() {
	  this.positionCells();
	  this.positionSliderAtSelected();
	};
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	  this.setCellAlign();
	  this.cursorPosition = this.size.innerWidth * this.cellAlign;
	};
	
	var cellAlignShorthands = {
	  // cell align, then based on origin side
	  center: {
	    left: 0.5,
	    right: 0.5
	  },
	  left: {
	    left: 0,
	    right: 1
	  },
	  right: {
	    right: 0,
	    left: 1
	  }
	};
	
	proto.setCellAlign = function() {
	  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
	  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
	};
	
	proto.setGallerySize = function() {
	  if ( this.options.setGallerySize ) {
	    var height = this.options.adaptiveHeight && this.selectedSlide ?
	      this.selectedSlide.height : this.maxCellHeight;
	    this.viewport.style.height = height + 'px';
	  }
	};
	
	proto._getWrapShiftCells = function() {
	  // only for wrap-around
	  if ( !this.options.wrapAround ) {
	    return;
	  }
	  // unshift previous cells
	  this._unshiftCells( this.beforeShiftCells );
	  this._unshiftCells( this.afterShiftCells );
	  // get before cells
	  // initial gap
	  var gapX = this.cursorPosition;
	  var cellIndex = this.cells.length - 1;
	  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
	  // get after cells
	  // ending gap between last cell and end of gallery viewport
	  gapX = this.size.innerWidth - this.cursorPosition;
	  // start cloning at first cell, working forwards
	  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
	};
	
	proto._getGapCells = function( gapX, cellIndex, increment ) {
	  // keep adding cells until the cover the initial gap
	  var cells = [];
	  while ( gapX > 0 ) {
	    var cell = this.cells[ cellIndex ];
	    if ( !cell ) {
	      break;
	    }
	    cells.push( cell );
	    cellIndex += increment;
	    gapX -= cell.size.outerWidth;
	  }
	  return cells;
	};
	
	// ----- contain ----- //
	
	// contain cell targets so no excess sliding
	proto._containSlides = function() {
	  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
	    return;
	  }
	  var isRightToLeft = this.options.rightToLeft;
	  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
	  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
	  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
	  // content is less than gallery size
	  var isContentSmaller = contentWidth < this.size.innerWidth;
	  // bounds
	  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
	  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
	  // contain each cell target
	  this.slides.forEach( function( slide ) {
	    if ( isContentSmaller ) {
	      // all cells fit inside gallery
	      slide.target = contentWidth * this.cellAlign;
	    } else {
	      // contain to bounds
	      slide.target = Math.max( slide.target, beginBound );
	      slide.target = Math.min( slide.target, endBound );
	    }
	  }, this );
	};
	
	// -----  ----- //
	
	/**
	 * emits events via eventEmitter and jQuery events
	 * @param {String} type - name of event
	 * @param {Event} event - original event
	 * @param {Array} args - extra arguments
	 */
	proto.dispatchEvent = function( type, event, args ) {
	  var emitArgs = event ? [ event ].concat( args ) : args;
	  this.emitEvent( type, emitArgs );
	
	  if ( jQuery && this.$element ) {
	    // default trigger with type if no event
	    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
	    var $event = type;
	    if ( event ) {
	      // create jQuery event
	      var jQEvent = jQuery.Event( event );
	      jQEvent.type = type;
	      $event = jQEvent;
	    }
	    this.$element.trigger( $event, args );
	  }
	};
	
	// -------------------------- select -------------------------- //
	
	/**
	 * @param {Integer} index - index of the slide
	 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
	 * @param {Boolean} isInstant - will immediately set position at selected cell
	 */
	proto.select = function( index, isWrap, isInstant ) {
	  if ( !this.isActive ) {
	    return;
	  }
	  index = parseInt( index, 10 );
	  this._wrapSelect( index );
	
	  if ( this.options.wrapAround || isWrap ) {
	    index = utils.modulo( index, this.slides.length );
	  }
	  // bail if invalid index
	  if ( !this.slides[ index ] ) {
	    return;
	  }
	  var prevIndex = this.selectedIndex;
	  this.selectedIndex = index;
	  this.updateSelectedSlide();
	  if ( isInstant ) {
	    this.positionSliderAtSelected();
	  } else {
	    this.startAnimation();
	  }
	  if ( this.options.adaptiveHeight ) {
	    this.setGallerySize();
	  }
	  // events
	  this.dispatchEvent( 'select', null, [ index ] );
	  // change event if new index
	  if ( index != prevIndex ) {
	    this.dispatchEvent( 'change', null, [ index ] );
	  }
	  // old v1 event name, remove in v3
	  this.dispatchEvent('cellSelect');
	};
	
	// wraps position for wrapAround, to move to closest slide. #113
	proto._wrapSelect = function( index ) {
	  var len = this.slides.length;
	  var isWrapping = this.options.wrapAround && len > 1;
	  if ( !isWrapping ) {
	    return index;
	  }
	  var wrapIndex = utils.modulo( index, len );
	  // go to shortest
	  var delta = Math.abs( wrapIndex - this.selectedIndex );
	  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
	  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
	  if ( !this.isDragSelect && backWrapDelta < delta ) {
	    index += len;
	  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
	    index -= len;
	  }
	  // wrap position so slider is within normal area
	  if ( index < 0 ) {
	    this.x -= this.slideableWidth;
	  } else if ( index >= len ) {
	    this.x += this.slideableWidth;
	  }
	};
	
	proto.previous = function( isWrap, isInstant ) {
	  this.select( this.selectedIndex - 1, isWrap, isInstant );
	};
	
	proto.next = function( isWrap, isInstant ) {
	  this.select( this.selectedIndex + 1, isWrap, isInstant );
	};
	
	proto.updateSelectedSlide = function() {
	  var slide = this.slides[ this.selectedIndex ];
	  // selectedIndex could be outside of slides, if triggered before resize()
	  if ( !slide ) {
	    return;
	  }
	  // unselect previous selected slide
	  this.unselectSelectedSlide();
	  // update new selected slide
	  this.selectedSlide = slide;
	  slide.select();
	  this.selectedCells = slide.cells;
	  this.selectedElements = slide.getCellElements();
	  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
	  // Remove in v3?
	  this.selectedCell = slide.cells[0];
	  this.selectedElement = this.selectedElements[0];
	};
	
	proto.unselectSelectedSlide = function() {
	  if ( this.selectedSlide ) {
	    this.selectedSlide.unselect();
	  }
	};
	
	/**
	 * select slide from number or cell element
	 * @param {Element or Number} elem
	 */
	proto.selectCell = function( value, isWrap, isInstant ) {
	  // get cell
	  var cell = this.queryCell( value );
	  if ( !cell ) {
	    return;
	  }
	
	  var index = this.getCellSlideIndex( cell );
	  this.select( index, isWrap, isInstant );
	};
	
	proto.getCellSlideIndex = function( cell ) {
	  // get index of slides that has cell
	  for ( var i=0; i < this.slides.length; i++ ) {
	    var slide = this.slides[i];
	    var index = slide.cells.indexOf( cell );
	    if ( index != -1 ) {
	      return i;
	    }
	  }
	};
	
	// -------------------------- get cells -------------------------- //
	
	/**
	 * get Flickity.Cell, given an Element
	 * @param {Element} elem
	 * @returns {Flickity.Cell} item
	 */
	proto.getCell = function( elem ) {
	  // loop through cells to get the one that matches
	  for ( var i=0; i < this.cells.length; i++ ) {
	    var cell = this.cells[i];
	    if ( cell.element == elem ) {
	      return cell;
	    }
	  }
	};
	
	/**
	 * get collection of Flickity.Cells, given Elements
	 * @param {Element, Array, NodeList} elems
	 * @returns {Array} cells - Flickity.Cells
	 */
	proto.getCells = function( elems ) {
	  elems = utils.makeArray( elems );
	  var cells = [];
	  elems.forEach( function( elem ) {
	    var cell = this.getCell( elem );
	    if ( cell ) {
	      cells.push( cell );
	    }
	  }, this );
	  return cells;
	};
	
	/**
	 * get cell elements
	 * @returns {Array} cellElems
	 */
	proto.getCellElements = function() {
	  return this.cells.map( function( cell ) {
	    return cell.element;
	  });
	};
	
	/**
	 * get parent cell from an element
	 * @param {Element} elem
	 * @returns {Flickit.Cell} cell
	 */
	proto.getParentCell = function( elem ) {
	  // first check if elem is cell
	  var cell = this.getCell( elem );
	  if ( cell ) {
	    return cell;
	  }
	  // try to get parent cell elem
	  elem = utils.getParent( elem, '.flickity-slider > *' );
	  return this.getCell( elem );
	};
	
	/**
	 * get cells adjacent to a slide
	 * @param {Integer} adjCount - number of adjacent slides
	 * @param {Integer} index - index of slide to start
	 * @returns {Array} cells - array of Flickity.Cells
	 */
	proto.getAdjacentCellElements = function( adjCount, index ) {
	  if ( !adjCount ) {
	    return this.selectedSlide.getCellElements();
	  }
	  index = index === undefined ? this.selectedIndex : index;
	
	  var len = this.slides.length;
	  if ( 1 + ( adjCount * 2 ) >= len ) {
	    return this.getCellElements();
	  }
	
	  var cellElems = [];
	  for ( var i = index - adjCount; i <= index + adjCount ; i++ ) {
	    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
	    var slide = this.slides[ slideIndex ];
	    if ( slide ) {
	      cellElems = cellElems.concat( slide.getCellElements() );
	    }
	  }
	  return cellElems;
	};
	
	/**
	 * select slide from number or cell element
	 * @param {Element, Selector String, or Number} selector
	 */
	proto.queryCell = function( selector ) {
	  if ( typeof selector == 'number' ) {
	    // use number as index
	    return this.cells[ selector ];
	  }
	  if ( typeof selector == 'string' ) {
	    // use string as selector, get element
	    selector = this.element.querySelector( selector );
	  }
	  // get cell from element
	  return this.getCell( selector );
	};
	
	// -------------------------- events -------------------------- //
	
	proto.uiChange = function() {
	  this.emitEvent('uiChange');
	};
	
	proto.childUIPointerDown = function( event ) {
	  this.emitEvent( 'childUIPointerDown', [ event ] );
	};
	
	// ----- resize ----- //
	
	proto.onresize = function() {
	  this.watchCSS();
	  this.resize();
	};
	
	utils.debounceMethod( Flickity, 'onresize', 150 );
	
	proto.resize = function() {
	  if ( !this.isActive ) {
	    return;
	  }
	  this.getSize();
	  // wrap values
	  if ( this.options.wrapAround ) {
	    this.x = utils.modulo( this.x, this.slideableWidth );
	  }
	  this.positionCells();
	  this._getWrapShiftCells();
	  this.setGallerySize();
	  this.emitEvent('resize');
	  // update selected index for group slides, instant
	  // TODO: position can be lost between groups of various numbers
	  var selectedElement = this.selectedElements && this.selectedElements[0];
	  this.selectCell( selectedElement, false, true );
	};
	
	// watches the :after property, activates/deactivates
	proto.watchCSS = function() {
	  var watchOption = this.options.watchCSS;
	  if ( !watchOption ) {
	    return;
	  }
	
	  var afterContent = getComputedStyle( this.element, ':after' ).content;
	  // activate if :after { content: 'flickity' }
	  if ( afterContent.indexOf('flickity') != -1 ) {
	    this.activate();
	  } else {
	    this.deactivate();
	  }
	};
	
	// ----- keydown ----- //
	
	// go previous/next if left/right keys pressed
	proto.onkeydown = function( event ) {
	  // only work if element is in focus
	  var isNotFocused = document.activeElement && document.activeElement != this.element;
	  if ( !this.options.accessibility ||isNotFocused ) {
	    return;
	  }
	
	  var handler = Flickity.keyboardHandlers[ event.keyCode ];
	  if ( handler ) {
	    handler.call( this );
	  }
	};
	
	Flickity.keyboardHandlers = {
	  // left arrow
	  37: function() {
	    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
	    this.uiChange();
	    this[ leftMethod ]();
	  },
	  // right arrow
	  39: function() {
	    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
	    this.uiChange();
	    this[ rightMethod ]();
	  },
	};
	
	// ----- focus ----- //
	
	proto.focus = function() {
	  var prevScrollY = window.pageYOffset;
	  this.element.focus();
	  // hack to fix scroll jump after focus, #76
	  if ( window.pageYOffset != prevScrollY ) {
	    window.scrollTo( window.pageXOffset, prevScrollY );
	  }
	};
	
	// -------------------------- destroy -------------------------- //
	
	// deactivate all Flickity functionality, but keep stuff available
	proto.deactivate = function() {
	  if ( !this.isActive ) {
	    return;
	  }
	  this.element.classList.remove('flickity-enabled');
	  this.element.classList.remove('flickity-rtl');
	  this.unselectSelectedSlide();
	  // destroy cells
	  this.cells.forEach( function( cell ) {
	    cell.destroy();
	  });
	  this.element.removeChild( this.viewport );
	  // move child elements back into element
	  moveElements( this.slider.children, this.element );
	  if ( this.options.accessibility ) {
	    this.element.removeAttribute('tabIndex');
	    this.element.removeEventListener( 'keydown', this );
	  }
	  // set flags
	  this.isActive = false;
	  this.emitEvent('deactivate');
	};
	
	proto.destroy = function() {
	  this.deactivate();
	  window.removeEventListener( 'resize', this );
	  this.emitEvent('destroy');
	  if ( jQuery && this.$element ) {
	    jQuery.removeData( this.element, 'flickity' );
	  }
	  delete this.element.flickityGUID;
	  delete instances[ this.guid ];
	};
	
	// -------------------------- prototype -------------------------- //
	
	utils.extend( proto, animatePrototype );
	
	// -------------------------- extras -------------------------- //
	
	/**
	 * get Flickity instance from element
	 * @param {Element} elem
	 * @returns {Flickity}
	 */
	Flickity.data = function( elem ) {
	  elem = utils.getQueryElement( elem );
	  var id = elem && elem.flickityGUID;
	  return id && instances[ id ];
	};
	
	utils.htmlInit( Flickity, 'flickity' );
	
	if ( jQuery && jQuery.bridget ) {
	  jQuery.bridget( 'flickity', Flickity );
	}
	
	// set internal jQuery, for Webpack + jQuery v3, #478
	Flickity.setJQuery = function( jq ) {
	  jQuery = jq;
	};
	
	Flickity.Cell = Cell;
	
	return Flickity;
	
	}));


/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Flickity v2.1.1
	 * Touch, responsive, flickable carousels
	 *
	 * Licensed GPLv3 for open source use
	 * or Flickity Commercial License for commercial use
	 *
	 * https://flickity.metafizzy.co
	 * Copyright 2015-2018 Metafizzy
	 */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(38),
	      __webpack_require__(443),
	      __webpack_require__(448),
	      __webpack_require__(446),
	      __webpack_require__(447),
	      __webpack_require__(440),
	      __webpack_require__(445)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      require('./flickity'),
	      require('./drag'),
	      require('./prev-next-button'),
	      require('./page-dots'),
	      require('./player'),
	      require('./add-remove-cell'),
	      require('./lazyload')
	    );
	  }
	
	})( window, function factory( Flickity ) {
	  /*jshint strict: false*/
	  return Flickity;
	});


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(38),
	      __webpack_require__(28)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
	      return factory( window, Flickity, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('./flickity'),
	      require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    factory(
	      window,
	      window.Flickity,
	      window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, utils ) {
	'use strict';
	
	Flickity.createMethods.push('_createLazyload');
	var proto = Flickity.prototype;
	
	proto._createLazyload = function() {
	  this.on( 'select', this.lazyLoad );
	};
	
	proto.lazyLoad = function() {
	  var lazyLoad = this.options.lazyLoad;
	  if ( !lazyLoad ) {
	    return;
	  }
	  // get adjacent cells, use lazyLoad option for adjacent count
	  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
	  var cellElems = this.getAdjacentCellElements( adjCount );
	  // get lazy images in those cells
	  var lazyImages = [];
	  cellElems.forEach( function( cellElem ) {
	    var lazyCellImages = getCellLazyImages( cellElem );
	    lazyImages = lazyImages.concat( lazyCellImages );
	  });
	  // load lazy images
	  lazyImages.forEach( function( img ) {
	    new LazyLoader( img, this );
	  }, this );
	};
	
	function getCellLazyImages( cellElem ) {
	  // check if cell element is lazy image
	  if ( cellElem.nodeName == 'IMG' ) {
	    var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
	    var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
	    var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
	    if ( lazyloadAttr || srcAttr || srcsetAttr ) {
	      return [ cellElem ];
	    }
	  }
	  // select lazy images in cell
	  var lazySelector = 'img[data-flickity-lazyload], ' +
	    'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
	  var imgs = cellElem.querySelectorAll( lazySelector );
	  return utils.makeArray( imgs );
	}
	
	// -------------------------- LazyLoader -------------------------- //
	
	/**
	 * class to handle loading images
	 */
	function LazyLoader( img, flickity ) {
	  this.img = img;
	  this.flickity = flickity;
	  this.load();
	}
	
	LazyLoader.prototype.handleEvent = utils.handleEvent;
	
	LazyLoader.prototype.load = function() {
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  // get src & srcset
	  var src = this.img.getAttribute('data-flickity-lazyload') ||
	    this.img.getAttribute('data-flickity-lazyload-src');
	  var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
	  // set src & serset
	  this.img.src = src;
	  if ( srcset ) {
	    this.img.setAttribute( 'srcset', srcset );
	  }
	  // remove attr
	  this.img.removeAttribute('data-flickity-lazyload');
	  this.img.removeAttribute('data-flickity-lazyload-src');
	  this.img.removeAttribute('data-flickity-lazyload-srcset');
	};
	
	LazyLoader.prototype.onload = function( event ) {
	  this.complete( event, 'flickity-lazyloaded' );
	};
	
	LazyLoader.prototype.onerror = function( event ) {
	  this.complete( event, 'flickity-lazyerror' );
	};
	
	LazyLoader.prototype.complete = function( event, className ) {
	  // unbind events
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	
	  var cell = this.flickity.getParentCell( this.img );
	  var cellElem = cell && cell.element;
	  this.flickity.cellSizeChange( cellElem );
	
	  this.img.classList.add( className );
	  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
	};
	
	// -----  ----- //
	
	Flickity.LazyLoader = LazyLoader;
	
	return Flickity;
	
	}));


/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(38),
	      __webpack_require__(277),
	      __webpack_require__(28)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, TapListener, utils ) {
	      return factory( window, Flickity, TapListener, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('./flickity'),
	      require('tap-listener'),
	      require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    factory(
	      window,
	      window.Flickity,
	      window.TapListener,
	      window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, TapListener, utils ) {
	
	// -------------------------- PageDots -------------------------- //
	
	'use strict';
	
	function PageDots( parent ) {
	  this.parent = parent;
	  this._create();
	}
	
	PageDots.prototype = new TapListener();
	
	PageDots.prototype._create = function() {
	  // create holder element
	  this.holder = document.createElement('ol');
	  this.holder.className = 'flickity-page-dots';
	  // create dots, array of elements
	  this.dots = [];
	  // events
	  this.on( 'tap', this.onTap );
	  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
	};
	
	PageDots.prototype.activate = function() {
	  this.setDots();
	  this.bindTap( this.holder );
	  // add to DOM
	  this.parent.element.appendChild( this.holder );
	};
	
	PageDots.prototype.deactivate = function() {
	  // remove from DOM
	  this.parent.element.removeChild( this.holder );
	  TapListener.prototype.destroy.call( this );
	};
	
	PageDots.prototype.setDots = function() {
	  // get difference between number of slides and number of dots
	  var delta = this.parent.slides.length - this.dots.length;
	  if ( delta > 0 ) {
	    this.addDots( delta );
	  } else if ( delta < 0 ) {
	    this.removeDots( -delta );
	  }
	};
	
	PageDots.prototype.addDots = function( count ) {
	  var fragment = document.createDocumentFragment();
	  var newDots = [];
	  var length = this.dots.length;
	  var max = length + count;
	
	  for ( var i = length; i < max; i++ ) {
	    var dot = document.createElement('li');
	    dot.className = 'dot';
	    dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
	    fragment.appendChild( dot );
	    newDots.push( dot );
	  }
	
	  this.holder.appendChild( fragment );
	  this.dots = this.dots.concat( newDots );
	};
	
	PageDots.prototype.removeDots = function( count ) {
	  // remove from this.dots collection
	  var removeDots = this.dots.splice( this.dots.length - count, count );
	  // remove from DOM
	  removeDots.forEach( function( dot ) {
	    this.holder.removeChild( dot );
	  }, this );
	};
	
	PageDots.prototype.updateSelected = function() {
	  // remove selected class on previous
	  if ( this.selectedDot ) {
	    this.selectedDot.className = 'dot';
	    this.selectedDot.removeAttribute('aria-current');
	  }
	  // don't proceed if no dots
	  if ( !this.dots.length ) {
	    return;
	  }
	  this.selectedDot = this.dots[ this.parent.selectedIndex ];
	  this.selectedDot.className = 'dot is-selected';
	  this.selectedDot.setAttribute( 'aria-current', 'step' );
	};
	
	PageDots.prototype.onTap = function( event ) {
	  var target = event.target;
	  // only care about dot clicks
	  if ( target.nodeName != 'LI' ) {
	    return;
	  }
	
	  this.parent.uiChange();
	  var index = this.dots.indexOf( target );
	  this.parent.select( index );
	};
	
	PageDots.prototype.destroy = function() {
	  this.deactivate();
	};
	
	Flickity.PageDots = PageDots;
	
	// -------------------------- Flickity -------------------------- //
	
	utils.extend( Flickity.defaults, {
	  pageDots: true
	});
	
	Flickity.createMethods.push('_createPageDots');
	
	var proto = Flickity.prototype;
	
	proto._createPageDots = function() {
	  if ( !this.options.pageDots ) {
	    return;
	  }
	  this.pageDots = new PageDots( this );
	  // events
	  this.on( 'activate', this.activatePageDots );
	  this.on( 'select', this.updateSelectedPageDots );
	  this.on( 'cellChange', this.updatePageDots );
	  this.on( 'resize', this.updatePageDots );
	  this.on( 'deactivate', this.deactivatePageDots );
	};
	
	proto.activatePageDots = function() {
	  this.pageDots.activate();
	};
	
	proto.updateSelectedPageDots = function() {
	  this.pageDots.updateSelected();
	};
	
	proto.updatePageDots = function() {
	  this.pageDots.setDots();
	};
	
	proto.deactivatePageDots = function() {
	  this.pageDots.deactivate();
	};
	
	// -----  ----- //
	
	Flickity.PageDots = PageDots;
	
	return Flickity;
	
	}));


/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(94),
	      __webpack_require__(28),
	      __webpack_require__(38)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, utils, Flickity ) {
	      return factory( EvEmitter, utils, Flickity );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      require('ev-emitter'),
	      require('fizzy-ui-utils'),
	      require('./flickity')
	    );
	  } else {
	    // browser global
	    factory(
	      window.EvEmitter,
	      window.fizzyUIUtils,
	      window.Flickity
	    );
	  }
	
	}( window, function factory( EvEmitter, utils, Flickity ) {
	
	'use strict';
	
	// -------------------------- Player -------------------------- //
	
	function Player( parent ) {
	  this.parent = parent;
	  this.state = 'stopped';
	  // visibility change event handler
	  this.onVisibilityChange = this.visibilityChange.bind( this );
	  this.onVisibilityPlay = this.visibilityPlay.bind( this );
	}
	
	Player.prototype = Object.create( EvEmitter.prototype );
	
	// start play
	Player.prototype.play = function() {
	  if ( this.state == 'playing' ) {
	    return;
	  }
	  // do not play if page is hidden, start playing when page is visible
	  var isPageHidden = document.hidden;
	  if ( isPageHidden ) {
	    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
	    return;
	  }
	
	  this.state = 'playing';
	  // listen to visibility change
	  document.addEventListener( 'visibilitychange', this.onVisibilityChange );
	  // start ticking
	  this.tick();
	};
	
	Player.prototype.tick = function() {
	  // do not tick if not playing
	  if ( this.state != 'playing' ) {
	    return;
	  }
	
	  var time = this.parent.options.autoPlay;
	  // default to 3 seconds
	  time = typeof time == 'number' ? time : 3000;
	  var _this = this;
	  // HACK: reset ticks if stopped and started within interval
	  this.clear();
	  this.timeout = setTimeout( function() {
	    _this.parent.next( true );
	    _this.tick();
	  }, time );
	};
	
	Player.prototype.stop = function() {
	  this.state = 'stopped';
	  this.clear();
	  // remove visibility change event
	  document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
	};
	
	Player.prototype.clear = function() {
	  clearTimeout( this.timeout );
	};
	
	Player.prototype.pause = function() {
	  if ( this.state == 'playing' ) {
	    this.state = 'paused';
	    this.clear();
	  }
	};
	
	Player.prototype.unpause = function() {
	  // re-start play if paused
	  if ( this.state == 'paused' ) {
	    this.play();
	  }
	};
	
	// pause if page visibility is hidden, unpause if visible
	Player.prototype.visibilityChange = function() {
	  var isPageHidden = document.hidden;
	  this[ isPageHidden ? 'pause' : 'unpause' ]();
	};
	
	Player.prototype.visibilityPlay = function() {
	  this.play();
	  document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
	};
	
	// -------------------------- Flickity -------------------------- //
	
	utils.extend( Flickity.defaults, {
	  pauseAutoPlayOnHover: true
	});
	
	Flickity.createMethods.push('_createPlayer');
	var proto = Flickity.prototype;
	
	proto._createPlayer = function() {
	  this.player = new Player( this );
	
	  this.on( 'activate', this.activatePlayer );
	  this.on( 'uiChange', this.stopPlayer );
	  this.on( 'pointerDown', this.stopPlayer );
	  this.on( 'deactivate', this.deactivatePlayer );
	};
	
	proto.activatePlayer = function() {
	  if ( !this.options.autoPlay ) {
	    return;
	  }
	  this.player.play();
	  this.element.addEventListener( 'mouseenter', this );
	};
	
	// Player API, don't hate the ... thanks I know where the door is
	
	proto.playPlayer = function() {
	  this.player.play();
	};
	
	proto.stopPlayer = function() {
	  this.player.stop();
	};
	
	proto.pausePlayer = function() {
	  this.player.pause();
	};
	
	proto.unpausePlayer = function() {
	  this.player.unpause();
	};
	
	proto.deactivatePlayer = function() {
	  this.player.stop();
	  this.element.removeEventListener( 'mouseenter', this );
	};
	
	// ----- mouseenter/leave ----- //
	
	// pause auto-play on hover
	proto.onmouseenter = function() {
	  if ( !this.options.pauseAutoPlayOnHover ) {
	    return;
	  }
	  this.player.pause();
	  this.element.addEventListener( 'mouseleave', this );
	};
	
	// resume auto-play on hover off
	proto.onmouseleave = function() {
	  this.player.unpause();
	  this.element.removeEventListener( 'mouseleave', this );
	};
	
	// -----  ----- //
	
	Flickity.Player = Player;
	
	return Flickity;
	
	}));


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(38),
	      __webpack_require__(277),
	      __webpack_require__(28)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, TapListener, utils ) {
	      return factory( window, Flickity, TapListener, utils );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('./flickity'),
	      require('tap-listener'),
	      require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    factory(
	      window,
	      window.Flickity,
	      window.TapListener,
	      window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, Flickity, TapListener, utils ) {
	'use strict';
	
	var svgURI = 'http://www.w3.org/2000/svg';
	
	// -------------------------- PrevNextButton -------------------------- //
	
	function PrevNextButton( direction, parent ) {
	  this.direction = direction;
	  this.parent = parent;
	  this._create();
	}
	
	PrevNextButton.prototype = Object.create( TapListener.prototype );
	
	PrevNextButton.prototype._create = function() {
	  // properties
	  this.isEnabled = true;
	  this.isPrevious = this.direction == -1;
	  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
	  this.isLeft = this.direction == leftDirection;
	
	  var element = this.element = document.createElement('button');
	  element.className = 'flickity-button flickity-prev-next-button';
	  element.className += this.isPrevious ? ' previous' : ' next';
	  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
	  element.setAttribute( 'type', 'button' );
	  // init as disabled
	  this.disable();
	
	  element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );
	
	  // create arrow
	  var svg = this.createSVG();
	  element.appendChild( svg );
	  // events
	  this.on( 'tap', this.onTap );
	  this.parent.on( 'select', this.update.bind( this ) );
	  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
	};
	
	PrevNextButton.prototype.activate = function() {
	  this.bindTap( this.element );
	  // click events from keyboard
	  this.element.addEventListener( 'click', this );
	  // add to DOM
	  this.parent.element.appendChild( this.element );
	};
	
	PrevNextButton.prototype.deactivate = function() {
	  // remove from DOM
	  this.parent.element.removeChild( this.element );
	  // do regular TapListener destroy
	  TapListener.prototype.destroy.call( this );
	  // click events from keyboard
	  this.element.removeEventListener( 'click', this );
	};
	
	PrevNextButton.prototype.createSVG = function() {
	  var svg = document.createElementNS( svgURI, 'svg');
	  svg.setAttribute( 'class', 'flickity-button-icon' );
	  svg.setAttribute( 'viewBox', '0 0 100 100' );
	  var path = document.createElementNS( svgURI, 'path');
	  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
	  path.setAttribute( 'd', pathMovements );
	  path.setAttribute( 'class', 'arrow' );
	  // rotate arrow
	  if ( !this.isLeft ) {
	    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
	  }
	  svg.appendChild( path );
	  return svg;
	};
	
	// get SVG path movmement
	function getArrowMovements( shape ) {
	  // use shape as movement if string
	  if ( typeof shape == 'string' ) {
	    return shape;
	  }
	  // create movement string
	  return 'M ' + shape.x0 + ',50' +
	    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
	    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
	    ' L ' + shape.x3 + ',50 ' +
	    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
	    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
	    ' Z';
	}
	
	PrevNextButton.prototype.onTap = function() {
	  if ( !this.isEnabled ) {
	    return;
	  }
	  this.parent.uiChange();
	  var method = this.isPrevious ? 'previous' : 'next';
	  this.parent[ method ]();
	};
	
	PrevNextButton.prototype.handleEvent = utils.handleEvent;
	
	PrevNextButton.prototype.onclick = function( event ) {
	  // only allow clicks from keyboard
	  var focused = document.activeElement;
	  if ( focused && focused == this.element ) {
	    this.onTap( event, event );
	  }
	};
	
	// -----  ----- //
	
	PrevNextButton.prototype.enable = function() {
	  if ( this.isEnabled ) {
	    return;
	  }
	  this.element.disabled = false;
	  this.isEnabled = true;
	};
	
	PrevNextButton.prototype.disable = function() {
	  if ( !this.isEnabled ) {
	    return;
	  }
	  this.element.disabled = true;
	  this.isEnabled = false;
	};
	
	PrevNextButton.prototype.update = function() {
	  // index of first or last slide, if previous or next
	  var slides = this.parent.slides;
	  // enable is wrapAround and at least 2 slides
	  if ( this.parent.options.wrapAround && slides.length > 1 ) {
	    this.enable();
	    return;
	  }
	  var lastIndex = slides.length ? slides.length - 1 : 0;
	  var boundIndex = this.isPrevious ? 0 : lastIndex;
	  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
	  this[ method ]();
	};
	
	PrevNextButton.prototype.destroy = function() {
	  this.deactivate();
	};
	
	// -------------------------- Flickity prototype -------------------------- //
	
	utils.extend( Flickity.defaults, {
	  prevNextButtons: true,
	  arrowShape: {
	    x0: 10,
	    x1: 60, y1: 50,
	    x2: 70, y2: 40,
	    x3: 30
	  }
	});
	
	Flickity.createMethods.push('_createPrevNextButtons');
	var proto = Flickity.prototype;
	
	proto._createPrevNextButtons = function() {
	  if ( !this.options.prevNextButtons ) {
	    return;
	  }
	
	  this.prevButton = new PrevNextButton( -1, this );
	  this.nextButton = new PrevNextButton( 1, this );
	
	  this.on( 'activate', this.activatePrevNextButtons );
	};
	
	proto.activatePrevNextButtons = function() {
	  this.prevButton.activate();
	  this.nextButton.activate();
	  this.on( 'deactivate', this.deactivatePrevNextButtons );
	};
	
	proto.deactivatePrevNextButtons = function() {
	  this.prevButton.deactivate();
	  this.nextButton.deactivate();
	  this.off( 'deactivate', this.deactivatePrevNextButtons );
	};
	
	// --------------------------  -------------------------- //
	
	Flickity.PrevNextButton = PrevNextButton;
	
	return Flickity;
	
	}));


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.Slide = factory();
	  }
	
	}( window, function factory() {
	'use strict';
	
	function Slide( parent ) {
	  this.parent = parent;
	  this.isOriginLeft = parent.originSide == 'left';
	  this.cells = [];
	  this.outerWidth = 0;
	  this.height = 0;
	}
	
	var proto = Slide.prototype;
	
	proto.addCell = function( cell ) {
	  this.cells.push( cell );
	  this.outerWidth += cell.size.outerWidth;
	  this.height = Math.max( cell.size.outerHeight, this.height );
	  // first cell stuff
	  if ( this.cells.length == 1 ) {
	    this.x = cell.x; // x comes from first cell
	    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
	    this.firstMargin = cell.size[ beginMargin ];
	  }
	};
	
	proto.updateTarget = function() {
	  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
	  var lastCell = this.getLastCell();
	  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
	  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
	  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
	};
	
	proto.getLastCell = function() {
	  return this.cells[ this.cells.length - 1 ];
	};
	
	proto.select = function() {
	  this.changeSelected( true );
	};
	
	proto.unselect = function() {
	  this.changeSelected( false );
	};
	
	proto.changeSelected = function( isSelected ) {
	  var classMethod = isSelected ? 'add' : 'remove';
	  this.cells.forEach( function( cell ) {
	    cell.element.classList[ classMethod ]('is-selected');
	    cell.element.setAttribute( 'aria-selected', isSelected.toString() );
	  });
	};
	
	proto.getCellElements = function() {
	  return this.cells.map( function( cell ) {
	    return cell.element;
	  });
	};
	
	return Slide;
	
	}));


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * getSize v2.0.3
	 * measure size of elements
	 * MIT license
	 */
	
	/* jshint browser: true, strict: true, undef: true, unused: true */
	/* globals console: false */
	
	( function( window, factory ) {
	  /* jshint strict: false */ /* globals define, module */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.getSize = factory();
	  }
	
	})( window, function factory() {
	'use strict';
	
	// -------------------------- helpers -------------------------- //
	
	// get a number from a string, not a percentage
	function getStyleSize( value ) {
	  var num = parseFloat( value );
	  // not a percent like '100%', and a number
	  var isValid = value.indexOf('%') == -1 && !isNaN( num );
	  return isValid && num;
	}
	
	function noop() {}
	
	var logError = typeof console == 'undefined' ? noop :
	  function( message ) {
	    console.error( message );
	  };
	
	// -------------------------- measurements -------------------------- //
	
	var measurements = [
	  'paddingLeft',
	  'paddingRight',
	  'paddingTop',
	  'paddingBottom',
	  'marginLeft',
	  'marginRight',
	  'marginTop',
	  'marginBottom',
	  'borderLeftWidth',
	  'borderRightWidth',
	  'borderTopWidth',
	  'borderBottomWidth'
	];
	
	var measurementsLength = measurements.length;
	
	function getZeroSize() {
	  var size = {
	    width: 0,
	    height: 0,
	    innerWidth: 0,
	    innerHeight: 0,
	    outerWidth: 0,
	    outerHeight: 0
	  };
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    size[ measurement ] = 0;
	  }
	  return size;
	}
	
	// -------------------------- getStyle -------------------------- //
	
	/**
	 * getStyle, get style of element, check for Firefox bug
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	function getStyle( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    logError( 'Style returned ' + style +
	      '. Are you running this code in a hidden iframe on Firefox? ' +
	      'See https://bit.ly/getsizebug1' );
	  }
	  return style;
	}
	
	// -------------------------- setup -------------------------- //
	
	var isSetup = false;
	
	var isBoxSizeOuter;
	
	/**
	 * setup
	 * check isBoxSizerOuter
	 * do on first getSize() rather than on page load for Firefox bug
	 */
	function setup() {
	  // setup once
	  if ( isSetup ) {
	    return;
	  }
	  isSetup = true;
	
	  // -------------------------- box sizing -------------------------- //
	
	  /**
	   * Chrome & Safari measure the outer-width on style.width on border-box elems
	   * IE11 & Firefox<29 measures the inner-width
	   */
	  var div = document.createElement('div');
	  div.style.width = '200px';
	  div.style.padding = '1px 2px 3px 4px';
	  div.style.borderStyle = 'solid';
	  div.style.borderWidth = '1px 2px 3px 4px';
	  div.style.boxSizing = 'border-box';
	
	  var body = document.body || document.documentElement;
	  body.appendChild( div );
	  var style = getStyle( div );
	  // round value for browser zoom. desandro/masonry#928
	  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
	  getSize.isBoxSizeOuter = isBoxSizeOuter;
	
	  body.removeChild( div );
	}
	
	// -------------------------- getSize -------------------------- //
	
	function getSize( elem ) {
	  setup();
	
	  // use querySeletor if elem is string
	  if ( typeof elem == 'string' ) {
	    elem = document.querySelector( elem );
	  }
	
	  // do not proceed on non-objects
	  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
	    return;
	  }
	
	  var style = getStyle( elem );
	
	  // if hidden, everything is 0
	  if ( style.display == 'none' ) {
	    return getZeroSize();
	  }
	
	  var size = {};
	  size.width = elem.offsetWidth;
	  size.height = elem.offsetHeight;
	
	  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
	
	  // get all measurements
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    var value = style[ measurement ];
	    var num = parseFloat( value );
	    // any 'auto', 'medium' value will be 0
	    size[ measurement ] = !isNaN( num ) ? num : 0;
	  }
	
	  var paddingWidth = size.paddingLeft + size.paddingRight;
	  var paddingHeight = size.paddingTop + size.paddingBottom;
	  var marginWidth = size.marginLeft + size.marginRight;
	  var marginHeight = size.marginTop + size.marginBottom;
	  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
	  var borderHeight = size.borderTopWidth + size.borderBottomWidth;
	
	  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
	
	  // overwrite width and height if we can get it from style
	  var styleWidth = getStyleSize( style.width );
	  if ( styleWidth !== false ) {
	    size.width = styleWidth +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
	  }
	
	  var styleHeight = getStyleSize( style.height );
	  if ( styleHeight !== false ) {
	    size.height = styleHeight +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
	  }
	
	  size.innerWidth = size.width - ( paddingWidth + borderWidth );
	  size.innerHeight = size.height - ( paddingHeight + borderHeight );
	
	  size.outerWidth = size.width + marginWidth;
	  size.outerHeight = size.height + marginHeight;
	
	  return size;
	}
	
	return getSize;
	
	});


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * imagesLoaded v4.1.4
	 * JavaScript is all like "You images are done yet or what?"
	 * MIT License
	 */
	
	( function( window, factory ) { 'use strict';
	  // universal module definition
	
	  /*global define: false, module: false, require: false */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(94)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
	      return factory( window, EvEmitter );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('ev-emitter')
	    );
	  } else {
	    // browser global
	    window.imagesLoaded = factory(
	      window,
	      window.EvEmitter
	    );
	  }
	
	})( typeof window !== 'undefined' ? window : this,
	
	// --------------------------  factory -------------------------- //
	
	function factory( window, EvEmitter ) {
	
	'use strict';
	
	var $ = window.jQuery;
	var console = window.console;
	
	// -------------------------- helpers -------------------------- //
	
	// extend objects
	function extend( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	}
	
	var arraySlice = Array.prototype.slice;
	
	// turn element or nodeList into an array
	function makeArray( obj ) {
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    return obj;
	  }
	
	  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	  if ( isArrayLike ) {
	    // convert nodeList to array
	    return arraySlice.call( obj );
	  }
	
	  // array of single index
	  return [ obj ];
	}
	
	// -------------------------- imagesLoaded -------------------------- //
	
	/**
	 * @param {Array, Element, NodeList, String} elem
	 * @param {Object or Function} options - if function, use as callback
	 * @param {Function} onAlways - callback function
	 */
	function ImagesLoaded( elem, options, onAlways ) {
	  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
	  if ( !( this instanceof ImagesLoaded ) ) {
	    return new ImagesLoaded( elem, options, onAlways );
	  }
	  // use elem as selector string
	  var queryElem = elem;
	  if ( typeof elem == 'string' ) {
	    queryElem = document.querySelectorAll( elem );
	  }
	  // bail if bad element
	  if ( !queryElem ) {
	    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
	    return;
	  }
	
	  this.elements = makeArray( queryElem );
	  this.options = extend( {}, this.options );
	  // shift arguments if no options set
	  if ( typeof options == 'function' ) {
	    onAlways = options;
	  } else {
	    extend( this.options, options );
	  }
	
	  if ( onAlways ) {
	    this.on( 'always', onAlways );
	  }
	
	  this.getImages();
	
	  if ( $ ) {
	    // add jQuery Deferred object
	    this.jqDeferred = new $.Deferred();
	  }
	
	  // HACK check async to allow time to bind listeners
	  setTimeout( this.check.bind( this ) );
	}
	
	ImagesLoaded.prototype = Object.create( EvEmitter.prototype );
	
	ImagesLoaded.prototype.options = {};
	
	ImagesLoaded.prototype.getImages = function() {
	  this.images = [];
	
	  // filter & find items if we have an item selector
	  this.elements.forEach( this.addElementImages, this );
	};
	
	/**
	 * @param {Node} element
	 */
	ImagesLoaded.prototype.addElementImages = function( elem ) {
	  // filter siblings
	  if ( elem.nodeName == 'IMG' ) {
	    this.addImage( elem );
	  }
	  // get background image on element
	  if ( this.options.background === true ) {
	    this.addElementBackgroundImages( elem );
	  }
	
	  // find children
	  // no non-element nodes, #143
	  var nodeType = elem.nodeType;
	  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
	    return;
	  }
	  var childImgs = elem.querySelectorAll('img');
	  // concat childElems to filterFound array
	  for ( var i=0; i < childImgs.length; i++ ) {
	    var img = childImgs[i];
	    this.addImage( img );
	  }
	
	  // get child background images
	  if ( typeof this.options.background == 'string' ) {
	    var children = elem.querySelectorAll( this.options.background );
	    for ( i=0; i < children.length; i++ ) {
	      var child = children[i];
	      this.addElementBackgroundImages( child );
	    }
	  }
	};
	
	var elementNodeTypes = {
	  1: true,
	  9: true,
	  11: true
	};
	
	ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
	    return;
	  }
	  // get url inside url("...")
	  var reURL = /url\((['"])?(.*?)\1\)/gi;
	  var matches = reURL.exec( style.backgroundImage );
	  while ( matches !== null ) {
	    var url = matches && matches[2];
	    if ( url ) {
	      this.addBackground( url, elem );
	    }
	    matches = reURL.exec( style.backgroundImage );
	  }
	};
	
	/**
	 * @param {Image} img
	 */
	ImagesLoaded.prototype.addImage = function( img ) {
	  var loadingImage = new LoadingImage( img );
	  this.images.push( loadingImage );
	};
	
	ImagesLoaded.prototype.addBackground = function( url, elem ) {
	  var background = new Background( url, elem );
	  this.images.push( background );
	};
	
	ImagesLoaded.prototype.check = function() {
	  var _this = this;
	  this.progressedCount = 0;
	  this.hasAnyBroken = false;
	  // complete if no images
	  if ( !this.images.length ) {
	    this.complete();
	    return;
	  }
	
	  function onProgress( image, elem, message ) {
	    // HACK - Chrome triggers event before object properties have changed. #83
	    setTimeout( function() {
	      _this.progress( image, elem, message );
	    });
	  }
	
	  this.images.forEach( function( loadingImage ) {
	    loadingImage.once( 'progress', onProgress );
	    loadingImage.check();
	  });
	};
	
	ImagesLoaded.prototype.progress = function( image, elem, message ) {
	  this.progressedCount++;
	  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
	  // progress event
	  this.emitEvent( 'progress', [ this, image, elem ] );
	  if ( this.jqDeferred && this.jqDeferred.notify ) {
	    this.jqDeferred.notify( this, image );
	  }
	  // check if completed
	  if ( this.progressedCount == this.images.length ) {
	    this.complete();
	  }
	
	  if ( this.options.debug && console ) {
	    console.log( 'progress: ' + message, image, elem );
	  }
	};
	
	ImagesLoaded.prototype.complete = function() {
	  var eventName = this.hasAnyBroken ? 'fail' : 'done';
	  this.isComplete = true;
	  this.emitEvent( eventName, [ this ] );
	  this.emitEvent( 'always', [ this ] );
	  if ( this.jqDeferred ) {
	    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
	    this.jqDeferred[ jqMethod ]( this );
	  }
	};
	
	// --------------------------  -------------------------- //
	
	function LoadingImage( img ) {
	  this.img = img;
	}
	
	LoadingImage.prototype = Object.create( EvEmitter.prototype );
	
	LoadingImage.prototype.check = function() {
	  // If complete is true and browser supports natural sizes,
	  // try to check for image status manually.
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    // report based on naturalWidth
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    return;
	  }
	
	  // If none of the checks above matched, simulate loading on detached element.
	  this.proxyImage = new Image();
	  this.proxyImage.addEventListener( 'load', this );
	  this.proxyImage.addEventListener( 'error', this );
	  // bind to image as well for Firefox. #191
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.proxyImage.src = this.img.src;
	};
	
	LoadingImage.prototype.getIsImageComplete = function() {
	  // check for non-zero, non-undefined naturalWidth
	  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
	  return this.img.complete && this.img.naturalWidth;
	};
	
	LoadingImage.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.img, message ] );
	};
	
	// ----- events ----- //
	
	// trigger specified handler for event type
	LoadingImage.prototype.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	LoadingImage.prototype.onload = function() {
	  this.confirm( true, 'onload' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.onerror = function() {
	  this.confirm( false, 'onerror' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.unbindEvents = function() {
	  this.proxyImage.removeEventListener( 'load', this );
	  this.proxyImage.removeEventListener( 'error', this );
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	// -------------------------- Background -------------------------- //
	
	function Background( url, element ) {
	  this.url = url;
	  this.element = element;
	  this.img = new Image();
	}
	
	// inherit LoadingImage prototype
	Background.prototype = Object.create( LoadingImage.prototype );
	
	Background.prototype.check = function() {
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.img.src = this.url;
	  // check if image is already complete
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    this.unbindEvents();
	  }
	};
	
	Background.prototype.unbindEvents = function() {
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	Background.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.element, message ] );
	};
	
	// -------------------------- jQuery -------------------------- //
	
	ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
	  jQuery = jQuery || window.jQuery;
	  if ( !jQuery ) {
	    return;
	  }
	  // set local variable
	  $ = jQuery;
	  // $().imagesLoaded()
	  $.fn.imagesLoaded = function( options, callback ) {
	    var instance = new ImagesLoaded( this, options, callback );
	    return instance.jqDeferred.promise( $(this) );
	  };
	};
	// try making plugin
	ImagesLoaded.makeJQueryPlugin();
	
	// --------------------------  -------------------------- //
	
	return ImagesLoaded;
	
	});


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * medium-zoom v0.4.0
	 * Medium zoom on your images in vanilla JavaScript
	 * Copyright 2018 Francois Chalifour
	 * https://github.com/francoischalifour/medium-zoom
	 * MIT License
	 */
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.mediumZoom=t()}(this,function(){"use strict";var e=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},t=["IMG"],o=[27,81],n=function(e){return t.indexOf(e.tagName)>-1},i=function(e){return e.naturalWidth!==e.width},r=function(e){return e&&1===e.nodeType},d=function(d){var a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},l=a.margin,m=void 0===l?0:l,c=a.background,s=void 0===c?"#fff":c,u=a.scrollOffset,f=void 0===u?48:u,p=a.metaClick,v=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{bubbles:!1,cancelable:!1,detail:void 0};if("function"==typeof window.CustomEvent)return new CustomEvent(e,t);var o=document.createEvent("CustomEvent");return o.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),o},g=function(){if(x.original){if(x.original.dispatchEvent(v("show")),T=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0,A=!0,x.zoomed=function(e){var t=e.getBoundingClientRect(),o=t.top,n=t.left,i=t.width,r=t.height,d=e.cloneNode(),a=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0,l=window.pageXOffset||document.documentElement.scrollLeft||document.body.scrollLeft||0;return d.removeAttribute("id"),d.style.position="absolute",d.style.top=o+a+"px",d.style.left=n+l+"px",d.style.width=i+"px",d.style.height=r+"px",d.style.transform="",d}(x.original),document.body.appendChild(O),H.template){var e=r(H.template)?H.template:document.querySelector(H.template);x.template=document.createElement("div"),x.template.appendChild(e.content.cloneNode(!0)),document.body.appendChild(x.template)}if(document.body.appendChild(x.zoomed),requestAnimationFrame(function(){document.body.classList.add("medium-zoom--open")}),x.original.style.visibility="hidden",x.zoomed.classList.add("medium-zoom-image--open"),x.zoomed.addEventListener("click",h),x.zoomed.addEventListener("transitionend",b),x.original.getAttribute("data-zoom-target")){x.zoomedHd=x.zoomed.cloneNode(),x.zoomedHd.src=x.zoomed.getAttribute("data-zoom-target"),x.zoomedHd.onerror=function(){clearInterval(t),console.error("Unable to reach the zoom image target "+x.zoomedHd.src),x.zoomedHd=null,C()};var t=setInterval(function(){x.zoomedHd.naturalWidth&&(clearInterval(t),x.zoomedHd.classList.add("medium-zoom-image--open"),x.zoomedHd.addEventListener("click",h),document.body.appendChild(x.zoomedHd),C())},10)}else C()}},h=function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,o=function(){!A&&x.original&&(x.original.dispatchEvent(v("hide")),A=!0,document.body.classList.remove("medium-zoom--open"),x.zoomed.style.transform="",x.zoomedHd&&(x.zoomedHd.style.transform="",x.zoomedHd.removeEventListener("click",e)),x.template&&(x.template.style.transition="opacity 150ms",x.template.style.opacity=0),x.zoomed.removeEventListener("click",e),x.zoomed.addEventListener("transitionend",E))};t>0?setTimeout(o,t):o()},y=function(e){e&&e.target?(x.original=e.target,g()):x.original?h():(x.original=k[0],g())},z=function(e){if((e.metaKey||e.ctrlKey)&&H.metaClick)return window.open(e.target.getAttribute("data-original")||e.target.parentNode.href||e.target.src,"_blank");e.preventDefault(),y(e)},b=function e(){A=!1,x.zoomed.removeEventListener("transitionend",e),x.original.dispatchEvent(v("shown"))},E=function e(){x.original&&(x.original.style.visibility="",document.body.removeChild(x.zoomed),x.zoomedHd&&document.body.removeChild(x.zoomedHd),document.body.removeChild(O),x.zoomed.classList.remove("medium-zoom-image--open"),x.template&&document.body.removeChild(x.template),A=!1,x.zoomed.removeEventListener("transitionend",e),x.original.dispatchEvent(v("hidden")),x.original=null,x.zoomed=null,x.zoomedHd=null,x.template=null)},w=function(){if(!A&&x.original){var e=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0;Math.abs(T-e)>H.scrollOffset&&h(150)}},L=function(e){o.indexOf(e.keyCode||e.which)>-1&&h()},C=function(){if(x.original){var t={width:window.innerWidth,height:window.innerHeight,left:0,top:0,right:0,bottom:0},o=void 0,n=void 0;if(H.container)if(H.container instanceof Object)e(t,H.container),o=t.width-t.left-t.right-2*H.margin,n=t.height-t.top-t.bottom-2*H.margin;else{var i=(r(H.container)?H.container:document.querySelector(H.container)).getBoundingClientRect(),d=i.width,a=i.height,l=i.left,m=i.top;e(t,{width:d,height:a,left:l,top:m})}o=o||t.width-2*H.margin,n=n||t.height-2*H.margin;var c=x.zoomedHd||x.original,s=c.naturalWidth,u=void 0===s?o:s,f=c.naturalHeight,p=void 0===f?n:f,v=c.getBoundingClientRect(),g=v.top,h=v.left,y=v.width,z=v.height,b=Math.min(u,o)/y,E=Math.min(p,n)/z,w=Math.min(b,E)||1,L="scale("+w+") translate3d("+((o-y)/2-h+H.margin+t.left)/w+"px, "+((n-z)/2-g+H.margin+t.top)/w+"px, 0)";x.zoomed.style.transform=L,x.zoomedHd&&(x.zoomedHd.style.transform=L)}},H={margin:m,background:s,scrollOffset:f,metaClick:void 0===p||p,container:a.container,template:a.template};d instanceof Object&&e(H,d);var k=function(e){try{return Array.isArray(e)?e.filter(n):function(e){return NodeList.prototype.isPrototypeOf(e)||HTMLCollection.prototype.isPrototypeOf(e)}(e)?Array.apply(null,e).filter(n):r(e)?[e].filter(n):"string"==typeof e?Array.apply(null,document.querySelectorAll(e)).filter(n):Array.apply(null,document.querySelectorAll(t.map(function(e){return e.toLowerCase()}).join(","))).filter(i)}catch(e){throw new TypeError("The provided selector is invalid.\nExpects a CSS selector, a Node element, a NodeList, an HTMLCollection or an array.\nSee: https://github.com/francoischalifour/medium-zoom")}}(d),O=function(e){var t=document.createElement("div");return t.classList.add("medium-zoom-overlay"),t.style.backgroundColor=e,t}(H.background),x={original:null,zoomed:null,zoomedHd:null,template:null},T=0,A=!1;return k.forEach(function(e){e.classList.add("medium-zoom-image"),e.addEventListener("click",z)}),O.addEventListener("click",h),document.addEventListener("scroll",w),document.addEventListener("keyup",L),window.addEventListener("resize",h),{show:y,hide:h,toggle:y,update:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return t.background&&(O.style.backgroundColor=t.background),t.container&&t.container instanceof Object&&(t.container=e({},H.container,t.container)),e(H,t)},addEventListeners:function(e,t){k.forEach(function(o){o.addEventListener(e,t)})},detach:function(){x.zoomed&&h();var e=v("detach");k.forEach(function(t){t.classList.remove("medium-zoom-image"),t.removeEventListener("click",z),t.dispatchEvent(e)}),k.splice(0,k.length),O.removeEventListener("click",h),document.removeEventListener("scroll",w),document.removeEventListener("keyup",L),window.removeEventListener("resize",h)},images:k,options:H}},a=Object.freeze({default:d});return function(e,t){void 0===t&&(t={});var o=t.insertAt;if(e&&"undefined"!=typeof document){var n=document.head||document.getElementsByTagName("head")[0],i=document.createElement("style");i.type="text/css","top"===o&&n.firstChild?n.insertBefore(i,n.firstChild):n.appendChild(i),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(document.createTextNode(e))}}(".medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--open .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s}.medium-zoom-image--open{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}"),a&&d||a});


/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(95);
	
	var _flickity = __webpack_require__(444);
	
	var _flickity2 = _interopRequireDefault(_flickity);
	
	var _imagesloaded = __webpack_require__(496);
	
	var _imagesloaded2 = _interopRequireDefault(_imagesloaded);
	
	var _ExecutionEnvironment = __webpack_require__(218);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FlickityComponent = function (_Component) {
	  _inherits(FlickityComponent, _Component);
	
	  function FlickityComponent(props) {
	    _classCallCheck(this, FlickityComponent);
	
	    var _this = _possibleConstructorReturn(this, (FlickityComponent.__proto__ || Object.getPrototypeOf(FlickityComponent)).call(this, props));
	
	    _this.state = {
	      flickityReady: false
	    };
	
	    _this.carousel = null;
	    _this.flkty = null;
	    _this.imagesLoaded = _this.imagesLoaded.bind(_this);
	    return _this;
	  }
	
	  _createClass(FlickityComponent, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.reloadOnUpdate || !prevState.flickityReady && this.state.flickityReady) {
	        this.flkty.reloadCells();
	        this.flkty.resize();
	      }
	      this.imagesLoaded();
	    }
	  }, {
	    key: 'imagesLoaded',
	    value: function imagesLoaded() {
	      if (!this.props.disableImagesLoaded && _ExecutionEnvironment.canUseDOM) {
	        (0, _imagesloaded2.default)(this.carousel, function (instance) {
	          this.flkty.reloadCells();
	        }.bind(this));
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var carousel = this.carousel;
	      if (_ExecutionEnvironment.canUseDOM) {
	        this.flkty = new _flickity2.default(carousel, this.props.options);
	        this.setState({ flickityReady: true });
	        if (this.props.flickityRef) {
	          this.props.flickityRef(this.flkty);
	        }
	      }
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal() {
	      if (!this.carousel) {
	        return null;
	      }
	      var mountNode = this.carousel.querySelector('.flickity-slider');
	      if (mountNode) {
	        return (0, _reactDom.createPortal)(this.props.children, mountNode);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(this.props.elementType, {
	        className: this.props.className,
	        ref: function ref(c) {
	          _this2.carousel = c;
	        }
	      }, this.renderPortal());
	    }
	  }]);
	
	  return FlickityComponent;
	}(_react.Component);
	
	FlickityComponent.propTypes = {
	  disableImagesLoaded: _propTypes2.default.bool,
	  reloadOnUpdate: _propTypes2.default.bool,
	  options: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  elementType: _propTypes2.default.string,
	  children: _propTypes2.default.array,
	  flickityRef: _propTypes2.default.func
	};
	
	FlickityComponent.defaultProps = {
	  disableImagesLoaded: false,
	  reloadOnUpdate: false,
	  options: {},
	  className: '',
	  elementType: 'div'
	};
	
	exports.default = FlickityComponent;
	module.exports = exports['default'];
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(687);


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomFromSeed = __webpack_require__(690);
	
	var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
	var alphabet;
	var previousSeed;
	
	var shuffled;
	
	function reset() {
	    shuffled = false;
	}
	
	function setCharacters(_alphabet_) {
	    if (!_alphabet_) {
	        if (alphabet !== ORIGINAL) {
	            alphabet = ORIGINAL;
	            reset();
	        }
	        return;
	    }
	
	    if (_alphabet_ === alphabet) {
	        return;
	    }
	
	    if (_alphabet_.length !== ORIGINAL.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
	    }
	
	    var unique = _alphabet_.split('').filter(function(item, ind, arr){
	       return ind !== arr.lastIndexOf(item);
	    });
	
	    if (unique.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
	    }
	
	    alphabet = _alphabet_;
	    reset();
	}
	
	function characters(_alphabet_) {
	    setCharacters(_alphabet_);
	    return alphabet;
	}
	
	function setSeed(seed) {
	    randomFromSeed.seed(seed);
	    if (previousSeed !== seed) {
	        reset();
	        previousSeed = seed;
	    }
	}
	
	function shuffle() {
	    if (!alphabet) {
	        setCharacters(ORIGINAL);
	    }
	
	    var sourceArray = alphabet.split('');
	    var targetArray = [];
	    var r = randomFromSeed.nextValue();
	    var characterIndex;
	
	    while (sourceArray.length > 0) {
	        r = randomFromSeed.nextValue();
	        characterIndex = Math.floor(r * sourceArray.length);
	        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
	    }
	    return targetArray.join('');
	}
	
	function getShuffled() {
	    if (shuffled) {
	        return shuffled;
	    }
	    shuffled = shuffle();
	    return shuffled;
	}
	
	/**
	 * lookup shuffled letter
	 * @param index
	 * @returns {string}
	 */
	function lookup(index) {
	    var alphabetShuffled = getShuffled();
	    return alphabetShuffled[index];
	}
	
	module.exports = {
	    characters: characters,
	    seed: setSeed,
	    lookup: lookup,
	    shuffled: getShuffled
	};


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var encode = __webpack_require__(273);
	var alphabet = __webpack_require__(109);
	
	// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
	// This number should be updated every year or so to keep the generated id short.
	// To regenerate `new Date() - 0` and bump the version. Always bump the version!
	var REDUCE_TIME = 1459707606518;
	
	// don't change unless we change the algos or REDUCE_TIME
	// must be an integer and less than 16
	var version = 6;
	
	// Counter is used when shortid is called multiple times in one second.
	var counter;
	
	// Remember the last time shortid was called in case counter is needed.
	var previousSeconds;
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function build(clusterWorkerId) {
	
	    var str = '';
	
	    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);
	
	    if (seconds === previousSeconds) {
	        counter++;
	    } else {
	        counter = 0;
	        previousSeconds = seconds;
	    }
	
	    str = str + encode(alphabet.lookup, version);
	    str = str + encode(alphabet.lookup, clusterWorkerId);
	    if (counter > 0) {
	        str = str + encode(alphabet.lookup, counter);
	    }
	    str = str + encode(alphabet.lookup, seconds);
	
	    return str;
	}
	
	module.exports = build;


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(109);
	
	/**
	 * Decode the id to get the version and worker
	 * Mainly for debugging and testing.
	 * @param id - the shortid-generated id.
	 */
	function decode(id) {
	    var characters = alphabet.shuffled();
	    return {
	        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
	        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
	    };
	}
	
	module.exports = decode;


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomByte = __webpack_require__(689);
	
	function encode(lookup, number) {
	    var loopCounter = 0;
	    var done;
	
	    var str = '';
	
	    while (!done) {
	        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
	        done = number < (Math.pow(16, loopCounter + 1 ) );
	        loopCounter++;
	    }
	    return str;
	}
	
	module.exports = encode;


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabet = __webpack_require__(109);
	var encode = __webpack_require__(273);
	var decode = __webpack_require__(686);
	var build = __webpack_require__(685);
	var isValid = __webpack_require__(688);
	
	// if you are using cluster or multiple servers use this to make each instance
	// has a unique value for worker
	// Note: I don't know if this is automatically set when using third
	// party cluster solutions such as pm2.
	var clusterWorkerId = __webpack_require__(691) || 0;
	
	/**
	 * Set the seed.
	 * Highly recommended if you don't want people to try to figure out your id schema.
	 * exposed as shortid.seed(int)
	 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
	 */
	function seed(seedValue) {
	    alphabet.seed(seedValue);
	    return module.exports;
	}
	
	/**
	 * Set the cluster worker or machine id
	 * exposed as shortid.worker(int)
	 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
	 * returns shortid module so it can be chained.
	 */
	function worker(workerId) {
	    clusterWorkerId = workerId;
	    return module.exports;
	}
	
	/**
	 *
	 * sets new characters to use in the alphabet
	 * returns the shuffled alphabet
	 */
	function characters(newCharacters) {
	    if (newCharacters !== undefined) {
	        alphabet.characters(newCharacters);
	    }
	
	    return alphabet.shuffled();
	}
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function generate() {
	  return build(clusterWorkerId);
	}
	
	// Export all other functions as properties of the generate function
	module.exports = generate;
	module.exports.generate = generate;
	module.exports.seed = seed;
	module.exports.worker = worker;
	module.exports.characters = characters;
	module.exports.decode = decode;
	module.exports.isValid = isValid;


/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(109);
	
	function isShortId(id) {
	    if (!id || typeof id !== 'string' || id.length < 6 ) {
	        return false;
	    }
	
	    var characters = alphabet.characters();
	    var len = id.length;
	    for(var i = 0; i < len;i++) {
	        if (characters.indexOf(id[i]) === -1) {
	            return false;
	        }
	    }
	    return true;
	}
	
	module.exports = isShortId;


/***/ }),

/***/ 689:
/***/ (function(module, exports) {

	'use strict';
	
	var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
	
	function randomByte() {
	    if (!crypto || !crypto.getRandomValues) {
	        return Math.floor(Math.random() * 256) & 0x30;
	    }
	    var dest = new Uint8Array(1);
	    crypto.getRandomValues(dest);
	    return dest[0] & 0x30;
	}
	
	module.exports = randomByte;


/***/ }),

/***/ 690:
/***/ (function(module, exports) {

	'use strict';
	
	// Found this seed-based random generator somewhere
	// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
	
	var seed = 1;
	
	/**
	 * return a random number based on a seed
	 * @param seed
	 * @returns {number}
	 */
	function getNextValue() {
	    seed = (seed * 9301 + 49297) % 233280;
	    return seed/(233280.0);
	}
	
	function setSeed(_seed_) {
	    seed = _seed_;
	}
	
	module.exports = {
	    nextValue: getNextValue,
	    seed: setSeed
	};


/***/ }),

/***/ 691:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = 0;


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-env browser, amd, node */
	
	/**
	 *
	 * @file Translates plain ASCII punctuation characters into "smart" typographic punctuation
	 * @desc See the readme for details, installation instructions, and * license information.
	 * @version 0.0.4
	 * @author othree
	 *
	 * Copyright (c) 2003-2004 John Gruber
	 * Copyright (c) 2016      Kao, Wei-Ko(othree)
	 *
	 * @see {@link https://www.npmjs.com/package/smartypants|smartypants.js}
	 */
	
	/*! smartypants.js 0.0.6 | (c) Kao, Wei-Ko(othree) | github.com/othree/smartypants.js/blob/master/LICENSE */
	
	(function (root, factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) {
	      factory((root.SmartyPants = exports));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
	    // CommonJS
	    factory(exports);
	  } else {
	    // Browser globals
	    factory((root.SmartyPants = {}));
	  }
	}(this, function (exports) {
	
	  "use strict";
	  exports.__esModule = true;
	  var tags_to_skip = /<(\/?)(?:pre|code|kbd|script|math)[^>]*>/i;
	  /**
	   * @param text text to be parsed
	   * @param attr value of the smart_quotes="" attribute
	   */
	  var SmartyPants = function (text, attr) {
	    if (text === void 0) { text = ''; }
	    if (attr === void 0) { attr = '1'; }
	    var do_quotes;
	    var do_backticks;
	    var do_dashes;
	    var do_ellipses;
	    var do_stupefy;
	    var convert_quot = 0;
	    if (typeof attr === 'number') {
	      attr = attr.toString();
	    }
	    else {
	      attr = attr.replace(/\s/g, '');
	    }
	    /**
	     * Parse attributes:
	     * 0 : do nothing
	     * 1 : set all
	     * 2 : set all, using old school en- and em- dash shortcuts
	     * 3 : set all, using inverted old school en and em- dash shortcuts
	     *
	     * q : quotes
	     * b : backtick quotes (``double'' only)
	     * B : backtick quotes (``double'' and `single')
	     * d : dashes
	     * D : old school dashes
	     * i : inverted old school dashes
	     * e : ellipses
	     * w : convert &quot; entities to " for Dreamweaver users
	    */
	    if (attr === '0') {
	      // Do nothing
	      return text;
	    }
	    else if (attr === '1') {
	      // Do everything, turn all options on.
	      do_quotes = 1;
	      do_backticks = 1;
	      do_dashes = 1;
	      do_ellipses = 1;
	    }
	    else if (attr === '2') {
	      // Do everything, turn all options on, use old school dash shorthand.
	      do_quotes = 1;
	      do_backticks = 1;
	      do_dashes = 3;
	      do_ellipses = 1;
	    }
	    else if (attr === '3') {
	      // Do everything, turn all options on, use inverted old school dash shorthand.
	      do_quotes = 1;
	      do_backticks = 1;
	      do_dashes = 3;
	      do_ellipses = 1;
	    }
	    else if (attr === '-1') {
	      // Special "stupefy" mode.
	      do_stupefy = 1;
	    }
	    else {
	      for (var i = 0; i < attr.length; i++) {
	        var c = attr[i];
	        if (c === 'q') {
	          do_quotes = 1;
	        }
	        if (c === 'b') {
	          do_backticks = 1;
	        }
	        if (c === 'B') {
	          do_backticks = 2;
	        }
	        if (c === 'd') {
	          do_dashes = 1;
	        }
	        if (c === 'D') {
	          do_dashes = 2;
	        }
	        if (c === 'i') {
	          do_dashes = 3;
	        }
	        if (c === 'e') {
	          do_ellipses = 1;
	        }
	        if (c === 'w') {
	          convert_quot = 1;
	        }
	      }
	    }
	    var tokens = _tokenize(text);
	    var result = '';
	    /**
	     * Keep track of when we're inside <pre> or <code> tags.
	     */
	    var in_pre = 0;
	    /**
	     * This is a cheat, used to get some context
	     * for one-character tokens that consist of
	     * just a quote char. What we do is remember
	     * the last character of the previous text
	     * token, to use as context to curl single-
	     * character quote tokens correctly.
	     */
	    var prev_token_last_char = '';
	    for (var i = 0; i < tokens.length; i++) {
	      var cur_token = tokens[i];
	      if (cur_token[0] === 'tag') {
	        result = result + cur_token[1];
	        var matched = tags_to_skip.exec(cur_token[1]);
	        if (matched) {
	          if (matched[1] === '/') {
	            in_pre = 0;
	          }
	          else {
	            in_pre = 1;
	          }
	        }
	      }
	      else {
	        var t = cur_token[1];
	        var last_char = t.substring(t.length - 1, t.length); // Remember last char of this token before processing.
	        if (!in_pre) {
	          t = ProcessEscapes(t);
	          if (convert_quot) {
	            t = t.replace(/$quot;/g, '"');
	          }
	          if (do_dashes) {
	            if (do_dashes === 1) {
	              t = EducateDashes(t);
	            }
	            if (do_dashes === 2) {
	              t = EducateDashesOldSchool(t);
	            }
	            if (do_dashes === 3) {
	              t = EducateDashesOldSchoolInverted(t);
	            }
	          }
	          if (do_ellipses) {
	            t = EducateEllipses(t);
	          }
	          // Note: backticks need to be processed before quotes.
	          if (do_backticks) {
	            t = EducateBackticks(t);
	            if (do_backticks === 2) {
	              t = EducateSingleBackticks(t);
	            }
	          }
	          if (do_quotes) {
	            if (t === '\'') {
	              // Special case: single-character ' token
	              if (/\S/.test(prev_token_last_char)) {
	                t = '&#8217;';
	              }
	              else {
	                t = '&#8216;';
	              }
	            }
	            else if (t === '"') {
	              // Special case: single-character " token
	              if (/\S/.test(prev_token_last_char)) {
	                t = '&#8221;';
	              }
	              else {
	                t = '&#8220;';
	              }
	            }
	            else {
	              // Normal case:
	              t = EducateQuotes(t);
	            }
	          }
	          if (do_stupefy) {
	            t = StupefyEntities(t);
	          }
	        }
	        prev_token_last_char = last_char;
	        result = result + t;
	      }
	    }
	    return result;
	  };
	  exports.smartypants = SmartyPants;
	  var SmartQuotes = function (text, attr) {
	    if (text === void 0) { text = ''; }
	    if (attr === void 0) { attr = '1'; }
	    /**
	     * should we educate ``backticks'' -style quotes?
	     */
	    var do_backticks;
	    if (typeof attr === 'number') {
	      attr = attr.toString();
	    }
	    else {
	      attr = attr.replace(/\s/g, '');
	    }
	    if (attr === '0') {
	      // Do nothing
	      return text;
	    }
	    else if (attr === '2') {
	      // smarten ``backticks'' -style quotes
	      do_backticks = 1;
	    }
	    else {
	      do_backticks = 0;
	    }
	    /**
	     * Special case to handle quotes at the very end of $text when preceded by
	     * an HTML tag. Add a space to give the quote education algorithm a bit of
	     * context, so that it can guess correctly that it's a closing quote:
	     */
	    var add_extra_space = 0;
	    if (/>['"]$/.test(text)) {
	      add_extra_space = 1; // Remember, so we can trim the extra space later.
	      text = text + ' ';
	    }
	    var tokens = _tokenize(text);
	    var result = '';
	    /**
	     * Keep track of when we're inside <pre> or <code> tags.
	     */
	    var in_pre = 0;
	    /**
	     * This is a cheat, used to get some context
	     * for one-character tokens that consist of
	     * just a quote char. What we do is remember
	     * the last character of the previous text
	     * token, to use as context to curl single-
	     * character quote tokens correctly.
	     */
	    var prev_token_last_char = '';
	    for (var i = 0; i < tokens.length; i++) {
	      var cur_token = tokens[i];
	      if (cur_token[0] === 'tag') {
	        result = result + cur_token[1];
	        var matched = tags_to_skip.exec(cur_token[1]);
	        if (matched) {
	          if (matched[1] === '/') {
	            in_pre = 0;
	          }
	          else {
	            in_pre = 1;
	          }
	        }
	      }
	      else {
	        var t = cur_token[1];
	        var last_char = t.substring(t.length - 1, t.length); // Remember last char of this token before processing.
	        if (!in_pre) {
	          t = ProcessEscapes(t);
	          if (t === '\'') {
	            // Special case: single-character ' token
	            if (/\S/.test(prev_token_last_char)) {
	              t = '&#8217;';
	            }
	            else {
	              t = '&#8216;';
	            }
	          }
	          else if (t === '"') {
	            // Special case: single-character " token
	            if (/\S/.test(prev_token_last_char)) {
	              t = '&#8221;';
	            }
	            else {
	              t = '&#8220;';
	            }
	          }
	          else {
	            // Normal case:
	            t = EducateQuotes(t);
	          }
	        }
	        prev_token_last_char = last_char;
	        result = result + t;
	      }
	    }
	    if (add_extra_space) {
	      result = result.replace(/ $/, '');
	    }
	    return result;
	  };
	  exports.smartquotes = SmartQuotes;
	  var SmartDashes = function (text, attr) {
	    if (text === void 0) { text = ''; }
	    if (attr === void 0) { attr = '1'; }
	    // reference to the subroutine to use for dash education, default to EducateDashes:
	    var dash_sub_ref = EducateDashes;
	    if (typeof attr === 'number') {
	      attr = attr.toString();
	    }
	    else {
	      attr = attr.replace(/\s/g, '');
	    }
	    if (attr === '0') {
	      // Do nothing
	      return text;
	    }
	    else if (attr === '2') {
	      // use old smart dash shortcuts, "--" for en, "---" for em
	      dash_sub_ref = EducateDashesOldSchool;
	    }
	    else if (attr === '3') {
	      // inverse of 2, "--" for em, "---" for en
	      dash_sub_ref = EducateDashesOldSchoolInverted;
	    }
	    var tokens = _tokenize(text);
	    var result = '';
	    /**
	     * Keep track of when we're inside <pre> or <code> tags.
	     */
	    var in_pre = 0;
	    for (var i = 0; i < tokens.length; i++) {
	      var cur_token = tokens[i];
	      if (cur_token[0] === 'tag') {
	        result = result + cur_token[1];
	        var matched = tags_to_skip.exec(cur_token[1]);
	        if (matched) {
	          if (matched[1] === '/') {
	            in_pre = 0;
	          }
	          else {
	            in_pre = 1;
	          }
	        }
	      }
	      else {
	        var t = cur_token[1];
	        if (!in_pre) {
	          t = ProcessEscapes(t);
	          t = dash_sub_ref(t);
	        }
	        result = result + t;
	      }
	    }
	    return result;
	  };
	  exports.smartdashes = SmartDashes;
	  var SmartEllipses = function (text, attr) {
	    if (text === void 0) { text = ''; }
	    if (attr === void 0) { attr = '1'; }
	    if (typeof attr === 'number') {
	      attr = attr.toString();
	    }
	    else {
	      attr = attr.replace(/\s/g, '');
	    }
	    if (attr === '0') {
	      // Do nothing
	      return text;
	    }
	    var tokens = _tokenize(text);
	    var result = '';
	    /**
	     * Keep track of when we're inside <pre> or <code> tags.
	     */
	    var in_pre = 0;
	    for (var i = 0; i < tokens.length; i++) {
	      var cur_token = tokens[i];
	      if (cur_token[0] === 'tag') {
	        result = result + cur_token[1];
	        var matched = tags_to_skip.exec(cur_token[1]);
	        if (matched) {
	          if (matched[1] === '/') {
	            in_pre = 0;
	          }
	          else {
	            in_pre = 1;
	          }
	        }
	      }
	      else {
	        var t = cur_token[1];
	        if (!in_pre) {
	          t = ProcessEscapes(t);
	          t = EducateEllipses(t);
	        }
	        result = result + t;
	      }
	    }
	    return result;
	  };
	  exports.smartellipses = SmartEllipses;
	  /**
	   * @param {string} str String
	   * @return {string} The string, with "educated" curly quote HTML entities.
	   *
	   * Example input:  "Isn't this fun?"
	   * Example output: &#8220;Isn&#8217;t this fun?&#8221;
	   */
	  var EducateQuotes = function (str) {
	    /**
	     * Make our own "punctuation" character class, because the POSIX-style
	     * [:PUNCT:] is only available in Perl 5.6 or later:
	     *
	     * JavaScript don't have punctuation class neither.
	     */
	    var punct_class = '[!"#\$\%\'()*+,-./:;<=>?\@\[\\\]\^_`{|}~]';
	    /**
	     * Special case if the very first character is a quote
	     * followed by punctuation at a non-word-break. Close the quotes by brute force:
	     */
	    str = str.replace(new RegExp("^'(?=" + punct_class + "B)"), '&#8217;');
	    str = str.replace(new RegExp("^\"(?=" + punct_class + "B)"), '&#8221;');
	    /**
	     * Special case for double sets of quotes, e.g.:
	     *   <p>He said, "'Quoted' words in a larger quote."</p>
	     */
	    str = str.replace(/"'(?=\w)/, '&#8220;&#8216;');
	    str = str.replace(/'"(?=\w)/, '&#8216;&#8220;');
	    /**
	     * Special case for decade abbreviations (the '80s):
	     */
	    str = str.replace(/'(?=\d\d)/, '&#8217;');
	    var close_class = '[^\ \t\r\n\[\{\(\-]';
	    var dec_dashes = '&#8211;|&#8212;';
	    /**
	     * Get most opening single quotes:
	     * s {
	     *     (
	     *         \s          |   # a whitespace char, or
	     *         &nbsp;      |   # a non-breaking space entity, or
	     *         --          |   # dashes, or
	     *         &[mn]dash;  |   # named dash entities
	     *         $dec_dashes |   # or decimal entities
	     *         &\#x201[34];    # or hex
	     *     )
	     *     '                   # the quote
	     *     (?=\w)              # followed by a word character
	     * } {$1&#8216;}xg;
	     */
	    str = str.replace(new RegExp("(s|&nbsp;|--|&[mn]dash;|" + dec_dashes + "|&#x201[34])'(?=w)", 'g'), '\$1&#8216;');
	    /**
	     * Single closing quotes:
	     * s {
	     *     ($close_class)?
	     *     '
	     *     (?(1)|          # If $1 captured, then do nothing;
	     *       (?=\s | s\b)  # otherwise, positive lookahead for a whitespace
	     *     )               # char or an 's' at a word ending position. This
	     *                     # is a special case to handle something like:
	     *                     # "<i>Custer</i>'s Last Stand."
	     * } {$1&#8217;}xgi;
	     */
	    str = str.replace(new RegExp("(" + close_class + ")'", 'g'), '\$1&#8217;');
	    str = str.replace(new RegExp("'(?=s|s\b)", 'g'), '\$1&#8217;');
	    /**
	     * Any remaining single quotes should be opening ones:
	     */
	    str = str.replace(/'/g, '&#8216;');
	    /**
	     * Get most opening double quotes:
	     * s {
	     *     (
	     *         \s          |   # a whitespace char, or
	     *         &nbsp;      |   # a non-breaking space entity, or
	     *         --          |   # dashes, or
	     *         &[mn]dash;  |   # named dash entities
	     *         $dec_dashes |   # or decimal entities
	     *         &\#x201[34];    # or hex
	     *     )
	     *     "                   # the quote
	     *     (?=\w)              # followed by a word character
	     * } {$1&#8220;}xg;
	     */
	    str = str.replace(new RegExp("(s|&nbsp;|--|&[mn]dash;|" + dec_dashes + "|&#x201[34])\"(?=w)", 'g'), '\$1&#8220;');
	    /**
	     * Double closing quotes:
	     * s {
	     *     ($close_class)?
	     *     "
	     *     (?(1)|(?=\s))   # If $1 captured, then do nothing;
	     *                        # if not, then make sure the next char is whitespace.
	     * } {$1&#8221;}xg;
	     */
	    str = str.replace(new RegExp("(" + close_class + ")\"", 'g'), '\$1&#8221;');
	    str = str.replace(new RegExp("'(?=s)", 'g'), '\$1&#8221;');
	    /**
	     * Any remaining quotes should be opening ones.
	     */
	    str = str.replace(/"/g, '&#8220;');
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with ``backticks'' -style double quotes
	   *                  translated into HTML curly quote entities.
	   *
	   * Example input:  ``Isn't this fun?''
	   * Example output: &#8220;Isn't this fun?&#8221;
	   */
	  var EducateBackticks = function (str) {
	    str = str.replace(/``/g, '&#8220;');
	    str = str.replace(/''/g, '&#8221;');
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with `backticks' -style single quotes
	   *                  translated into HTML curly quote entities.
	   *
	   * Example input:  `Isn't this fun?'
	   * Example output: &#8216;Isn&#8217;t this fun?&#8217;
	   */
	  var EducateSingleBackticks = function (str) {
	    str = str.replace(/`/g, '&#8216;');
	    str = str.replace(/'/g, '&#8217;');
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with each instance of "--" translated to
	   *                  an em-dash HTML entity.
	   */
	  var EducateDashes = function (str) {
	    str = str.replace(/--/g, '&#8212;');
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with each instance of "--" translated to
	   *                  an en-dash HTML entity, and each "---" translated to
	   *                  an em-dash HTML entity.
	   */
	  var EducateDashesOldSchool = function (str) {
	    str = str.replace(/---/g, '&#8212;');
	    str = str.replace(/--/g, '&#8211;');
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with each instance of "--" translated to
	   *                  an em-dash HTML entity, and each "---" translated to
	   *                  an en-dash HTML entity. Two reasons why: First, unlike the
	   *                  en- and em-dash syntax supported by
	   *                  EducateDashesOldSchool(), it's compatible with existing
	   *                  entries written before SmartyPants 1.1, back when "--" was
	   *                  only used for em-dashes.  Second, em-dashes are more
	   *                  common than en-dashes, and so it sort of makes sense that
	   *                  the shortcut should be shorter to type. (Thanks to Aaron
	   *                  Swartz for the idea.)
	   */
	  var EducateDashesOldSchoolInverted = function (str) {
	    str = str.replace(/---/g, '&#8211;');
	    str = str.replace(/--/g, '&#8212;');
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with each instance of "..." translated to
	   *                  an ellipsis HTML entity. Also converts the case where
	   *                  there are spaces between the dots.
	   *
	   * Example input:  Huh...?
	   * Example output: Huh&#8230;?
	   */
	  var EducateEllipses = function (str) {
	    str = str.replace(/\.\.\./g, '&#8230;');
	    str = str.replace(/\. \. \./g, '&#8230;');
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with each SmartyPants HTML entity translated to
	   *                  its ASCII counterpart.
	   *
	   * Example input:  &#8220;Hello &#8212; world.&#8221;
	   * Example output: "Hello -- world."
	   */
	  var StupefyEntities = function (str) {
	    str = str.replace(/&#8211;/g, '-'); // en-dash
	    str = str.replace(/&#8212;/g, '--'); // em-dash
	    str = str.replace(/&#8216;/g, '\''); // open single quote
	    str = str.replace(/&#8217;/g, '\''); // close single quote
	    str = str.replace(/&#8220;/g, '"'); // open double quote
	    str = str.replace(/&#8221;/g, '"'); // close double quote
	    str = str.replace(/&#8230;/g, '...'); // ellipsis
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with each SmartyPants HTML entity translated to
	   *                  UTF-8 characters.
	   *
	   * Example input:  “Hello &#8217; world.”
	   * Example output: "Hello — world."
	   */
	  var EducateEntities = function (text, attr) {
	    if (attr === void 0) { attr = '1'; }
	    var do_quotes;
	    var do_backticks;
	    var do_dashes;
	    var do_ellipses;
	    var do_stupefy;
	    if (typeof attr === 'number') {
	      attr = attr.toString();
	    }
	    else {
	      attr = attr.replace(/\s/g, '');
	    }
	    if (attr === '0') {
	      // Do nothing
	      return text;
	    }
	    else if (attr === '1') {
	      // Do everything, turn all options on.
	      do_quotes = 1;
	      do_backticks = 1;
	      do_dashes = 1;
	      do_ellipses = 1;
	    }
	    else if (attr === '2') {
	      // Do everything, turn all options on, use old school dash shorthand.
	      do_quotes = 1;
	      do_backticks = 1;
	      do_dashes = 3;
	      do_ellipses = 1;
	    }
	    else if (attr === '3') {
	      // Do everything, turn all options on, use inverted old school dash shorthand.
	      do_quotes = 1;
	      do_backticks = 1;
	      do_dashes = 3;
	      do_ellipses = 1;
	    }
	    else if (attr === '-1') {
	      // Special "stupefy" mode.
	      do_stupefy = 1;
	    }
	    else {
	      for (var i = 0; i < attr.length; i++) {
	        var c = attr[i];
	        if (c === 'q') {
	          do_quotes = 1;
	        }
	        if (c === 'b') {
	          do_backticks = 1;
	        }
	        if (c === 'B') {
	          do_backticks = 2;
	        }
	        if (c === 'd') {
	          do_dashes = 1;
	        }
	        if (c === 'D') {
	          do_dashes = 2;
	        }
	        if (c === 'i') {
	          do_dashes = 3;
	        }
	        if (c === 'e') {
	          do_ellipses = 1;
	        }
	      }
	    }
	    if (do_dashes) {
	      text = text.replace(/&#8211;/g, '\u2013'); // en-dash
	      text = text.replace(/&#8212;/g, '\u2014'); // em-dash
	    }
	    if (do_quotes || do_backticks) {
	      text = text.replace(/&#8216;/g, '\u2018'); // open single quote
	      text = text.replace(/&#8217;/g, '\u2019'); // close single quote
	      text = text.replace(/&#8220;/g, '\u201c'); // open double quote
	      text = text.replace(/&#8221;/g, '\u201d'); // close double quote
	    }
	    if (do_ellipses) {
	      text = text.replace(/&#8230;/g, '\u2026'); // ellipsis
	    }
	    return text;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} The string, with each SmartyPants UTF-8 chars translated to
	   *                  its ASCII counterpart.
	   *
	   * Example input:  &#8220;Hello &#8212; world.&#8221;
	   * Example output: "Hello -- world."
	   */
	  var StupifyUTF8Char = function (str) {
	    str = str.replace(/\u2013/g, '-'); // en-dash
	    str = str.replace(/\u2014/g, '--'); // em-dash
	    str = str.replace(/\u2018/g, '\''); // open single quote
	    str = str.replace(/\u2019/g, '\''); // close single quote
	    str = str.replace(/\u201c/g, '"'); // open double quote
	    str = str.replace(/\u201d/g, '"'); // close double quote
	    str = str.replace(/\u2026/g, '...'); // ellipsis
	    return str;
	  };
	  /**
	   * @param {string} str String
	   * @return {string} string, with after processing the following backslash
	   *                  escape sequences. This is useful if you want to force a "dumb"
	   *                  quote or other character to appear.
	   *
	   *                  Escape  Value
	   *                  ------  -----
	   *                  \\      &#92;
	   *                  \"      &#34;
	   *                  \'      &#39;
	   *                  \.      &#46;
	   *                  \-      &#45;
	   *                  \`      &#96;
	   *
	   */
	  var ProcessEscapes = function (str) {
	    str = str.replace(/\\\\/g, '&#92;');
	    str = str.replace(/\\"/g, '&#34;');
	    str = str.replace(/\\'/g, '&#39;');
	    str = str.replace(/\\\./g, '&#46;');
	    str = str.replace(/\\-/g, '&#45;');
	    str = str.replace(/\\`/g, '&#96;');
	    return str;
	  };
	  /**
	   * @param {string} str String containing HTML markup.
	   * @return {Array<token>} Reference to an array of the tokens comprising the input
	   *                        string. Each token is either a tag (possibly with nested,
	   *                        tags contained therein, such as <a href="<MTFoo>">, or a
	   *                        run of text between tags. Each element of the array is a
	   *                        two-element array; the first is either 'tag' or 'text';
	   *                        the second is the actual value.
	   *
	   * Based on the _tokenize() subroutine from Brad Choate's MTRegex plugin.
	   *     <http://www.bradchoate.com/past/mtregex.php>
	   */
	  var _tokenize = function (str) {
	    var pos = 0;
	    var len = str.length;
	    var tokens = [];
	    var match = /<!--[\s\S]*?-->|<\?.*?\?>|<[^>]*>/g;
	    var matched = null;
	    while (matched = match.exec(str)) {
	      if (pos < matched.index) {
	        var t_1 = ['text', str.substring(pos, matched.index)];
	        tokens.push(t_1);
	      }
	      var t = ['tag', matched.toString()];
	      tokens.push(t);
	      pos = match.lastIndex;
	    }
	    if (pos < len) {
	      var t = ['text', str.substring(pos, len)];
	      tokens.push(t);
	    }
	    return tokens;
	  };
	  var smartypantsu = function (text, attr) {
	    if (text === void 0) { text = ''; }
	    if (attr === void 0) { attr = '1'; }
	    var str = SmartyPants(text, attr);
	    if (typeof attr === 'number') {
	      attr = attr.toString();
	    }
	    else {
	      attr = attr.replace(/\s/g, '');
	    }
	    if (attr === '-1') {
	      return StupifyUTF8Char(str);
	    }
	    else {
	      return EducateEntities(str, attr);
	    }
	  };
	  exports.smartypantsu = smartypantsu;
	  exports["default"] = SmartyPants;
	
	
	}));


/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.striptags = factory();
	  }
	}(this, function () {
	
	    var STATE_OUTPUT       = 0,
	        STATE_HTML         = 1,
	        STATE_PRE_COMMENT  = 2,
	        STATE_COMMENT      = 3,
	        WHITESPACE         = /\s/,
	        ALLOWED_TAGS_REGEX = /<(\w*)>/g;
	
	    function striptags(html, allowableTags, tagReplacement) {
	        var html = html || '',
	            state = STATE_OUTPUT,
	            depth = 0,
	            output = '',
	            tagBuffer = '',
	            inQuote = false,
	            i, length, c;
	
	        if (typeof allowableTags === 'string') {
	            // Parse the string into an array of tags
	            allowableTags = parseAllowableTags(allowableTags);
	        } else if (!Array.isArray(allowableTags)) {
	            // If it is not an array, explicitly set to null
	            allowableTags = null;
	        }
	
	        for (i = 0, length = html.length; i < length; i++) {
	            c = html[i];
	
	            switch (c) {
	                case '<': {
	                    // ignore '<' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // '<' followed by a space is not a valid tag, continue
	                    if (html[i + 1] == ' ') {
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // change to STATE_HTML
	                    if (state == STATE_OUTPUT) {
	                        state = STATE_HTML;
	
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // ignore additional '<' characters when inside a tag
	                    if (state == STATE_HTML) {
	                        depth++;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '>': {
	                    // something like this is happening: '<<>>'
	                    if (depth) {
	                        depth--;
	                        break;
	                    }
	
	                    // ignore '>' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // an HTML tag was closed
	                    if (state == STATE_HTML) {
	                        inQuote = state = 0;
	
	                        if (allowableTags) {
	                            tagBuffer += '>';
	                            flushTagBuffer();
	                        }
	
	                        break;
	                    }
	
	                    // '<!' met its ending '>'
	                    if (state == STATE_PRE_COMMENT) {
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    // if last two characters were '--', then end comment
	                    if (state == STATE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '-') {
	
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                // catch both single and double quotes
	                case '"':
	                case '\'': {
	                    if (state == STATE_HTML) {
	                        if (inQuote == c) {
	                            // end quote found
	                            inQuote = false;
	                        } else if (!inQuote) {
	                            // start quote only if not already in one
	                            inQuote = c;
	                        }
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '!': {
	                    if (state == STATE_HTML &&
	                        html[i - 1] == '<') {
	
	                        // looks like we might be starting a comment
	                        state = STATE_PRE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '-': {
	                    // if the previous two characters were '!-', this is a comment
	                    if (state == STATE_PRE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '!') {
	
	                        state = STATE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case 'E':
	                case 'e': {
	                    // check for DOCTYPE, because it looks like a comment and isn't
	                    if (state == STATE_PRE_COMMENT &&
	                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {
	
	                        state = STATE_HTML;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                default: {
	                    consumeCharacter(c);
	                }
	            }
	        }
	
	        function consumeCharacter(c) {
	            if (state == STATE_OUTPUT) {
	                output += c;
	            } else if (allowableTags && state == STATE_HTML) {
	                tagBuffer += c;
	            }
	        }
	
	        function flushTagBuffer() {
	            var normalized = '',
	                nonWhitespaceSeen = false,
	                i, length, c;
	
	            normalizeTagBuffer:
	            for (i = 0, length = tagBuffer.length; i < length; i++) {
	                c = tagBuffer[i].toLowerCase();
	
	                switch (c) {
	                    case '<': {
	                        break;
	                    }
	
	                    case '>': {
	                        break normalizeTagBuffer;
	                    }
	
	                    case '/': {
	                        nonWhitespaceSeen = true;
	                        break;
	                    }
	
	                    default: {
	                        if (!c.match(WHITESPACE)) {
	                            nonWhitespaceSeen = true;
	                            normalized += c;
	                        } else if (nonWhitespaceSeen) {
	                            break normalizeTagBuffer;
	                        }
	                    }
	                }
	            }
	
	            if (allowableTags.indexOf(normalized) !== -1) {
	                output += tagBuffer;
	            } else if (tagReplacement) {
	                output += tagReplacement;
	            }
	
	            tagBuffer = '';
	        }
	
	        return output;
	    }
	
	    /**
	     * Return an array containing tags that are allowed to pass through the
	     * algorithm.
	     *
	     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
	     * @return array|null An array of allowed tags or null if none.
	     */
	    function parseAllowableTags(allowableTags) {
	        var tagsArray = [],
	            match;
	
	        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
	            tagsArray.push(match[1]);
	        }
	
	        return tagsArray.length !== 0 ? tagsArray : null;
	    }
	
	    return striptags;
	}));


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Tap listener v2.0.0
	 * listens to taps
	 * MIT license
	 */
	
	/*jshint browser: true, unused: true, undef: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /*jshint strict: false*/ /*globals define, module, require */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(278)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Unipointer ) {
	      return factory( window, Unipointer );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('unipointer')
	    );
	  } else {
	    // browser global
	    window.TapListener = factory(
	      window,
	      window.Unipointer
	    );
	  }
	
	}( window, function factory( window, Unipointer ) {
	
	'use strict';
	
	// --------------------------  TapListener -------------------------- //
	
	function TapListener( elem ) {
	  this.bindTap( elem );
	}
	
	// inherit Unipointer & EventEmitter
	var proto = TapListener.prototype = Object.create( Unipointer.prototype );
	
	/**
	 * bind tap event to element
	 * @param {Element} elem
	 */
	proto.bindTap = function( elem ) {
	  if ( !elem ) {
	    return;
	  }
	  this.unbindTap();
	  this.tapElement = elem;
	  this._bindStartEvent( elem, true );
	};
	
	proto.unbindTap = function() {
	  if ( !this.tapElement ) {
	    return;
	  }
	  this._bindStartEvent( this.tapElement, true );
	  delete this.tapElement;
	};
	
	/**
	 * pointer up
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto.pointerUp = function( event, pointer ) {
	  // ignore emulated mouse up clicks
	  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
	    return;
	  }
	
	  var pointerPoint = Unipointer.getPointerPoint( pointer );
	  var boundingRect = this.tapElement.getBoundingClientRect();
	  var scrollX = window.pageXOffset;
	  var scrollY = window.pageYOffset;
	  // calculate if pointer is inside tapElement
	  var isInside = pointerPoint.x >= boundingRect.left + scrollX &&
	    pointerPoint.x <= boundingRect.right + scrollX &&
	    pointerPoint.y >= boundingRect.top + scrollY &&
	    pointerPoint.y <= boundingRect.bottom + scrollY;
	  // trigger callback if pointer is inside element
	  if ( isInside ) {
	    this.emitEvent( 'tap', [ event, pointer ] );
	  }
	
	  // set flag for emulated clicks 300ms after touchend
	  if ( event.type != 'mouseup' ) {
	    this.isIgnoringMouseUp = true;
	    // reset flag after 300ms
	    var _this = this;
	    setTimeout( function() {
	      delete _this.isIgnoringMouseUp;
	    }, 400 );
	  }
	};
	
	proto.destroy = function() {
	  this.pointerDone();
	  this.unbindTap();
	};
	
	// -----  ----- //
	
	return TapListener;
	
	}));


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Unidragger v2.3.0
	 * Draggable base class
	 * MIT license
	 */
	
	/*jshint browser: true, unused: true, undef: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(278)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Unipointer ) {
	      return factory( window, Unipointer );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('unipointer')
	    );
	  } else {
	    // browser global
	    window.Unidragger = factory(
	      window,
	      window.Unipointer
	    );
	  }
	
	}( window, function factory( window, Unipointer ) {
	
	'use strict';
	
	// -------------------------- Unidragger -------------------------- //
	
	function Unidragger() {}
	
	// inherit Unipointer & EvEmitter
	var proto = Unidragger.prototype = Object.create( Unipointer.prototype );
	
	// ----- bind start ----- //
	
	proto.bindHandles = function() {
	  this._bindHandles( true );
	};
	
	proto.unbindHandles = function() {
	  this._bindHandles( false );
	};
	
	/**
	 * Add or remove start event
	 * @param {Boolean} isAdd
	 */
	proto._bindHandles = function( isAdd ) {
	  // munge isAdd, default to true
	  isAdd = isAdd === undefined ? true : isAdd;
	  // bind each handle
	  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
	  var touchAction = isAdd ? this._touchActionValue : '';
	  for ( var i=0; i < this.handles.length; i++ ) {
	    var handle = this.handles[i];
	    this._bindStartEvent( handle, isAdd );
	    handle[ bindMethod ]( 'click', this );
	    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
	    if ( window.PointerEvent ) {
	      handle.style.touchAction = touchAction;
	    }
	  }
	};
	
	// prototype so it can be overwriteable by Flickity
	proto._touchActionValue = 'none';
	
	// ----- start event ----- //
	
	/**
	 * pointer start
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto.pointerDown = function( event, pointer ) {
	  var isOkay = this.okayPointerDown( event );
	  if ( !isOkay ) {
	    return;
	  }
	  // track start event position
	  this.pointerDownPointer = pointer;
	
	  event.preventDefault();
	  this.pointerDownBlur();
	  // bind move and end events
	  this._bindPostStartEvents( event );
	  this.emitEvent( 'pointerDown', [ event, pointer ] );
	};
	
	// nodes that have text fields
	var cursorNodes = {
	  TEXTAREA: true,
	  INPUT: true,
	  SELECT: true,
	  OPTION: true,
	};
	
	// input types that do not have text fields
	var clickTypes = {
	  radio: true,
	  checkbox: true,
	  button: true,
	  submit: true,
	  image: true,
	  file: true,
	};
	
	// dismiss inputs with text fields. flickity#403, flickity#404
	proto.okayPointerDown = function( event ) {
	  var isCursorNode = cursorNodes[ event.target.nodeName ];
	  var isClickType = clickTypes[ event.target.type ];
	  var isOkay = !isCursorNode || isClickType;
	  if ( !isOkay ) {
	    this._pointerReset();
	  }
	  return isOkay;
	};
	
	// kludge to blur previously focused input
	proto.pointerDownBlur = function() {
	  var focused = document.activeElement;
	  // do not blur body for IE10, metafizzy/flickity#117
	  var canBlur = focused && focused.blur && focused != document.body;
	  if ( canBlur ) {
	    focused.blur();
	  }
	};
	
	// ----- move event ----- //
	
	/**
	 * drag move
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto.pointerMove = function( event, pointer ) {
	  var moveVector = this._dragPointerMove( event, pointer );
	  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
	  this._dragMove( event, pointer, moveVector );
	};
	
	// base pointer move logic
	proto._dragPointerMove = function( event, pointer ) {
	  var moveVector = {
	    x: pointer.pageX - this.pointerDownPointer.pageX,
	    y: pointer.pageY - this.pointerDownPointer.pageY
	  };
	  // start drag if pointer has moved far enough to start drag
	  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
	    this._dragStart( event, pointer );
	  }
	  return moveVector;
	};
	
	// condition if pointer has moved far enough to start drag
	proto.hasDragStarted = function( moveVector ) {
	  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
	};
	
	// ----- end event ----- //
	
	/**
	 * pointer up
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto.pointerUp = function( event, pointer ) {
	  this.emitEvent( 'pointerUp', [ event, pointer ] );
	  this._dragPointerUp( event, pointer );
	};
	
	proto._dragPointerUp = function( event, pointer ) {
	  if ( this.isDragging ) {
	    this._dragEnd( event, pointer );
	  } else {
	    // pointer didn't move enough for drag to start
	    this._staticClick( event, pointer );
	  }
	};
	
	// -------------------------- drag -------------------------- //
	
	// dragStart
	proto._dragStart = function( event, pointer ) {
	  this.isDragging = true;
	  // prevent clicks
	  this.isPreventingClicks = true;
	  this.dragStart( event, pointer );
	};
	
	proto.dragStart = function( event, pointer ) {
	  this.emitEvent( 'dragStart', [ event, pointer ] );
	};
	
	// dragMove
	proto._dragMove = function( event, pointer, moveVector ) {
	  // do not drag if not dragging yet
	  if ( !this.isDragging ) {
	    return;
	  }
	
	  this.dragMove( event, pointer, moveVector );
	};
	
	proto.dragMove = function( event, pointer, moveVector ) {
	  event.preventDefault();
	  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
	};
	
	// dragEnd
	proto._dragEnd = function( event, pointer ) {
	  // set flags
	  this.isDragging = false;
	  // re-enable clicking async
	  setTimeout( function() {
	    delete this.isPreventingClicks;
	  }.bind( this ) );
	
	  this.dragEnd( event, pointer );
	};
	
	proto.dragEnd = function( event, pointer ) {
	  this.emitEvent( 'dragEnd', [ event, pointer ] );
	};
	
	// ----- onclick ----- //
	
	// handle all clicks and prevent clicks when dragging
	proto.onclick = function( event ) {
	  if ( this.isPreventingClicks ) {
	    event.preventDefault();
	  }
	};
	
	// ----- staticClick ----- //
	
	// triggered after pointer down & up with no/tiny movement
	proto._staticClick = function( event, pointer ) {
	  // ignore emulated mouse up clicks
	  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
	    return;
	  }
	
	  this.staticClick( event, pointer );
	
	  // set flag for emulated clicks 300ms after touchend
	  if ( event.type != 'mouseup' ) {
	    this.isIgnoringMouseUp = true;
	    // reset flag after 300ms
	    setTimeout( function() {
	      delete this.isIgnoringMouseUp;
	    }.bind( this ), 400 );
	  }
	};
	
	proto.staticClick = function( event, pointer ) {
	  this.emitEvent( 'staticClick', [ event, pointer ] );
	};
	
	// ----- utils ----- //
	
	Unidragger.getPointerPoint = Unipointer.getPointerPoint;
	
	// -----  ----- //
	
	return Unidragger;
	
	}));


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Unipointer v2.3.0
	 * base class for doing one thing with pointer event
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /*global define, module, require */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(94)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
	      return factory( window, EvEmitter );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('ev-emitter')
	    );
	  } else {
	    // browser global
	    window.Unipointer = factory(
	      window,
	      window.EvEmitter
	    );
	  }
	
	}( window, function factory( window, EvEmitter ) {
	
	'use strict';
	
	function noop() {}
	
	function Unipointer() {}
	
	// inherit EvEmitter
	var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );
	
	proto.bindStartEvent = function( elem ) {
	  this._bindStartEvent( elem, true );
	};
	
	proto.unbindStartEvent = function( elem ) {
	  this._bindStartEvent( elem, false );
	};
	
	/**
	 * Add or remove start event
	 * @param {Boolean} isAdd - remove if falsey
	 */
	proto._bindStartEvent = function( elem, isAdd ) {
	  // munge isAdd, default to true
	  isAdd = isAdd === undefined ? true : isAdd;
	  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
	
	  // default to mouse events
	  var startEvent = 'mousedown';
	  if ( window.PointerEvent ) {
	    // Pointer Events
	    startEvent = 'pointerdown';
	  } else if ( 'ontouchstart' in window ) {
	    // Touch Events. iOS Safari
	    startEvent = 'touchstart';
	  }
	  elem[ bindMethod ]( startEvent, this );
	};
	
	// trigger handler methods for events
	proto.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	// returns the touch that we're keeping track of
	proto.getTouch = function( touches ) {
	  for ( var i=0; i < touches.length; i++ ) {
	    var touch = touches[i];
	    if ( touch.identifier == this.pointerIdentifier ) {
	      return touch;
	    }
	  }
	};
	
	// ----- start event ----- //
	
	proto.onmousedown = function( event ) {
	  // dismiss clicks from right or middle buttons
	  var button = event.button;
	  if ( button && ( button !== 0 && button !== 1 ) ) {
	    return;
	  }
	  this._pointerDown( event, event );
	};
	
	proto.ontouchstart = function( event ) {
	  this._pointerDown( event, event.changedTouches[0] );
	};
	
	proto.onpointerdown = function( event ) {
	  this._pointerDown( event, event );
	};
	
	/**
	 * pointer start
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 */
	proto._pointerDown = function( event, pointer ) {
	  // dismiss right click and other pointers
	  // button = 0 is okay, 1-4 not
	  if ( event.button || this.isPointerDown ) {
	    return;
	  }
	
	  this.isPointerDown = true;
	  // save pointer identifier to match up touch events
	  this.pointerIdentifier = pointer.pointerId !== undefined ?
	    // pointerId for pointer events, touch.indentifier for touch events
	    pointer.pointerId : pointer.identifier;
	
	  this.pointerDown( event, pointer );
	};
	
	proto.pointerDown = function( event, pointer ) {
	  this._bindPostStartEvents( event );
	  this.emitEvent( 'pointerDown', [ event, pointer ] );
	};
	
	// hash of events to be bound after start event
	var postStartEvents = {
	  mousedown: [ 'mousemove', 'mouseup' ],
	  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
	  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
	};
	
	proto._bindPostStartEvents = function( event ) {
	  if ( !event ) {
	    return;
	  }
	  // get proper events to match start event
	  var events = postStartEvents[ event.type ];
	  // bind events to node
	  events.forEach( function( eventName ) {
	    window.addEventListener( eventName, this );
	  }, this );
	  // save these arguments
	  this._boundPointerEvents = events;
	};
	
	proto._unbindPostStartEvents = function() {
	  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
	  if ( !this._boundPointerEvents ) {
	    return;
	  }
	  this._boundPointerEvents.forEach( function( eventName ) {
	    window.removeEventListener( eventName, this );
	  }, this );
	
	  delete this._boundPointerEvents;
	};
	
	// ----- move event ----- //
	
	proto.onmousemove = function( event ) {
	  this._pointerMove( event, event );
	};
	
	proto.onpointermove = function( event ) {
	  if ( event.pointerId == this.pointerIdentifier ) {
	    this._pointerMove( event, event );
	  }
	};
	
	proto.ontouchmove = function( event ) {
	  var touch = this.getTouch( event.changedTouches );
	  if ( touch ) {
	    this._pointerMove( event, touch );
	  }
	};
	
	/**
	 * pointer move
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 * @private
	 */
	proto._pointerMove = function( event, pointer ) {
	  this.pointerMove( event, pointer );
	};
	
	// public
	proto.pointerMove = function( event, pointer ) {
	  this.emitEvent( 'pointerMove', [ event, pointer ] );
	};
	
	// ----- end event ----- //
	
	
	proto.onmouseup = function( event ) {
	  this._pointerUp( event, event );
	};
	
	proto.onpointerup = function( event ) {
	  if ( event.pointerId == this.pointerIdentifier ) {
	    this._pointerUp( event, event );
	  }
	};
	
	proto.ontouchend = function( event ) {
	  var touch = this.getTouch( event.changedTouches );
	  if ( touch ) {
	    this._pointerUp( event, touch );
	  }
	};
	
	/**
	 * pointer up
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 * @private
	 */
	proto._pointerUp = function( event, pointer ) {
	  this._pointerDone();
	  this.pointerUp( event, pointer );
	};
	
	// public
	proto.pointerUp = function( event, pointer ) {
	  this.emitEvent( 'pointerUp', [ event, pointer ] );
	};
	
	// ----- pointer done ----- //
	
	// triggered on pointer up & pointer cancel
	proto._pointerDone = function() {
	  this._pointerReset();
	  this._unbindPostStartEvents();
	  this.pointerDone();
	};
	
	proto._pointerReset = function() {
	  // reset properties
	  this.isPointerDown = false;
	  delete this.pointerIdentifier;
	};
	
	proto.pointerDone = noop;
	
	// ----- pointer cancel ----- //
	
	proto.onpointercancel = function( event ) {
	  if ( event.pointerId == this.pointerIdentifier ) {
	    this._pointerCancel( event, event );
	  }
	};
	
	proto.ontouchcancel = function( event ) {
	  var touch = this.getTouch( event.changedTouches );
	  if ( touch ) {
	    this._pointerCancel( event, touch );
	  }
	};
	
	/**
	 * pointer cancel
	 * @param {Event} event
	 * @param {Event or Touch} pointer
	 * @private
	 */
	proto._pointerCancel = function( event, pointer ) {
	  this._pointerDone();
	  this.pointerCancel( event, pointer );
	};
	
	// public
	proto.pointerCancel = function( event, pointer ) {
	  this.emitEvent( 'pointerCancel', [ event, pointer ] );
	};
	
	// -----  ----- //
	
	// utility function for getting x/y coords from event
	Unipointer.getPointerPoint = function( pointer ) {
	  return {
	    x: pointer.pageX,
	    y: pointer.pageY
	  };
	};
	
	// -----  ----- //
	
	return Unipointer;
	
	}));


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-check-16px",
	  "use": "shape-check-16px-usage",
	  "viewBox": "0 0 16 16",
	  "content": "<symbol viewBox=\"0 0 16 16\" fill-rule=\"evenodd\" id=\"shape-check-16px\"><path d=\"M6.45 10.13L3.694 7.374l-1.42 1.41L6.45 12.96l7.05-7.05-1.41-1.41-5.64 5.63z\" fill-rule=\"nonzero\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-eye",
	  "use": "shape-eye-usage",
	  "viewBox": "0 0 16 16",
	  "content": "<symbol viewBox=\"0 0 16 16\" id=\"shape-eye\"><path d=\"M8 10.571c-1.406 0-2.545-1.15-2.545-2.571 0-1.421 1.139-2.571 2.545-2.571S10.545 6.579 10.545 8c0 1.421-1.139 2.571-2.545 2.571M8 3.5C3.958 3.5 1 8 1 8s2.958 4.5 7 4.5S15 8 15 8s-2.958-4.5-7-4.5z\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h160v160H0z"
	});
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill2",
	  d: "M85.998 114h-9a2 2 0 1 1 0-4h9c1.1 0 2 .9 2 2s-.9 2-2 2m0 8h-4a2 2 0 1 1 0-4h4c1.1 0 2 .9 2 2s-.9 2-2 2m0 7.63h-13.69a2 2 0 1 1 0-4h13.69a2 2 0 1 1 0 4m-25-7.63a2 2 0 1 1 0-4h8c1.1 0 2 .9 2 2s-.9 2-2 2h-8zm-5-35c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2s-.9 2-2 2h-8c-1.1 0-2-.9-2-2m-1.32 9.63h-13.68a2 2 0 1 1 0-4h13.68a2 2 0 0 1 2 2c0 1.11-.89 2-2 2M40.998 85h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4c-1.1 0-2-.9-2-2s.9-2 2-2m0-8h9c1.1 0 2 .9 2 2s-.9 2-2 2h-9c-1.1 0-2-.9-2-2s.9-2 2-2m13 10c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2m1.84-10h3.16c1.1 0 2 .9 2 2s-.9 2-2 2h-3.16a2 2 0 1 1 0-4m5.16-25h8c1.1 0 2 .9 2 2s-.9 2-2 2h-8a2 2 0 1 1 0-4m7-8h3.16a2 2 0 1 1 0 4h-3.16a2 2 0 1 1 0-4m7 8h1c1.1 0 2 .9 2 2s-.9 2-2 2h-1a2 2 0 1 1 0-4m2-8h9c1.1 0 2 .9 2 2s-.9 2-2 2h-9a2 2 0 1 1 0-4m9 12h-4a2 2 0 1 1 0-4h4c1.1 0 2 .9 2 2s-.9 2-2 2m-14.84 58h-3.16a2 2 0 1 1 0-4h3.16a2 2 0 1 1 0 4m3.84 4h1c1.1 0 2 .9 2 2s-.9 2-2 2h-1a2 2 0 1 1 0-4m11-54.37h-13.69a2 2 0 1 1 0-4h13.69a2 2 0 1 1 0 4m12.85 67.09c7.46-16.16-2.99-35.13-20.68-37.48.54-2.11.83-4.33.83-6.61 0-2.27-.28-4.47-.82-6.57 2.5-.27 9.85-1.57 11.44-3.02l11.49 5.75c.7.35 1.55.26 2.19-.27a2 2 0 0 0 .6-2.13l-5.05-15.67c.36-.78.68-1.58.96-2.39.96-2.8 1.45-5.72 1.45-8.7 0-14.68-11.94-26.63-26.63-26.63-14.68 0-26.63 11.95-26.63 26.63 0 2.28.29 4.5.83 6.61-13.02 1.73-23.09 12.91-23.09 26.39 0 3.95.87 7.76 2.41 11.09l-5.05 15.67a2 2 0 0 0 .6 2.13c.37.31.83.48 1.3.48.3 0 .61-.07.89-.21l11.49-5.75c.12.11.26.2.41.28 2.74 1.36 7.21 2.33 11.03 2.74-4.3 16.7 8.41 33.2 25.81 33.2 4.9 0 13.38-1.75 14.99-3.22l11.49 5.75c.28.14.59.21.89.21.47 0 .93-.17 1.3-.48a2 2 0 0 0 .6-2.13l-5.05-15.67z",
	  fill: "#0dcaf2",
	  fillOpacity: 0.5,
	  fillRule: "nonzero"
	});
	
	var _ref3 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill1",
	  d: "M143.32 98.57C141.36 105.179 135.25 110 128 110s-13.36-4.821-15.32-11.43a2.006 2.006 0 0 1 .31-1.771c.38-.5.97-.799 1.6-.799h26.82c.63 0 1.22.299 1.6.799.38.51.49 1.17.31 1.771m-29.37-14.36c1.45-2.76 4.34-4.29 7.28-4.21.46.019.89.24 1.16.61.27.37.37.84.25 1.279-.18.66-.77 1.111-1.45 1.111h-.04c-1.84-.05-3.64.92-4.55 2.62-.33.62-1.04.92-1.71.74h-.01c-.44-.12-.8-.431-.98-.851a1.45 1.45 0 0 1 .05-1.299M124 88.259v2c0 1.651-1.34 3-3 3s-3-1.349-3-3v-2c0-1.66 1.34-3 3-3s3 1.34 3 3m8 0c0-1.66 1.34-3 3-3s3 1.34 3 3v2c0 1.651-1.34 3-3 3s-3-1.349-3-3v-2zm1.78-7.529c.27-.37.7-.591 1.16-.6a8.028 8.028 0 0 1 7.31 4.259c.2.391.22.861.04 1.261-.17.409-.52.71-.95.819l-.06.021c-.67.18-1.38-.13-1.71-.74a4.998 4.998 0 0 0-4.54-2.62c-.7.02-1.32-.44-1.5-1.111-.11-.449-.02-.92.25-1.289M128 70c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24-10.75-24-24-24",
	  fill: "#cc339f",
	  fillOpacity: 0.5,
	  fillRule: "nonzero"
	});
	
	var _ref4 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M90.85 122.72c7.462-16.164-2.989-35.129-20.68-37.48.54-2.11.83-4.33.83-6.61 0-2.269-.28-4.47-.82-6.57 2.507-.269 9.853-1.566 11.44-3.02l11.49 5.75a1.999 1.999 0 0 0 2.19-.27 2 2 0 0 0 .6-2.13l-5.05-15.67c.36-.779.68-1.58.96-2.39a26.728 26.728 0 0 0 1.45-8.7C93.26 30.95 81.32 19 66.63 19 51.95 19 40 30.95 40 45.63c0 2.28.29 4.5.83 6.61-13.02 1.73-23.09 12.911-23.09 26.39 0 3.949.871 7.757 2.41 11.09l-5.05 15.67a2 2 0 0 0 .6 2.13c.37.31.83.48 1.3.48.3 0 .61-.07.89-.21l11.49-5.75c.12.111.26.2.41.281 2.74 1.359 7.21 2.33 11.03 2.739-4.296 16.705 8.413 33.2 25.81 33.2 4.906 0 13.381-1.745 14.99-3.22l11.49 5.75c.28.14.59.21.89.21.47 0 .93-.17 1.3-.48a2 2 0 0 0 .6-2.13l-5.05-15.67zM73 126.26c-2.427-1.172-4.109 2.433-1.79 3.58l5.7 2.851c-22.293 6.708-36.931-10.807-31.99-27.441 10.73-.21 19.92-6.809 23.92-16.139 15.724 1.524 25.12 18.481 18.07 32.58-.629 1.285.008 1.248 3.72 13.389L73 126.26zm5-8.628a2 2 0 0 1 0 4H64.316a2 2 0 0 1 0-4H78zM68 110a2 2 0 0 1 0 4h-1a2 2 0 0 1 0-4h1zm10 0a2 2 0 0 1 0 4h-4a2 2 0 0 1 0-4h4zm-17 0a2 2 0 0 1 0 4h-8a2 2 0 0 1 0-4h8zm2.165-8a2 2 0 0 1 0 4H60a2 2 0 0 1 0-4h3.165zM78 102a2 2 0 0 1 0 4h-9a2 2 0 0 1 0-4h9zm-43.91-2.309l5.7-2.851c.99-.49 1.39-1.689.89-2.68-.35-.7-1.05-1.11-1.79-1.11-.874 0-.229-.035-18.52 9.03l3.83-11.889c.634-1.942-2.46-3.738-2.46-11.561C21.74 66.095 31.946 56 44.37 56 56.894 56 67 66.21 67 78.63c0 13.886-12.736 27.12-32.91 21.061zM46.68 88.63H33a2 2 0 1 1 0-4h13.68a2 2 0 0 1 2 2c0 1.11-.89 2-2 2zM44 81h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2s-.9 2-2 2zm-7 0h-4c-1.1 0-2-.9-2-2s.9-2 2-2h4c1.1 0 2 .9 2 2s-.9 2-2 2zm21 0h-8c-1.1 0-2-.9-2-2s.9-2 2-2h8c1.1 0 2 .9 2 2s-.9 2-2 2zm-7-8h-3.16a2 2 0 1 1 0-4H51c1.1 0 2 .9 2 2s-.9 2-2 2zm-9 0h-9c-1.1 0-2-.9-2-2s.9-2 2-2h9c1.1 0 2 .9 2 2s-.9 2-2 2zm24.63-50c12.48 0 22.63 10.151 22.63 22.63 0 2.53-.41 5.021-1.23 7.39-1.868 5.483-2.347-.121 2.6 16.06-18.357-9.097-17.663-9.03-18.52-9.03-2.093 0-2.788 2.856-.9 3.79l5.7 2.851c-2.43.729-5.5 1.259-8.06 1.469-4-9.33-13.2-15.94-23.93-16.15-.6-2.02-.92-4.16-.92-6.38C44 33.151 54.15 23 66.63 23zM78 51.632a2 2 0 0 1 0 4H64.316a2 2 0 0 1 0-4H78zM68 44a2 2 0 0 1 0 4h-1a2 2 0 0 1 0-4h1zm10 0a2 2 0 0 1 0 4h-4a2 2 0 0 1 0-4h4zm-17 0a2 2 0 0 1 0 4h-8a2 2 0 0 1 0-4h8zm17-8a2 2 0 0 1 0 4h-9a2 2 0 0 1 0-4h9zm-14.835 0a2 2 0 0 1 0 4H60a2 2 0 0 1 0-4h3.165z",
	  fillRule: "nonzero"
	});
	
	var _ref5 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M120 62c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 4c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20zm13.405 22a2 2 0 0 1 1.918 2.57C133.357 97.179 127.247 102 120 102s-13.357-4.821-15.323-11.43a1.998 1.998 0 0 1 .315-1.765 1.996 1.996 0 0 1 1.603-.805h26.81zm-3.021 4h-20.768c2.122 3.688 6.05 6 10.384 6 4.334 0 8.262-2.312 10.384-6zM113 85.257a3 3 0 0 1-3-3v-2a3 3 0 1 1 6 0v2a3 3 0 0 1-3 3zm14 0a3 3 0 0 1-3-3v-2a3 3 0 1 1 6 0v2a3 3 0 0 1-3 3zm-1.466-11.241a1.499 1.499 0 0 1 1.405-1.889 8.017 8.017 0 0 1 7.274 4.201 1.5 1.5 0 0 1-.932 2.162 1.5 1.5 0 0 1-1.708-.739 5.014 5.014 0 0 0-4.546-2.624 1.5 1.5 0 0 1-1.493-1.109v-.002zm-18.651 4.345a1.498 1.498 0 0 1-.937-2.151c1.458-2.755 4.343-4.289 7.283-4.205a1.499 1.499 0 0 1 1.408 1.887l-.001.002a1.5 1.5 0 0 1-1.489 1.111c-1.837-.05-3.638.918-4.549 2.618a1.499 1.499 0 0 1-1.709.74l-.006-.002z",
	  fillRule: "nonzero"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 160 160",
	    fillRule: "evenodd",
	    clipRule: "evenodd"
	  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h160v160H0z"
	});
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill2",
	  d: "M48 128a8 8 0 0 1-8 8H24a8 8 0 0 1-8-8h32zm112-6v6a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-6h48zM48 100v24H16v-24h32zm112-16v34h-48V84h48zM48 96a8 8 0 0 0-8-8H24a8 8 0 0 0-8 8h32zm112-16a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8h48z",
	  fillOpacity: 0.5
	});
	
	var _ref3 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill1",
	  d: "M96 132c0-3.183-1.264-6.235-3.515-8.485A11.996 11.996 0 0 0 84 120h-8a11.996 11.996 0 0 0-8.485 3.515A11.996 11.996 0 0 0 64 132v4h32v-4zm32-36v8a8 8 0 0 1-8 8H40a8 8 0 0 1-8-8v-8h96zm0-40v36H32V56h96zm0-8a8 8 0 0 0-8-8H40a8 8 0 0 0-8 8v4h96v-4z",
	  fillOpacity: 0.5
	});
	
	var _ref4 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M104 100v4H78v8.168A11.996 11.996 0 0 1 88 124v4H56v-4a11.996 11.996 0 0 1 10-11.832V104H40v-4h64zm-20 24a8 8 0 0 0-8-8h-8.002A7.998 7.998 0 0 0 60 123.998V124h24zm-10-20h-4v8h4v-8zm-2-14c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4zm32-2H40c0-1.457-.39-2.823-1.072-4H104v4zm-76-8h-4V40c0-4.415 3.584-8 8-8h80c4.416 0 8 3.585 8 8v24h-4V48H28v32zm3.586-3.586a2 2 0 0 1 0-2.828l15-15a2 2 0 1 1 2.828 2.828l-15 15a2 2 0 0 1-2.828 0zm0-10a2 2 0 0 1 0-2.828l2-2a2 2 0 1 1 2.828 2.828l-2 2a2 2 0 0 1-2.828 0zm7-7a2 2 0 0 1 0-2.828l5-5a2 2 0 1 1 2.828 2.828l-5 5a2 2 0 0 1-2.828 0zm-7-2a2 2 0 0 1 0-2.828l3-3a2 2 0 1 1 2.828 2.828l-3 3a2 2 0 0 1-2.828 0zm20-1a2 2 0 0 1 0-2.828l2-2a2 2 0 1 1 2.828 2.828l-2 2a2 2 0 0 1-2.828 0zM112 36H32a4.002 4.002 0 0 0-4 4v4h88v-4a4.002 4.002 0 0 0-4-4zm-36 6h-8a2 2 0 0 1 0-4h8a2 2 0 0 1 0 4z"
	});
	
	var _ref5 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M144 128h-32c-4.415 0-8-3.585-8-8V72c0-4.415 3.584-8 8-8h32c4.416 0 8 3.585 8 8v48c0 4.415-3.585 8-8 8zm4-14h-40v6c0 2.208 1.792 4 4 4h32c2.208 0 4-1.792 4-4v-6zm-20 1c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4zm20-39h-40v34h40V76zm-37.414 27.414a2 2 0 0 1 0-2.828l15-15a2 2 0 1 1 2.828 2.828l-15 15a2 2 0 0 1-2.828 0zm0-10a2 2 0 0 1 0-2.828l2-2a2 2 0 1 1 2.828 2.828l-2 2a2 2 0 0 1-2.828 0zm7-7a2 2 0 0 1 0-2.828l5-5a2 2 0 1 1 2.828 2.828l-5 5a2 2 0 0 1-2.828 0zm-7-2a2 2 0 0 1 0-2.828l3-3a2 2 0 1 1 2.828 2.828l-3 3a2 2 0 0 1-2.828 0zm20-1a2 2 0 0 1 0-2.828l2-2a2 2 0 1 1 2.828 2.828l-2 2a2 2 0 0 1-2.828 0zM144 68h-32c-2.208 0-4 1.792-4 4h40c0-2.208-1.792-4-4-4zm-14 3h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2zM32 128H16c-4.416 0-8-3.585-8-8V88c0-4.416 3.584-8 8-8h16c4.415 0 8 3.584 8 8v32c0 4.415-3.585 8-8 8m4-8H12c0 2.208 1.792 4 4 4h16c2.208 0 4-1.792 4-4m-10 3h-4a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2m-14-7h24V92H12v24zm11.707-16.707a.999.999 0 0 0-1.414 0l-8 8a.999.999 0 1 0 1.414 1.414l8-8a.999.999 0 0 0 0-1.414m-8 4.414l1-1a.999.999 0 1 0-1.414-1.414l-1 1a.999.999 0 1 0 1.414 1.414m6.586-9.414l-4 4a.999.999 0 1 0 1.414 1.414l4-4a.999.999 0 1 0-1.414-1.414m-6.586 4.414l3-3a.999.999 0 1 0-1.414-1.414l-3 3a.999.999 0 1 0 1.414 1.414m13-4.414a.999.999 0 0 0-1.414 0l-2 2a.999.999 0 1 0 1.414 1.414l2-2a.997.997 0 0 0 0-1.414M32 84H16c-2.208 0-4 1.792-4 4h24c0-2.208-1.792-4-4-4m-6 3h-4a1 1 0 0 1 0-2h4a1 1 0 1 1 0 2"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 160 160"
	  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h160v160H0z"
	});
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill2",
	  d: "M136 46a2 2 0 0 1 2 2v32a2 2 0 0 1-2 2h-32a2 2 0 0 1-2-2V48a2 2 0 0 1 2-2h32zm-8 8h-16c-1.097 0-2 .903-2 2v4c0 1.097.903 2 2 2s2-.903 2-2v-2h4v12h-2c-1.097 0-2 .903-2 2s.903 2 2 2h8c1.097 0 2-.903 2-2s-.903-2-2-2h-2V58h4v2c0 1.097.903 2 2 2s2-.903 2-2v-4c0-1.097-.903-2-2-2z",
	  fillOpacity: 0.5
	});
	
	var _ref3 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill1",
	  d: "M113.267 123.97c-7.352 0-6.567-9.97-.252-9.97h9v1c0 5.819-4.775 8.97-8.748 8.97m14.748-.97a2 2 0 0 1-2-2v-13c0-4.775-3.774-10-10-10h-.002c-5.024 0-8.755 3.96-8.755 5.734 0 1.485 1.297 1.998 1.997 1.998 2.309 0 2.077-3.732 6.758-3.732 3.286 0 6.002 2.653 6.002 6v2h-9a9 9 0 0 0-9 9c0 8.896 11.133 12.255 18.195 5.175 1.13 3.652 5.19 2.686 5.805 2.825 2.646 0 2.648-4 0-4",
	  fillOpacity: 0.5
	});
	
	var _ref4 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill1",
	  d: "M93.811 91.43H56v18.97h16.21c-1.889 2.79-5.489 5.8-12.21 5.8-8.73 0-15.839-7.27-15.839-16.2S51.27 83.8 60 83.8c7.675 0 10.537 4.622 12.771 6.48L87.26 76.32C85.417 75.063 77.208 64 60 64c-19.849 0-36 16.15-36 36s16.151 36 36 36c23.38 0 38.68-18.97 33.811-44.57",
	  fillOpacity: 0.5,
	  fillRule: "nonzero"
	});
	
	var _ref5 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M52 124c-17.691 0-32-14.308-32-32s14.309-32 32-32c8.641 0 15.864 3.16 21.44 8.364l-8.679 8.368C62.376 74.44 58.216 71.8 52 71.8c-10.92 0-19.84 9.04-19.84 20.2s8.92 20.2 19.84 20.2c12.668 0 17.416-9.092 18.148-13.8H52V87.428h30.379C84.963 108.452 72.208 124 52 124m33.806-40.572H48V102.4h16.211c-1.891 2.786-5.489 5.8-12.211 5.8-8.734 0-15.84-7.267-15.84-16.2S43.266 75.8 52 75.8c4.975 0 8.178 2.075 9.989 3.816l2.776 2.668 14.488-13.967-3.083-2.877C69.553 59.264 61.194 56 52 56c-19.851 0-36 16.149-36 36s16.149 36 36 36c23.377 0 38.682-18.966 33.806-44.572",
	  fillRule: "nonzero"
	});
	
	var _ref6 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M105.267 115.97c-7.352 0-6.567-9.97-.252-9.97h9v1c0 5.819-4.775 8.97-8.748 8.97m14.748-.97a2 2 0 0 1-2-2v-13c0-4.775-3.774-10-10-10h-.002c-5.024 0-8.755 3.96-8.755 5.734 0 1.485 1.297 1.998 1.997 1.998 2.309 0 2.077-3.732 6.758-3.732 3.286 0 6.002 2.653 6.002 6v2h-9a9 9 0 0 0-9 9c0 8.896 11.133 12.255 18.195 5.175 1.13 3.652 5.19 2.686 5.805 2.825 2.646 0 2.648-4 0-4M124.35 36c.81-2.33 3.04-4 5.65-4 3.31 0 6 2.69 6 6 0 2.61-1.67 4.84-4 5.65v24.7c2.33.81 4 3.04 4 5.65 0 3.31-2.69 6-6 6-2.61 0-4.84-1.67-5.65-4h-24.7c-.81 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6 0-2.61 1.67-4.84 4-5.65v-24.7c-2.33-.81-4-3.04-4-5.65 0-3.31 2.69-6 6-6 2.61 0 4.84 1.67 5.65 4h24.7zM130 76c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-36 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm30.35-4c.59-1.7 1.95-3.06 3.65-3.65v-24.7a5.952 5.952 0 0 1-3.65-3.65h-24.7A5.952 5.952 0 0 1 96 43.65v24.7c1.7.59 3.06 1.95 3.65 3.65h24.7zM106 50v2c0 1.1-.9 2-2 2s-2-.9-2-2v-4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2s-2-.9-2-2v-2h-4v12h2c1.1 0 2 .9 2 2s-.9 2-2 2h-8c-1.1 0-2-.9-2-2s.9-2 2-2h2V50h-4zM94 36c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm36 0c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 160 160",
	    fillRule: "evenodd",
	    clipRule: "evenodd"
	  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h160v160H0z"
	});
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill2",
	  d: "M63 123h-3v3h-3v-3h-3v-3h3v-3h3v3h3v3zm-22 12c-6.638 0-12-5.362-12-12s5.362-12 12-12c3.244 0 5.953 1.182 8.044 3.141l-3.263 3.13c-.89-.852-2.447-1.846-4.781-1.846-4.097 0-7.443 3.393-7.443 7.575s3.346 7.575 7.443 7.575c4.753 0 6.534-3.413 6.807-5.175H41v-4.116h11.334c.103.601.187 1.2.187 1.987C52.521 130.135 47.928 135 41 135m5-37c-13.798 0-25 11.202-25 25s11.202 25 25 25 25-11.202 25-25-11.202-25-25-25",
	  fill: "#0dcaf2",
	  fillRule: "nonzero",
	  fillOpacity: 0.5
	});
	
	var _ref3 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill1",
	  d: "M99 89.01c0 2.21-1.79 4-4 4H81c-1.06 0-2.08-.42-2.83-1.17A4.002 4.002 0 0 1 77 89.01v-6c0-1.1.9-2 2-2s2 .9 2 2v6.021h14v-6c0-1.111.9-2 2-2s2 .889 2 2v5.979zM80.95 73.441c1.57-1.571 4.08-4.091 5.65-5.66a2.002 2.002 0 0 1 2.83 0l5.66 5.66c.78.779.78 2.049 0 2.829-.78.78-2.05.78-2.83 0l-2.24-2.239v10c0 1.099-.9 2-2 2a2 2 0 0 1-2-2v-10s-1.22 1.209-2.25 2.239c-.78.78-2.04.78-2.82 0-.79-.78-.79-2.05 0-2.829m33.04 7.059v-.34l-.01-.16-.01-.17v-.17l-.01-.16-.01-.17-.01-.16-.02-.17-.01-.16-.01-.17-.02-.16-.01-.17-.02-.16-.02-.16-.02-.17-.02-.159-.02-.16-.02-.161-.03-.17-.02-.16-.03-.16-.02-.16-.03-.16-.03-.159-.02-.161-.04-.16-.06-.32-.03-.16-.04-.15-.03-.16-.04-.16-.03-.16-.04-.149-.04-.161-.04-.15-.04-.16-.04-.159-.04-.151-.05-.15-.04-.159-.05-.151-.04-.16-.05-.15-.05-.15-.05-.15-.05-.149-.05-.161-.05-.15-.05-.149-.05-.151-.06-.15-.05-.14-.06-.15-.06-.15-.05-.15-.06-.149-.06-.141-.06-.149-.06-.151-.07-.14-.06-.15-.06-.14-.07-.15-.06-.14-.07-.14-.07-.15-.07-.139-.06-.141-.07-.14-.08-.14-.07-.14-.07-.139-.07-.141-.08-.14-.14-.28-.08-.13-.08-.14-.08-.14-.08-.13-.07-.14-.08-.13-.09-.14-.08-.13-.08-.13-.08-.14-.09-.13-.08-.129-.09-.13-.09-.131-.08-.13-.09-.13-.09-.13-.09-.13-.09-.13-.09-.12-.09-.13-.1-.129-.09-.121-.09-.129-.1-.121-.09-.12-.1-.13-.1-.12-.09-.12-.1-.12-.2-.24-.1-.119-.1-.12-.1-.121-.11-.12-.1-.12-.1-.11-.11-.12-.1-.11-.11-.12-.11-.11-.1-.109-.11-.121-.66-.66-.12-.11-.11-.1-.11-.11-.12-.109-.11-.101-.12-.109-.11-.101-.12-.1-.12-.11-.24-.2-.12-.1-.12-.099-.12-.101-.24-.2-.12-.09-.13-.1-.12-.089-.12-.101-.13-.09-.12-.09-.13-.099-.13-.091-.12-.09-.13-.09-.13-.09-.13-.089-.13-.09-.13-.08-.13-.091-.13-.09-.13-.08-.13-.09-.14-.08-.26-.16-.14-.09-.13-.08-.14-.08-.13-.07-.28-.16-.13-.08-.14-.07-.14-.069-.14-.081-.14-.07-.14-.07-.14-.08-.14-.07-.14-.07-.14-.059-.14-.071-.15-.07-.14-.069-.14-.061-.15-.069-.14-.061-.15-.059-.14-.071-.15-.059-.15-.061-.14-.059-.15-.061-.15-.05-.15-.059-.15-.061-.14-.05-.15-.06-.15-.05-.15-.05-.15-.05-.16-.049-.15-.051-.3-.1-.15-.05-.16-.04-.15-.049-.16-.041-.15-.049-.15-.04-.16-.04-.16-.04-.15-.04-.16-.041-.15-.04-.16-.03-.16-.04-.16-.03-.15-.04-.16-.029-.16-.031-.16-.03-.16-.04-.16-.02-.16-.03-.16-.03-.16-.02-.16-.03-.16-.019-.17-.031-.16-.019-.16-.021-.16-.019-.17-.021-.16-.019-.16-.021-.17-.01-.16-.02-.17-.01-.16-.01-.17-.02-.16-.01-.17-.01-.16-.009h-.17L89 55.02l-.16-.01h-.34l-.16-.01h-.68l-.16.01h-.34l-.16.01-.17.011h-.17l-.16.009-.17.01-.16.01-.17.02-.16.01-.17.01-.16.02-.17.01-.16.021-.16.019-.17.021-.16.019-.16.021-.16.019-.17.031-.16.019-.16.03-.16.02-.16.03-.16.03-.16.02-.16.04-.16.03-.16.031-.16.029-.15.04-.16.03-.16.04-.16.03-.15.04-.16.041-.15.04-.16.04-.16.04-.15.04-.15.049-.16.041-.15.049-.16.04-.15.05-.3.1-.15.051-.16.049-.15.05-.15.05-.15.05-.15.06-.14.05-.15.061-.15.059-.15.05-.15.061-.14.059-.15.061-.15.059-.14.071-.15.059-.14.061-.15.069-.14.061-.14.069-.15.07-.14.071-.14.059-.14.07-.14.07-.14.08-.14.07-.14.07-.14.081-.14.069-.14.07-.13.08-.28.16-.13.07-.14.08-.13.08-.14.09-.26.16-.14.08-.13.09-.13.08-.13.09-.13.091-.13.08-.13.09-.13.089-.13.09-.13.09-.12.09-.13.091-.13.099-.12.09-.13.09-.12.101-.12.089-.13.1-.12.09-.24.2-.12.101-.12.099-.12.1-.24.2-.12.11-.12.1-.11.101-.12.109-.11.101-.12.109-.11.11-.11.1-.12.11-.66.66-.11.121-.1.109-.11.11-.11.12-.1.11-.11.12-.1.11-.1.12-.11.12-.1.121-.1.12-.1.119-.2.24-.1.12-.09.12-.1.12-.1.13-.09.12-.1.121-.09.129-.1.121-.09.129-.09.13-.09.12-.09.13-.09.13-.09.13-.09.13-.08.13-.09.131-.09.13-.08.129-.09.13-.08.14-.08.13-.08.13-.08.14-.09.13-.07.14-.08.13-.08.14-.08.14-.07.13-.08.141-.07.139-.08.14-.07.141-.07.139-.08.14-.07.14-.07.14-.06.141-.07.139-.07.15-.07.14-.06.14-.07.15-.06.14-.06.15-.07.14-.06.151-.06.149-.06.141-.06.149-.05.15-.06.15-.06.15-.05.14-.06.15-.05.151-.05.149-.05.15-.05.161-.05.149-.05.15-.05.15-.05.15-.04.16-.05.151-.04.159-.05.15-.04.151-.04.159-.04.16-.04.15-.04.161-.04.149-.03.16-.04.16-.03.16-.04.15-.03.16-.06.32-.03.16-.03.161-.03.159-.03.16-.02.16-.03.16-.02.16-.03.17-.02.161-.02.16-.02.159-.02.17-.02.16-.02.16-.01.17-.02.16-.01.17-.01.16-.02.17-.01.16-.01.17-.01.16v.17l-.01.17-.01.16v.17l-.01.17v1l.01.17v.17l.01.16.01.17v.17l.01.16.01.17.01.16.02.17.01.16.01.17.02.16.01.17.02.161.02.16.02.17.02.159.04.32.03.17.02.16.03.16.02.161.03.16.03.159.12.64.03.161.04.149.03.16.04.16.03.161.04.149.04.16.04.15.04.161.04.159.04.15.05.151.04.159.05.15.04.16.1.3.05.151.05.149.05.16.15.45.06.151.05.139.12.3.05.151.06.149.06.141.06.149.06.15.07.14.06.15.06.14.07.15.06.14.07.141.07.149.07.14.06.14.14.281.08.139.14.281.08.139.07.14.08.141.07.129.16.281.08.13.07.139.09.13.08.141.08.13.08.129.08.14.09.13.08.13.09.13.09.131.08.13.09.129.27.39.09.12.18.26.1.12.09.13.1.12.09.12.1.13.1.12.09.12.1.12.2.241.1.119.2.24.11.12.1.12.1.111.11.12.1.109.11.12.11.111.1.109.11.12.66.66.12.111.11.099.11.111.12.109.11.1.12.11.11.1.12.1.12.11.72.6.12.09.12.1.13.1.12.09.12.1.13.09.12.1.13.09.13.091.12.089.52.36.13.08.13.091.13.09.13.08.13.089.14.081.26.16.14.079.13.08.14.08.13.08.28.16.13.071.14.08.14.069.14.08.14.07.14.071.14.08.28.139.14.06.14.07.15.071.14.069.14.06.15.07.14.06.15.06.14.07.3.12.14.06.15.06.15.05.3.12.14.05.15.061.15.05.15.049.15.05.16.05.15.051.3.099.15.05.16.04.15.05.16.04.15.05.15.04.32.08.15.04.16.04.15.04.16.03.16.04.16.031.15.04.16.029.16.03.16.031.16.029.32.06.16.031.16.019.16.03.16.02.17.03.48.06.17.02.32.04.17.01.16.021.17.009.16.01.17.021.16.009.17.01.16.01h.17l.17.011.16.009h.17l.17.01h1l.17-.01h.17l.16-.009.17-.011h.17l.16-.01.17-.01.16-.009.17-.021.16-.01.17-.009.16-.021.17-.01.16-.02.16-.02.17-.02.32-.04.16-.02.17-.03.16-.02.16-.03.16-.019.16-.031.16-.03.16-.03.16-.029.16-.031.16-.03.16-.029.15-.04.16-.031.16-.04.16-.03.15-.04.16-.04.15-.04.16-.04.16-.04.15-.04.15-.05.16-.04.15-.05.16-.04.15-.05.3-.099.15-.051.16-.05.15-.05.15-.049.15-.05.15-.061.14-.05.15-.06.15-.06.15-.05.15-.06.14-.06.15-.06.15-.06.14-.07.15-.06.14-.06.15-.07.14-.06.14-.069.15-.071.14-.07.14-.06.28-.139.14-.08.14-.071.14-.07.14-.08.14-.069.14-.08.13-.071.14-.08.14-.08.13-.08.14-.08.13-.08.14-.079.13-.08.13-.08.14-.081.13-.089.13-.08.13-.09.13-.091.13-.08.13-.09.13-.09.13-.09.13-.09.12-.089.13-.091.13-.09.12-.1.13-.09.12-.1.12-.09.13-.1.12-.1.12-.09.12-.1.12-.1.12-.1.24-.2.12-.1.12-.11.12-.1.11-.1.12-.11.11-.1.12-.109.11-.111.11-.099.12-.111.11-.11.11-.11.11-.11.11-.11.11-.11.11-.11.11-.12.1-.109.11-.111.11-.12.1-.109.11-.12.1-.111.1-.12.11-.12.1-.12.1-.12.1-.119.2-.241.1-.12.09-.12.1-.12.1-.13.09-.12.1-.12.09-.13.09-.12.1-.13.09-.13.09-.12.09-.13.09-.13.09-.13.09-.129.08-.13.09-.131.09-.13.08-.13.09-.13.08-.14.08-.129.08-.13.09-.141.08-.13.07-.139.08-.13.16-.281.08-.129.07-.141.07-.14.08-.139.14-.281.07-.139.08-.141.07-.14.06-.14.07-.14.07-.149.07-.141.06-.14.07-.15.06-.14.06-.15.07-.14.06-.15.06-.149.06-.141.06-.149.05-.151.12-.3.05-.139.06-.151.05-.15.1-.3.05-.16.05-.149.05-.151.1-.3.04-.16.05-.15.04-.159.05-.151.04-.15.04-.159.04-.161.04-.15.04-.16.04-.149.03-.161.04-.16.03-.16.04-.149.03-.161.03-.16.03-.16.04-.16.02-.16.03-.159.03-.16.02-.161.03-.16.02-.16.03-.17.02-.16.02-.16.02-.159.02-.17.02-.16.02-.161.01-.17.02-.16.01-.17.01-.16.02-.17.01-.16.01-.17.01-.16v-.17l.01-.17.01-.16v-.34l.01-.16v-.68l-.01-.16z",
	  fill: "#cc339f",
	  fillOpacity: 0.5
	});
	
	var _ref4 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill2",
	  d: "M144.06 110.031v.603c0 6.632-2.895 12.18-8.08 15.075-2.653 1.567-5.548 2.291-8.563 2.291-3.014 0-6.271-.844-9.286-2.532-.482-.242-.723-.845-.602-1.328.12-.482.723-.843 1.206-.843 2.05 0 4.099-.363 5.909-1.206-4.462-2.774-5.668-6.633-5.789-9.648-.12-3.498 1.086-6.391 1.206-6.513.121-.361.482-.723.965-.723.482 0 .844.121 1.085.482 2.051 2.895 5.186 4.703 8.683 4.945 0-1.93.844-3.739 2.412-5.065 2.533-2.171 6.271-2.051 8.683.12.965-.361 1.93-.844 2.774-1.447.362-.241.964-.241 1.327 0 .361.241.602.724.482 1.206-.362 1.688-1.206 3.256-2.412 4.583M132 94c-11.045 0-20 8.954-20 20s8.955 20 20 20c11.046 0 20-8.954 20-20s-8.954-20-20-20M122 17.055c-11.046 0-20 8.955-20 20 0 8.341 5.108 15.481 12.363 18.483V44.419h-2.909c-.872 0-1.454-.582-1.454-1.455v-5.817c0-.873.582-1.455 1.454-1.455h2.909v-2.909c0-4.8 3.928-8.728 8.728-8.728h4.363c.873 0 1.455.582 1.455 1.455v5.818c0 .873-.582 1.455-1.455 1.455h-4.363v2.909h4.363c.437 0 .873 0 1.164.436.291.437.437.873.291 1.309l-1.455 5.818c-.145.728-.726 1.164-1.454 1.164h-2.909V57C133.626 56.43 142 47.733 142 37.055c0-11.045-8.954-20-20-20",
	  fill: "#0dcaf2",
	  fillRule: "nonzero",
	  fillOpacity: 0.5
	});
	
	var _ref5 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill1",
	  d: "M46.059 58.82c-1.748 0-3.387-.909-3.946-1.981 0 0-.863 3.286-1.073 4.093-.649 2.507-1.955 3.904-3.147 5.445.023 0-.665-3.931-.107-6.299.31-1.344 2.019-8.561 2.019-8.561s-.513-1.033-.513-2.555c0-2.393 1.391-4.188 3.116-4.188 1.468 0 2.182 1.104 2.182 2.424 0 1.476-.939 3.69-1.428 5.733-.413 1.717.854 3.116 2.547 3.116 3.061 0 5.415-3.233 5.415-7.893 0-4.125-2.967-7.008-7.194-7.008-4.901 0-7.775 3.675-7.775 7.482 0 1.483.566 3.068 1.281 3.93.14.171.163.319.117.497-.133.544-.42 1.717-.482 1.958-.077.319-.248.38-.575.233C34.344 54.244 33 51.097 33 48.573c0-5.438 3.947-10.425 11.381-10.425 5.974 0 10.619 4.257 10.619 9.951 0 5.935-3.744 10.721-8.941 10.721M44 29c-11.045 0-20 8.954-20 20s8.955 20 20 20c11.046 0 20-8.954 20-20s-8.954-20-20-20",
	  fill: "#cc339f",
	  fillOpacity: 0.5
	});
	
	var _ref6 =
	/*#__PURE__*/
	_react2.default.createElement("g", null, _react2.default.createElement("path", {
	  d: "M51.036 49.898l.086.004.086.008.085.011.085.015.084.019.083.023.082.025.081.03.079.033.079.036.076.04.075.043.072.046.071.049 9.465 6.883.068.052.067.055.063.058.062.061.058.063.056.065.053.068.05.07.047.072.043.075.041.076.037.077.034.079.03.081.027.082.024.082.02.084.016.085.012.085.009.085.005.086.002.086-.003.086-.006.086-.009.086-.014.085-.017.084-.02.084-.024.082-.028.082-.031.08-.035.079-.038.077-.041.076-.044.073-.048.072-.051.07-.053.067-.057.065-.059.063-.062.059-.064.058-.067.054-.069.051-.071.049-.073.045-.075.042-.077.039-.078.036-.08.032-.081.029-.082.025-.084.021-.084.018-.085.015-.085.01-.086.007-.086.004-.086-.001-.086-.004-.086-.008-.085-.011-.085-.015-.084-.019-.083-.023-.082-.026-.081-.029-.079-.033-.078-.036-.077-.04-.074-.043-.073-.046-.071-.049-9.465-6.883-.068-.052-.066-.055-.064-.058-.061-.061-.059-.063-.056-.065-.053-.068-.05-.07-.047-.073-.043-.074-.041-.076-.037-.077-.034-.079-.03-.081-.027-.082-.024-.082-.019-.084-.016-.085-.013-.085-.009-.085-.005-.086-.001-.086.002-.086.006-.086.01-.086.013-.085.017-.084.02-.084.025-.082.027-.082.031-.08.035-.079.038-.077.041-.076.045-.073.047-.072.051-.07.053-.067.057-.065.059-.063.062-.059.064-.058.067-.054.069-.051.071-.049.073-.045.075-.042.077-.039.078-.036.08-.032.081-.029.083-.025.083-.021.084-.018.085-.015.085-.01.086-.007.086-.004.086.001zm51.745-7.594l.086.006.086.009.085.013.084.017.084.02.083.024.081.028.08.031.079.034.078.038.075.041.074.044.072.048.07.05.067.053.065.057.063.059.06.061.058.064.054.067.052.069.048.071.046.073.042.075.039.076.036.079.032.079.029.082.026.082.022.083.018.084.014.085.011.085.007.086.004.086v.086l-.004.086-.008.086-.011.085-.015.085-.018.084-.023.083-.025.082-.029.081-.033.08-.036.078-.04.077-.042.074-.046.073-.049.071-.052.069-7.486 9.467-.055.067-.057.063-.061.062-.063.059-.065.056-.068.053-.07.05-.072.047-.074.044-.075.041-.078.037-.079.034-.08.031-.082.027-.083.023-.084.02-.084.017-.085.013-.086.009-.086.005-.086.002-.086-.002-.086-.006-.085-.009-.085-.014-.085-.016-.083-.021-.083-.024-.081-.027-.081-.031-.079-.034-.077-.038-.076-.041-.074-.044-.071-.048-.07-.05-.068-.053-.065-.057-.062-.059-.061-.061-.057-.064-.054-.067-.052-.069-.049-.071-.045-.073-.043-.075-.039-.077-.035-.078-.033-.08-.029-.081-.025-.082-.022-.083-.018-.084-.015-.085-.011-.085-.007-.086-.003-.086v-.086l.004-.086.007-.086.012-.085.014-.085.019-.084.022-.083.026-.082.029-.081.033-.08.036-.078.039-.077.043-.074.046-.073.049-.071.051-.069 7.487-9.467.054-.067.058-.064.06-.061.063-.059.066-.056.067-.053.07-.05.072-.047.074-.044.076-.041.078-.037.079-.034.08-.031.082-.027.082-.024.084-.02.085-.016.085-.013.085-.009.086-.005.086-.002.086.002zm-3.749 43.358l.09.004.089.009.089.013.088.017.087.02.087.025.085.028.084.032.082.036.081.039.078.044.077.046.075.05.072.053 10.1 7.805.07.057.067.059.065.063.061.065.059.068.055.071.052.073.049.075.046.077.042.08.038.081.035.082.031.085.027.085.023.087.02.088.015.088.011.089.008.09.003.089v.09l-.005.09-.009.089-.013.089-.016.088-.021.087-.024.087-.029.085-.032.084-.036.082-.039.08-.043.079-.047.077-.05.074-.053.073-.056.069-.06.068-.063.064-.065.062-.068.058-.07.056-.073.052-.076.049-.077.045-.079.042-.081.039-.083.034-.085.031-.085.027-.087.024-.087.019-.089.015-.089.012-.089.007-.09.004-.09-.001-.089-.005-.09-.008-.089-.013-.088-.017-.087-.02-.086-.025-.086-.028-.083-.032-.083-.036-.08-.04-.079-.043-.077-.046-.074-.05-.072-.054-10.101-7.804-.07-.057-.067-.059-.064-.063-.062-.065-.058-.068-.056-.071-.052-.073-.049-.075-.045-.077-.042-.08-.039-.081-.034-.083-.031-.084-.028-.086-.023-.086-.019-.088-.016-.088-.011-.089-.007-.09-.004-.089.001-.09.005-.09.008-.089.013-.089.017-.088.02-.088.025-.086.028-.085.032-.084.036-.082.04-.081.043-.078.046-.077.05-.075.053-.072.057-.07.059-.067.063-.064.065-.062.068-.058.071-.056.073-.052.075-.049.077-.046.08-.041.081-.039.083-.035.084-.03.085-.028.087-.023.088-.019.088-.016.089-.011.09-.007.089-.004.09.001zM63.749 88.53l.084.004.085.008.084.011.084.015.083.019.082.022.081.025.079.029.079.032.077.035.076.039.074.042.072.045.07.048.068.051.065.054.064.056.061.059.058.062.056.064.053.066.05.069.047.071.044.072.041.075.037.076.035.077.031.079.028.08.024.082.021.082.017.083.014.084.011.084.006.085.003.085v.085l-.004.084-.008.085-.011.084-.015.084-.019.083-.022.082-.025.081-.029.079-.032.079-.035.077-.039.076-.042.074-.045.072-.048.07-.051.068-.054.065-.056.064-8.518 9.156-.059.061-.061.058-.064.056-.067.053-.068.05-.071.047-.073.044-.074.041-.076.038-.078.034-.079.031-.08.028-.081.024-.083.021-.083.018-.083.014-.085.01-.084.006-.085.004-.085-.001-.085-.004-.084-.008-.085-.011-.083-.015-.083-.018-.082-.022-.081-.026-.08-.029-.079-.032-.077-.035-.075-.039-.074-.042-.072-.045-.07-.048-.068-.051-.066-.053-.063-.057-.061-.059-.058-.062-.056-.064-.053-.066-.05-.069-.047-.07-.044-.073-.041-.074-.038-.076-.034-.078-.032-.079-.027-.08-.025-.082-.021-.082-.017-.083-.014-.084-.01-.084-.007-.085-.003-.084.001-.085.004-.085.008-.085.011-.084.015-.083.018-.083.022-.082.026-.081.028-.08.033-.079.035-.077.039-.076.042-.073.045-.072.048-.07.05-.068.054-.066.057-.063 8.517-9.157.059-.061.062-.058.064-.056.066-.053.069-.05.071-.047.072-.044.075-.041.076-.037.077-.035.079-.031.08-.028.082-.024.082-.021.083-.017.084-.014.084-.011.085-.006.085-.003h.085zM73.57 24.653a.476.476 0 0 0 .86 0c1.777-4.291 4.756-4.179 6.307-2.768 1.684 1.532 1.684 4.597 0 7.662-1.013 1.974-3.393 3.949-5.645 5.438a1.994 1.994 0 0 1-2.184 0c-2.252-1.489-4.632-3.464-5.645-5.438-1.684-3.065-1.684-6.13 0-7.662 1.551-1.411 4.53-1.523 6.307 2.768zm48.006 41.436a.473.473 0 0 0 .847 0c1.561-3.639 4.128-3.531 5.472-2.309 1.473 1.341 1.473 4.022 0 6.704-.864 1.685-2.866 3.369-4.792 4.66a1.991 1.991 0 0 1-2.207 0c-1.926-1.291-3.927-2.975-4.791-4.66-1.473-2.682-1.473-5.363 0-6.704 1.344-1.222 3.911-1.33 5.471 2.309zm-85.703 3.493a1.185 1.185 0 0 1 2.254 0l1.131 3.482a.597.597 0 0 0 .563.409h3.661a1.184 1.184 0 0 1 .696 2.143l-2.961 2.152a.59.59 0 0 0-.215.662l1.131 3.482a1.186 1.186 0 0 1-1.823 1.324l-2.962-2.151a.588.588 0 0 0-.696 0l-2.962 2.151a1.186 1.186 0 0 1-1.823-1.324l1.131-3.482a.587.587 0 0 0-.215-.662l-2.961-2.152a1.183 1.183 0 0 1 .696-2.143h3.661a.595.595 0 0 0 .563-.409l1.131-3.482z"
	}), _react2.default.createElement("path", {
	  d: "M38 90c-13.798 0-25 11.202-25 25s11.202 25 25 25 25-11.202 25-25-11.202-25-25-25zm0 46c-11.58 0-21-9.42-21-21s9.42-21 21-21 21 9.42 21 21-9.42 21-21 21zm6.334-22.716c.104.601.187 1.2.187 1.987C44.521 122.135 39.928 127 33 127c-6.638 0-12-5.362-12-12s5.362-12 12-12c3.244 0 5.953 1.181 8.044 3.14l-3.263 3.131c-.89-.852-2.447-1.846-4.781-1.846-4.097 0-7.443 3.393-7.443 7.575 0 4.181 3.346 7.575 7.443 7.575 4.753 0 6.534-3.413 6.807-5.175H33v-4.116h11.334zM52 109v3h3v3h-3v3h-3v-3h-3v-3h3v-3h3z",
	  fillRule: "nonzero"
	}), _react2.default.createElement("path", {
	  d: "M75.24 47.435l.16-.029.161-.028.16-.027.161-.026.161-.025.161-.024.162-.024.162-.022.162-.021.164-.02.163-.019.163-.018.163-.018.164-.016.165-.015.164-.014.165-.013.165-.012.165-.011.166-.01.166-.009.166-.008.167-.007.166-.006.167-.005.167-.003.168-.003.168-.001L80 47l.336.002.168.003.167.003.167.005.166.006.167.007.166.008.166.009.166.01.165.011.165.012.165.013.164.014.165.015.164.016.326.036.163.019.164.02.162.021.162.022.162.024.161.024.161.025.161.026.16.027.161.028.16.029.318.062.159.032.159.034.158.033.157.034.158.036.156.037.158.038.156.039.155.039.312.082.308.086.155.044.306.092.154.047.152.048.151.049.152.049.151.051.302.104.149.053.15.055.149.055.148.056.149.057.147.058.148.058.294.12.145.062.146.062.145.063.145.064.143.064.145.066.142.066.144.067.142.069.142.068.141.07.14.071.141.071.141.072.138.073.139.074.139.075.137.075.138.077.137.077.272.156.136.08.135.08.134.081.133.082.134.083.132.083.133.084.131.085.131.086.26.174.13.088.129.089.128.089.128.091.254.182.126.093.125.093.125.094.248.19.123.096.123.097.121.098.122.098.12.099.12.1.12.101.119.1.119.103.117.102.117.103.116.104.117.105.114.105.115.106.113.106.114.108.224.216.112.11.22.22.11.112.216.224.108.114.106.113.106.115.105.114.105.117.104.116.103.117.102.117.103.119.1.119.101.12.1.12.099.12.098.122.098.121.097.123.096.123.19.248.094.125.093.125.093.126.182.254.091.128.089.128.089.129.088.13.174.26.086.131.085.131.084.133.083.132.083.134.082.133.081.134.08.135.08.136.078.135.078.137.077.137.077.138.075.137.075.139.074.139.073.138.072.141.071.141.071.14.07.141.068.142.069.142.067.144.066.142.066.145.064.143.064.145.063.145.062.146.062.145.12.294.058.148.058.147.057.149.056.148.055.149.055.15.053.149.104.302.051.151.049.152.049.151.048.152.047.154.092.306.044.155.086.308.082.312.039.155.039.156.038.158.037.156.036.158.034.157.034.158.033.159.032.159.062.318.029.16.028.161.027.16.026.161.025.161.024.161.024.162.022.162.021.162.02.164.019.163.036.326.016.164.015.165.014.164.013.165.012.165.011.165.01.166.009.166.008.166.007.167.006.166.005.167.003.167.003.168L106 73l-.001.168-.001.168-.003.168-.003.167-.005.167-.006.166-.007.167-.008.166-.009.166-.01.166-.011.165-.012.165-.013.165-.014.164-.015.165-.016.164-.018.163-.018.163-.019.163-.02.164-.021.162-.022.162-.024.162-.024.161-.025.161-.026.161-.027.16-.028.161-.029.16-.062.318-.032.159-.033.159-.034.158-.034.157-.036.158-.037.156-.038.158-.039.156-.039.155-.041.156-.041.156-.086.308-.044.155-.046.153-.046.153-.047.153-.048.153-.049.151-.049.152-.051.151-.052.151-.052.151-.053.149-.055.15-.055.149-.056.148-.057.149-.058.147-.058.148-.12.294-.062.145-.062.146-.063.145-.064.145-.064.143-.066.145-.066.142-.067.144-.069.142-.068.142-.07.141-.071.14-.071.141-.072.141-.073.138-.074.139-.075.139-.075.137-.077.138-.077.137-.078.137-.078.135-.08.136-.08.135-.081.134-.082.133-.083.134-.083.132-.084.133-.085.131-.086.131-.174.26-.088.13-.089.129-.089.128-.091.128-.091.127-.091.127-.093.126-.093.125-.094.125-.095.124-.095.124-.096.123-.097.123-.098.121-.098.122-.099.12-.1.12-.101.12-.1.119-.103.118-.102.118-.103.117-.104.116-.105.116-.105.115-.106.115-.106.113-.108.114-.108.112-.108.112-.11.112-.11.11-.11.11-.112.11-.112.108-.112.108-.114.108-.113.106-.115.106-.114.105-.117.105-.116.104-.117.103-.117.102-.119.103-.119.1-.12.101-.12.1-.12.099-.122.098-.121.097-.123.097-.123.097-.124.096-.124.094-.125.094-.125.093-.126.093-.127.091-.127.091-.128.091-.128.089-.129.089-.13.088-.13.088-.13.085-.131.086-.131.085-.133.084-.132.084-.134.082-.133.082-.134.081-.135.081-.136.08-.136.078-.136.078-.137.077-.138.076-.137.076-.139.075-.139.074-.138.073-.282.144-.14.07-.141.069-.142.07-.142.068-.144.066-.142.067-.145.066-.143.065-.145.063-.145.064-.146.061-.145.062-.294.12-.148.058-.147.058-.149.058-.148.055-.149.055-.15.055-.149.053-.151.052-.151.052-.151.051-.152.049-.151.049-.152.048-.154.047-.153.047-.153.045-.155.044-.154.044-.154.042-.156.042-.156.04-.155.04-.156.038-.158.038-.156.037-.158.035-.157.035-.158.034-.159.034-.159.031-.159.031-.159.03-.16.03-.161.028-.16.026-.161.027-.161.025-.161.025-.162.023-.162.022-.162.021-.164.021-.163.018-.163.019-.163.016-.164.017-.165.014-.164.015-.165.013-.165.013-.165.01-.166.01-.166.009-.166.008-.167.006-.166.006-.167.005-.167.004-.168.003-.168.002h-.336l-.168-.002-.168-.003-.167-.004-.167-.005-.166-.006-.167-.006-.166-.008-.166-.009-.166-.01-.165-.01-.33-.026-.164-.015-.165-.014-.164-.017-.163-.016-.163-.019-.163-.018-.164-.021-.162-.021-.162-.022-.162-.023-.322-.05-.161-.027-.16-.026-.161-.028-.16-.03-.159-.03-.318-.062-.159-.034-.158-.034-.157-.035-.158-.035-.156-.037-.158-.038-.156-.038-.155-.04-.156-.04-.156-.042-.154-.042-.154-.044-.155-.044-.153-.045-.306-.094-.153-.048-.151-.049-.152-.049-.151-.051-.302-.104-.149-.053-.15-.055-.149-.055-.148-.055-.149-.058-.147-.058-.148-.058-.294-.12-.145-.062-.146-.061-.145-.064-.145-.063-.143-.065-.145-.066-.142-.067-.144-.066-.142-.068-.142-.07-.141-.069-.14-.07-.282-.144-.138-.073-.139-.074-.139-.075-.137-.076-.138-.076-.137-.077-.137-.078-.135-.078-.136-.08-.135-.081-.134-.081-.133-.082-.134-.082-.132-.084-.133-.084-.131-.085-.131-.086-.13-.085-.26-.176-.129-.089-.128-.089-.128-.091-.254-.182-.126-.093-.125-.093-.125-.094-.124-.094-.124-.096-.246-.194-.121-.097-.122-.098-.12-.099-.12-.1-.12-.101-.119-.1-.118-.103-.118-.102-.117-.103-.116-.104-.117-.105-.114-.105-.115-.106-.113-.106-.114-.108-.224-.216-.112-.11-.22-.22-.11-.112-.216-.224-.108-.114-.106-.113-.106-.115-.105-.115-.105-.116-.104-.116-.103-.117-.102-.118-.103-.118-.1-.119-.101-.12-.1-.12-.099-.12-.098-.122-.097-.121-.194-.246-.096-.124-.094-.124-.094-.125-.093-.125-.093-.126-.182-.254-.091-.128-.089-.128-.089-.129-.176-.26-.085-.13-.086-.131-.085-.131-.084-.133-.084-.132-.082-.134-.082-.133-.081-.134-.081-.135-.08-.136-.078-.135-.078-.137-.077-.137-.076-.138-.076-.137-.075-.139-.074-.139-.073-.138-.144-.282-.07-.14-.069-.141-.07-.142-.068-.142-.067-.144-.066-.142-.066-.145-.065-.143-.063-.145-.064-.145-.061-.146-.062-.145-.12-.294-.058-.148-.058-.147-.058-.149-.055-.148-.055-.149-.055-.15-.053-.149-.104-.302-.051-.151-.049-.152-.049-.151-.048-.153-.094-.306-.045-.153-.044-.155-.044-.154-.042-.154-.042-.156-.04-.156-.04-.155-.038-.156-.038-.158-.037-.156-.035-.158-.035-.157-.034-.158-.034-.159-.032-.159-.06-.318-.03-.16-.028-.161-.026-.16-.027-.161-.05-.322-.023-.162-.022-.162-.021-.162-.021-.164-.018-.163-.019-.163-.016-.163-.017-.164-.014-.165-.015-.164-.026-.33-.01-.165-.01-.166-.018-.332-.005-.167-.006-.166-.005-.167-.004-.167-.003-.168-.002-.168v-.336l.002-.168.003-.168.004-.167.005-.167.006-.166.005-.167.018-.332.01-.166.01-.165.013-.165.013-.165.015-.164.014-.165.017-.164.016-.163.019-.163.018-.163.021-.164.021-.162.022-.162.023-.162.025-.161.025-.161.027-.161.026-.16.028-.161.03-.16.03-.159.03-.159.032-.159.034-.159.034-.158.035-.157.035-.158.037-.156.038-.158.038-.156.04-.155.04-.156.042-.156.042-.154.044-.154.044-.155.045-.153.047-.153.047-.154.048-.152.049-.151.049-.152.051-.151.052-.151.052-.151.053-.149.055-.15.055-.149.055-.148.058-.149.058-.147.058-.148.12-.294.062-.145.061-.146.064-.145.063-.145.065-.143.066-.145.066-.142.067-.144.068-.142.07-.142.069-.141.07-.14.144-.282.073-.138.074-.139.075-.139.076-.137.076-.138.077-.137.078-.137.078-.135.08-.136.081-.135.081-.134.082-.133.082-.134.084-.132.084-.133.085-.131.086-.131.085-.13.088-.13.088-.13.089-.129.089-.128.091-.128.091-.127.091-.127.093-.126.093-.125.094-.125.094-.124.096-.124.097-.123.097-.123.097-.121.098-.122.099-.12.1-.12.101-.12.1-.119.103-.119.102-.117.103-.117.104-.116.105-.117.105-.114.106-.115.106-.113.108-.114.108-.112.108-.112.11-.112.11-.11.11-.11.112-.11.112-.108.112-.108.114-.108.113-.106.115-.106.114-.105.117-.105.116-.104.117-.103.118-.102.118-.103.119-.1.12-.101.12-.1.12-.099.122-.098.121-.098.123-.097.123-.096.124-.095.124-.095.125-.094.125-.093.126-.093.127-.091.127-.091.128-.091.128-.089.129-.089.13-.088.26-.174.131-.086.131-.085.133-.084.132-.083.134-.083.133-.082.134-.081.135-.08.136-.08.135-.078.137-.078.137-.077.138-.077.137-.075.139-.075.139-.074.138-.073.141-.072.141-.071.14-.071.141-.07.142-.068.142-.069.144-.067.142-.066.145-.066.143-.064.145-.064.145-.063.146-.062.145-.062.294-.12.148-.058.147-.058.149-.057.148-.056.149-.055.15-.055.149-.053.151-.052.151-.052.151-.051.152-.049.151-.049.153-.048.153-.047.153-.046.153-.046.155-.044.154-.043.154-.043.156-.041.156-.041.155-.039.156-.039.158-.038.156-.037.158-.036.157-.034.158-.033.159-.034.159-.032.318-.062zM80.143 51h-.286l-.142.002-.143.002-.141.003-.142.004-.142.005-.14.005-.142.008-.14.007-.14.009-.141.009-.139.01-.14.011-.14.012-.138.013-.139.014-.139.014-.138.016-.138.016-.138.017-.136.018-.138.019-.137.019-.137.021-.135.021-.137.022-.136.023-.135.024-.135.025-.134.025-.135.026-.135.027-.133.028-.134.029-.133.029-.133.031-.133.031-.264.064-.132.034-.131.034-.132.035-.131.036-.13.037-.129.037-.13.038-.13.039-.129.04-.129.041-.128.041-.129.042-.127.043-.128.043-.127.045-.127.045-.252.092-.126.048-.25.096-.124.05-.124.05-.124.051-.124.052-.122.053-.123.053-.122.054-.122.055-.122.055-.121.057-.12.056-.12.058-.12.058-.12.059-.12.06-.118.06-.118.061-.118.061-.117.064-.118.062-.117.064-.116.065-.115.065-.116.066-.115.066-.114.068-.114.068-.114.069-.113.069-.113.069-.112.072-.112.071-.112.071-.11.072-.111.075-.11.073-.109.075-.11.075-.108.075-.109.077-.107.077-.107.078-.107.078-.106.079-.106.08-.105.08-.105.08-.104.082-.104.082-.103.082-.103.084-.204.168-.101.085-.101.086-.1.086-.099.087-.1.088-.098.088-.098.089-.098.089-.097.089-.097.091-.096.091-.095.091-.094.093-.095.092-.094.093-.093.094-.092.095-.092.094-.092.095-.091.096-.091.097-.089.097-.089.098-.089.098-.088.098-.088.1-.087.099-.086.1-.085.101-.086.101-.084.102-.084.102-.084.103-.082.103-.082.104-.082.104-.08.105-.08.105-.08.106-.079.106-.078.107-.078.107-.077.107-.077.109-.075.108-.075.11-.075.109-.073.11-.074.111-.073.11-.071.112-.071.112-.072.112-.069.113-.069.113-.069.114-.068.114-.068.114-.066.115-.066.116-.065.115-.065.116-.064.117-.062.118-.064.117-.061.118-.061.118-.06.118-.06.12-.059.12-.058.12-.058.12-.056.12-.057.121-.056.122-.054.122-.054.122-.054.123-.051.122-.052.124-.052.124-.05.124-.05.124-.096.25-.048.126-.047.126-.045.126-.046.127-.044.127-.044.128-.042.127-.043.129-.041.128-.04.129-.04.129-.039.13-.038.13-.037.129-.037.13-.036.131-.035.132-.035.131-.033.132-.064.264-.032.133-.03.133-.029.133-.029.134-.028.133-.027.135-.026.134-.026.135-.048.27-.023.136-.022.137-.021.135-.021.137-.019.137-.019.138-.018.136-.017.138-.016.138-.015.138-.015.139-.013.139-.014.138-.012.14-.011.14-.01.139-.009.141-.009.14-.008.14-.007.142-.004.14-.01.284-.003.141-.002.143-.002.142v.286l.004.285.003.141.01.284.004.14.007.142.008.14.009.14.009.141.01.139.011.14.012.139.014.139.013.139.015.139.015.138.016.138.017.138.018.136.019.138.019.137.021.137.021.135.022.137.023.136.048.27.026.135.026.134.027.135.028.133.029.134.029.133.03.133.032.133.064.264.033.132.035.132.035.131.036.131.037.13.037.129.038.13.039.13.08.258.041.128.043.129.042.127.044.128.044.127.046.127.045.126.047.126.048.126.096.25.1.248.104.248.051.122.054.123.108.244.056.122.057.121.056.12.116.24.059.12.06.12.06.118.122.236.064.117.062.118.064.117.065.116.065.115.066.116.066.115.136.228.069.114.138.226.072.112.142.224.073.11.074.111.073.11.075.109.075.11.075.108.077.109.077.107.156.214.079.106.08.106.16.21.164.208.082.103.084.103.168.204.086.101.085.101.086.1.087.099.088.1.088.098.089.099.178.194.091.097.091.096.092.095.092.094.092.095.093.094.094.093.094.092.095.092.096.092.095.091.097.091.097.089.196.178.098.088.1.088.099.087.1.086.101.085.101.086.204.168.103.084.103.082.208.164.105.08.105.081.212.158.214.156.107.077.109.077.108.075.11.075.109.075.11.073.111.074.11.073.336.213.113.07.114.069.113.069.228.136.116.066.115.066.115.065.116.064.117.065.118.063.117.062.118.062.118.061.118.06.119.06.121.059.24.116.121.057.12.056.122.056.244.108.123.054.122.051.248.104.248.1.25.096.126.048.126.047.127.045.126.045.127.045.128.044.127.042.128.043.129.041.258.08.13.039.13.038.129.037.131.037.13.036.131.034.132.036.132.033.264.064.133.032.133.03.134.029.133.029.133.028.135.027.27.052.134.024.135.024.136.023.137.022.135.021.137.021.137.019.138.019.136.018.138.017.138.016.138.015.139.015.139.013.138.014.14.012.14.011.139.01.141.009.14.009.14.008.142.006.14.005.284.01.142.003.284.004h.286l.142-.002.142-.002.142-.003.284-.01.14-.005.142-.006.14-.008.141-.009.14-.009.139-.01.14-.011.14-.012.138-.014.139-.013.139-.015.138-.015.138-.016.138-.017.136-.018.138-.019.137-.019.137-.021.135-.021.137-.022.136-.023.135-.024.134-.024.135-.026.135-.026.135-.027.133-.028.133-.029.134-.029.133-.03.133-.032.264-.064.131-.033.133-.036.131-.034.13-.036.131-.037.129-.037.13-.038.13-.039.129-.04.129-.04.129-.041.128-.043.127-.042.128-.044.127-.045.126-.045.127-.045.126-.047.126-.048.25-.096.124-.05.124-.05.124-.052.124-.052.122-.051.123-.054.122-.054.122-.054.122-.056.12-.056.121-.057.12-.058.12-.058.121-.059.119-.06.118-.06.118-.061.118-.062.117-.062.118-.063.117-.065.116-.064.115-.065.115-.066.116-.066.114-.068.114-.068.113-.069.114-.069.113-.07.112-.071.112-.071.112-.071.11-.073.111-.074.11-.073.109-.075.11-.075.108-.075.109-.077.107-.077.107-.078.107-.078.106-.079.106-.079.105-.081.105-.08.104-.082.104-.082.103-.082.103-.084.204-.168.101-.086.101-.085.1-.086.099-.087.1-.088.098-.088.099-.089.097-.089.097-.089.097-.091.095-.091.096-.092.095-.092.094-.092.094-.093.093-.094.092-.094.093-.095.091-.096.091-.095.091-.097.089-.097.089-.097.089-.099.088-.098.088-.1.087-.099.086-.1.085-.101.086-.101.168-.204.084-.103.082-.103.082-.104.082-.104.08-.105.081-.105.158-.212.078-.107.078-.107.077-.107.077-.109.075-.108.075-.11.075-.109.073-.11.074-.111.073-.11.071-.112.071-.112.072-.112.069-.113.069-.114.069-.113.068-.114.068-.114.066-.116.066-.115.065-.115.064-.116.065-.117.063-.118.062-.117.062-.118.061-.118.06-.118.06-.119.059-.121.058-.12.058-.12.057-.121.056-.12.055-.122.055-.122.054-.122.053-.123.053-.122.051-.124.052-.124.05-.124.05-.124.096-.25.048-.126.047-.126.045-.127.045-.126.045-.127.043-.128.043-.127.042-.128.042-.129.04-.129.04-.129.039-.13.038-.13.037-.129.037-.131.036-.13.035-.131.034-.133.034-.131.064-.264.031-.133.031-.133.029-.134.029-.133.028-.133.027-.135.026-.135.026-.135.024-.134.024-.135.023-.136.022-.137.021-.135.021-.137.019-.137.019-.138.018-.136.017-.138.032-.276.014-.139.014-.139.013-.139.012-.139.011-.14.01-.139.009-.141.009-.14.007-.14.008-.142.005-.14.005-.142.004-.142.003-.142.002-.142.002-.142v-.286l-.004-.284-.003-.142-.004-.142-.005-.142-.005-.14-.008-.142-.007-.14-.009-.141-.009-.14-.01-.139-.011-.14-.012-.14-.013-.138-.028-.278-.032-.276-.017-.138-.018-.136-.019-.138-.019-.137-.021-.137-.021-.135-.022-.137-.023-.136-.024-.135-.024-.134-.052-.27-.027-.135-.028-.133-.029-.133-.029-.134-.062-.266-.064-.264-.068-.264-.035-.131-.036-.13-.037-.131-.037-.129-.038-.13-.039-.13-.08-.258-.042-.129-.042-.128-.043-.127-.043-.128-.045-.127-.045-.126-.045-.127-.047-.126-.048-.126-.096-.25-.1-.248-.052-.124-.051-.124-.053-.122-.053-.123-.054-.122-.11-.244-.056-.12-.057-.121-.116-.24-.059-.121-.06-.119-.06-.118-.061-.118-.062-.118-.062-.117-.063-.118-.065-.117-.064-.116-.065-.115-.066-.115-.066-.116-.136-.228-.069-.113-.069-.114-.069-.113-.072-.112-.142-.224-.073-.11-.074-.111-.073-.11-.075-.109-.075-.11-.075-.108-.077-.109-.077-.107-.156-.214-.158-.212-.081-.105-.08-.105-.164-.208-.082-.103-.084-.103-.168-.204-.086-.101-.085-.101-.086-.1-.087-.099-.088-.1-.088-.098-.178-.196-.089-.097-.091-.097-.091-.095-.091-.096-.093-.095-.092-.094-.093-.094-.094-.093-.095-.092-.094-.093-.095-.091-.096-.091-.097-.091-.194-.178-.099-.089-.098-.088-.1-.088-.099-.087-.1-.086-.101-.086-.101-.085-.204-.168-.103-.084-.103-.082-.208-.164-.21-.16-.106-.08-.106-.079-.214-.156-.107-.077-.109-.077-.108-.075-.11-.075-.109-.075-.11-.073-.111-.075-.11-.072-.224-.142-.112-.072-.226-.138-.114-.069-.228-.136-.115-.066-.116-.066-.115-.065-.116-.065-.117-.064-.118-.062-.117-.064-.236-.122-.118-.06-.12-.06-.12-.059-.24-.116-.12-.056-.121-.057-.244-.11-.122-.054-.123-.053-.122-.053-.124-.052-.124-.051-.248-.1-.25-.096-.126-.048-.252-.092-.254-.09-.128-.043-.127-.043-.129-.042-.128-.041-.129-.041-.129-.04-.13-.039-.13-.038-.129-.037-.13-.037-.131-.036-.131-.035-.264-.068-.264-.064-.266-.062-.133-.029-.134-.029-.133-.028-.135-.027-.134-.026-.27-.05-.135-.024-.136-.023-.136-.022-.136-.021-.137-.021-.137-.019-.138-.019-.136-.018-.138-.017-.276-.032-.278-.028-.138-.013-.14-.012-.14-.011-.139-.01-.141-.009-.14-.009-.14-.007-.142-.008-.14-.005-.142-.005-.142-.004-.141-.003-.285-.004zM87 85.013H73a4 4 0 0 1-4-4v-6a2 2 0 0 1 4 0v6.014h14v-6a2 2 0 0 1 4 0v5.986a4 4 0 0 1-4 4zM75.774 68.269l2.242-2.242v10a2 2 0 0 0 4 0v-10l2.243 2.242a2 2 0 1 0 2.828-2.828c-1.569-1.569-4.086-4.087-5.657-5.656a1.998 1.998 0 0 0-2.828 0l-5.657 5.656a2 2 0 0 0 2.829 2.828z"
	}), _react2.default.createElement("path", {
	  d: "M124 122c-3.12 0-6.04-.9-8.5-2.46 1.32.31 2.64.46 3.92.46 3.01 0 5.91-.72 8.56-2.29 7.774-4.344 8.081-13.238 8.081-15.265l-.002-.362.001-.053c.94-1.03 1.66-2.2 2.09-3.47 1.18 2.22 1.85 4.76 1.85 7.44 0 8.82-7.18 16-16 16m-10-19.99c4.22 3.74 9 3.84 11.79 3.84v-3.22c0-1.93 1.68-3.63 3.67-3.63.15 0 3.6 0 3.6 3.63 0 5.6-2.39 10.14-6.54 12.46-2.648 1.56-5.709 2.185-8.79 1.8.06-.02 3.27-.89 5.2-2.42-5.87-2.945-10.03-5.46-8.93-12.46m-6 3.99c0-8.82 7.18-16 16-16 5.15 0 9.74 2.45 12.66 6.24-.84.61-1.81 1.09-2.77 1.45a6.613 6.613 0 0 0-4.424-1.689c-3.685 0-6.676 3.088-6.676 6.629-3.49-.24-6.63-2.05-8.68-4.94-.24-.36-.6-.48-1.08-.48-.49 0-.85.36-.97.72-.114.114-1.218 2.753-1.218 6.021 0 3.711 1.577 7.518 5.798 10.139-1.73.8-3.69 1.18-5.65 1.2A15.89 15.89 0 0 1 108 106m16-20c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20M115.09 45.964v-8.6H118c.731 0 1.31-.43 1.45-1.16l1.46-5.82c.14-.43 0-.87-.29-1.31-.29-.43-.73-.43-1.17-.43h-4.36v-2.909h4.36c.88 0 1.46-.581 1.46-1.461v-5.82c0-.87-.58-1.45-1.46-1.45h-4.36c-4.8 0-8.729 3.93-8.729 8.731v2.909h-2.911c-.87 0-1.45.58-1.45 1.45v5.82c0 .87.58 1.45 1.45 1.45h2.911v6.69C101.38 41.344 98 36.064 98 30.004c0-8.82 7.18-16 16-16s16 7.18 16 16c0 8.45-6.59 15.4-14.91 15.96M114 10.004c-11.05 0-20 8.95-20 20 0 8.409 5.197 15.608 12.525 18.554a2.001 2.001 0 0 0 2.745-1.856V35.914c0-.87-.579-1.46-1.45-1.46h-2.91v-2.9h2.91c.871 0 1.45-.59 1.45-1.46v-4.359c0-3.201 2.62-5.821 5.82-5.821H118v2.91h-2.91a2.92 2.92 0 0 0-2.91 2.911v4.359c0 .87.58 1.46 1.46 1.46h3.92l-.72 2.9h-3.2c-.88 0-1.46.59-1.46 1.46v12.083a1.997 1.997 0 0 0 2.024 1.999C125.403 49.863 134 40.778 134 30.004c0-11.05-8.95-20-20-20M36.383 30.102c-7.477 0-11.444 5.023-11.444 10.484 0 2.539 1.35 5.703 3.514 6.711.328.158.5.086.578-.233.055-.242.352-1.414.485-1.97a.537.537 0 0 0-.116-.5c-.72-.867-1.289-2.469-1.289-3.953 0-3.819 2.889-7.522 7.819-7.522 4.259 0 7.234 2.897 7.234 7.046 0 4.687-2.367 7.937-5.445 7.937-1.703 0-2.977-1.405-2.563-3.133.494-2.061 1.438-4.28 1.438-5.764 0-1.33-.711-2.439-2.194-2.439-1.744 0-3.134 1.798-3.134 4.211 0 1.531.515 2.57.515 2.57s-1.717 7.258-2.031 8.611c-.24 1.022-.249 2.323-.183 3.48C23.942 53.157 20 47.535 20 41c0-8.822 7.178-16 16-16s16 7.178 16 16c0 8.824-7.178 16-16 16-1.541 0-3.027-.23-4.438-.638.581-1.047 1.187-2.29 1.463-3.346.211-.811 1.077-4.116 1.077-4.116.562 1.077 2.219 1.991 3.968 1.991 5.227 0 8.994-4.805 8.994-10.78 0-5.728-4.673-10.009-10.681-10.009M36 21c-11.046 0-20 8.956-20 20 0 11.046 8.954 20 20 20s20-8.954 20-20c0-11.044-8.954-20-20-20",
	  fillRule: "nonzero"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 160 160",
	    fillRule: "evenodd",
	    clipRule: "evenodd"
	  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
	};
	
	exports.default = __webpack_require__.p + "static/social-sharing.d6b7f115.svg";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h160v160H0z"
	});
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill2",
	  d: "M74 134H38c-7.727 0-14-6.273-14-14s6.273-14 14-14h36c7.727 0 14 6.273 14 14s-6.273 14-14 14zm-36-21c3.863 0 7 3.137 7 7s-3.137 7-7 7-7-3.137-7-7 3.137-7 7-7zm36-43H38c-7.727 0-14-6.273-14-14s6.273-14 14-14h36c7.727 0 14 6.273 14 14s-6.273 14-14 14zM38 49c3.863 0 7 3.137 7 7s-3.137 7-7 7-7-3.137-7-7 3.137-7 7-7z",
	  fillOpacity: 0.5
	});
	
	var _ref3 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill1",
	  d: "M38 74h36c7.727 0 14 6.273 14 14s-6.273 14-14 14H38c-7.727 0-14-6.273-14-14s6.273-14 14-14zm36 21c-3.863 0-7-3.137-7-7s3.137-7 7-7 7 3.137 7 7-3.137 7-7 7z",
	  fillOpacity: 0.5
	});
	
	var _ref4 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M66 65.995c5.026 0 9.417 2.658 11.884 6.637a8.022 8.022 0 0 1 8.776 1.708l.76.76a7.927 7.927 0 0 1 2.06-3.59c3.13-3.12 8.2-3.12 11.32 0l12.08 12.08a7.825 7.825 0 0 1 2.06-3.59c2.46-2.46 6.14-2.98 9.12-1.54a7.921 7.921 0 0 1 2.19-4.12 8.015 8.015 0 0 1 11.32 0l4.25 4.25a2 2 0 0 1-2.84 2.82l-4.24-4.24a4.008 4.008 0 0 0-5.66 0 4.008 4.008 0 0 0 0 5.66c1.88 1.88-.96 4.7-2.83 2.83l-2.82-2.83h-.01a3.996 3.996 0 0 0-5.65 5.65v.01l.7.7c1.48 1.46-.01 3.93-1.98 3.32-.69-.18.67 1.02-18.52-18.17a4.008 4.008 0 0 0-5.66 0 3.998 3.998 0 0 0-.09 5.56l17.06 17.07c1.85 1.85-.91 4.67-2.79 2.86L89.4 82.74l-5.17-5.17a4.008 4.008 0 0 0-5.66 0 4.008 4.008 0 0 0 0 5.66c.1.1 33.31 33.32 33.58 33.5l-.04.04c.78.78.78 2.05 0 2.83-.89.891-2.32.67-2.82 0h-.01l-8.96-8.96c-3.12 3.13-.38 10.93 6.13 17.44 4.32 4.32 13.38 10.14 17.44 6.13h.01c1.557-1.556 3.908.802 2.35 2.36-4.68 4.68-14.81 2.15-22.62-5.659h-.01c-5.84-5.841-11.39-16.881-5.65-22.621L77.551 87.871c-2.519 3.692-6.744 6.124-11.551 6.124H30c-7.732 0-14-6.268-14-14 0-7.731 6.273-14 14-14h36zm0 31.995c7.73 0 14 6.27 14 14 0 7.739-6.27 14-14 14H30c-7.679 0-14-6.219-14-14 0-7.725 6.289-14 14-14h36zm0 4H30c-5.496 0-10 4.46-10 10 0 5.504 4.445 10 10 10h36c5.516 0 10-4.453 10-10 0-5.54-4.504-10-10-10zm-36 3c3.863 0 7 3.137 7 7 0 3.864-3.137 7-7 7s-7-3.136-7-7c0-3.863 3.137-7 7-7zm36-14.995c3.731 0 6.973-2.053 8.689-5.083a8.013 8.013 0 0 1 .006-9.834c-1.716-3.032-4.964-5.083-8.695-5.083H30c-5.522 0-10 4.48-10 10 0 5.522 4.481 10 10 10h36zm0-17c3.863 0 7 3.136 7 7 0 3.863-3.137 7-7 7s-7-3.137-7-7c0-3.864 3.137-7 7-7zM66 34c7.73 0 14 6.26 14 13.99 0 7.739-6.27 14-14 14H30c-7.679 0-14-6.219-14-14C16 40.311 22.219 34 30 34h36zm0 23.99c5.516 0 10-4.453 10-10A9.989 9.989 0 0 0 66 38H30c-5.529 0-10 4.469-10 9.99 0 5.505 4.445 10 10 10h36zm-36-3c3.86 0 7-3.13 7-7 0-3.86-3.14-6.99-7-6.99s-7 3.13-7 6.99c0 3.87 3.14 7 7 7z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 160 160",
	    fillRule: "evenodd",
	    clipRule: "evenodd"
	  }, props), _ref, _ref2, _ref3, _ref4);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h160v160H0z"
	});
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill2",
	  d: "M138.5 104a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m-11.5 3a10.994 10.994 0 0 0-10.994 11.353.998.998 0 0 1-1.797.629A12.2 12.2 0 0 1 112 112c0-6.63 5.37-12 12-12 5.364 0 9.9 3.524 11.431 8.384a.984.984 0 0 1-1.577 1.049A10.797 10.797 0 0 0 127 107m13-15h-6c0-2.21-1.79-4-4-4h-12c-2.21 0-4 1.79-4 4h-6c-4.42 0-8 3.58-8 8v24c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8v-24c0-4.42-3.58-8-8-8",
	  fillOpacity: 0.5,
	  fillRule: "nonzero"
	});
	
	var _ref3 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill1",
	  d: "M126.5 70c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m-4.5-9.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m1 8.5c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm-4 0c0 .55-.45 1-1 1s-1-.45-1-1v-5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5c0 .55-.45 1-1 1s-1-.45-1-1V59c0-.55.45-1 1-1s1 .45 1 1v2.77a2.996 2.996 0 0 1 5 2.23v5zm6.51-10.55c.25-.29.61-.45.99-.45s.74.16.99.45c.25.28.37.66.32 1.04l-.75 6.01c-.03.29-.27.5-.56.5-.29 0-.53-.21-.56-.5l-.75-6.01c-.05-.38.07-.76.32-1.04M136 59v-3c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-3l5-5-5-5zM72 144H40a4 4 0 0 1-4-4v-13h-4a3.995 3.995 0 0 1-2.828-1.172A3.995 3.995 0 0 1 28 123v-4c0-1.061.421-2.078 1.172-2.828A3.995 3.995 0 0 1 32 115h40a4 4 0 0 1 4 4v4.923l12.743-10.292A2 2 0 0 1 92 115.187v25.593a1.999 1.999 0 0 1-3.267 1.548L76 131.91V140a4 4 0 0 1-4 4zm-24-17a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4h4zm7 0a2 2 0 0 0 0-4h-1a2 2 0 0 0 0 4h1zm12 0a2 2 0 0 0 0-4h-6a2 2 0 0 0 0 4h6zm.15-45.999c-5.03 0-9.46 2.53-12.15 6.39-2.69-3.86-7.12-6.39-12.15-6.39-8.2 0-14.85 6.72-14.85 15 0 8.28 6.65 15 14.85 15h24.3c8.2 0 14.85-6.72 14.85-15 0-8.28-6.65-15-14.85-15zm-.15 22c-3.75 0-6.8-2.95-6.98-6.66a5.958 5.958 0 0 0 4.98 2.66 6.005 6.005 0 0 0 5-9.32c2.36 1.13 4 3.53 4 6.32 0 3.87-3.13 7-7 7zm-24 0c-3.75 0-6.8-2.95-6.98-6.66a5.958 5.958 0 0 0 4.98 2.66 6.005 6.005 0 0 0 5-9.32c2.36 1.13 4 3.53 4 6.32 0 3.87-3.13 7-7 7z",
	  fillOpacity: 0.5,
	  fillRule: "nonzero"
	});
	
	var _ref4 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "fill2",
	  d: "M52 70c-2.21 0-4-1.79-4-4V56a3.98 3.98 0 0 1 3.02-3.87C51.47 40.93 60.69 32 72 32s20.53 8.93 20.98 20.13c1.74.43 3.02 2 3.02 3.87v10c0 2.21-1.79 4-4 4h-7v.17c0 1.01-.9 1.83-2 1.83s-2-.82-2-1.83V51.83c0-1.01.9-1.83 2-1.83s2 .82 2 1.83V52h3.97c-.51-8.92-7.91-16-16.97-16-9.06 0-16.46 7.08-16.97 16H59v-.17c0-1.01.9-1.83 2-1.83s2 .82 2 1.83v18.34c0 1.01-.9 1.83-2 1.83s-2-.82-2-1.83V70h-7zm25.17-11.85l-4.24 10.88c-.17.45-.64.71-1.11.62a.996.996 0 0 1-.82-.98V62l-2.8 1.12c-.38.15-.8.06-1.09-.22-.28-.29-.36-.72-.21-1.09l4.18-10.14a.999.999 0 0 1 1.111-.6c.469.1.809.51.809.98V58l2.86-1.14c.371-.15.79-.07 1.081.21.279.28.369.7.229 1.08zM91 60c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3zm-33 0c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3z",
	  fillOpacity: 0.5,
	  fillRule: "nonzero"
	});
	
	var _ref5 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M120 40a8 8 0 0 1 8 8v3l5 5-5 5v3a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8V48a8 8 0 0 1 8-8h16zm0 28c2.206 0 4-1.794 4-4v-3c0-1.061.421-2.078 1.172-2.828L127.343 56l-2.171-2.172A3.995 3.995 0 0 1 124 51v-3c0-2.205-1.794-4-4-4h-16c-2.206 0-4 1.795-4 4v16c0 2.206 1.794 4 4 4h16zm-3-7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm-2-5.5a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6zm-7-2c1.66 0 3 1.34 3 3v5a1 1 0 1 1-2 0v-5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5a1 1 0 1 1-2 0V51a1 1 0 1 1 2 0v2.77c.53-.48 1.23-.77 2-.77zm9.187-1.512a1.322 1.322 0 0 1 2.307-1.041c.251.285.368.664.32 1.041l-.751 6.016a.568.568 0 0 1-1.125 0l-.751-6.016zM115.5 51a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM77 62v.167C77 63.179 76.104 64 75 64s-2-.821-2-1.833V43.833c0-1.012.896-1.833 2-1.833s2 .821 2 1.833V44h3.971C80.453 35.076 73.053 28 64 28s-16.453 7.076-16.971 16H51v-.167c0-1.012.896-1.833 2-1.833s2 .821 2 1.833v18.334C55 63.179 54.104 64 53 64s-2-.821-2-1.833V62h-7a4 4 0 0 1-4-4V48a4.003 4.003 0 0 1 3.018-3.879C43.479 32.931 52.696 24 64 24c11.304 0 20.521 8.931 20.982 20.121A4.003 4.003 0 0 1 88 48v10a4 4 0 0 1-4 4h-7zm-7.834-11.854a1 1 0 1 0-1.304-1.291L65 50v-5.945a1 1 0 0 0-1.924-.381l-4.175 10.138a.999.999 0 1 0 1.297 1.309L63 54v6.669a1 1 0 0 0 1.933.363l4.233-10.886zM50 48h-5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5h-4a1 1 0 0 1 0-2h4v-1a1 1 0 0 0-1-1zm33 0h-5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5h-4a1 1 0 0 1 0-2h4v-1a1 1 0 0 0-1-1zM122 80a4 4 0 0 1 4 4h6c4.42 0 8 3.58 8 8v24c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8V92c0-4.42 3.58-8 8-8h6a4 4 0 0 1 4-4h12zm4 8a4 4 0 0 1-4-4h-12a4 4 0 0 1-4 4h-6c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V92c0-2.21-1.79-4-4-4h-6zm-10 4c-6.63 0-12 5.37-12 12 0 2.595.83 4.998 2.235 6.963a.968.968 0 0 0 1.738-.609c.029-.118.027-.236.027-.354a10.994 10.994 0 0 1 17.868-8.583.964.964 0 1 0 1.544-1.027A11.944 11.944 0 0 0 116 92zm14.5-1a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5z",
	  fillRule: "nonzero"
	});
	
	var _ref6 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M64 136H32a4 4 0 0 1-4-4v-13h-4a3.995 3.995 0 0 1-2.828-1.172A3.995 3.995 0 0 1 20 115v-4c0-1.061.421-2.078 1.172-2.828A3.995 3.995 0 0 1 24 107h40a4 4 0 0 1 4 4v4.923l12.743-10.293A2 2 0 0 1 84 107.186v25.593a2 2 0 0 1-3.267 1.548L68 123.909V132a4 4 0 0 1-4 4zm0-25H24v4h6a2 2 0 0 1 2 2v15h32v-8a4 4 0 0 1 4-4 4 4 0 0 1-4-4v-5zm16 17.559L69.43 120 80 111.372v17.187zM40 119h-4a2 2 0 0 1 0-4h4a2 2 0 0 1 0 4zm7 0h-1a2 2 0 0 1 0-4h1a2 2 0 0 1 0 4zm12 0h-6a2 2 0 0 1 0-4h6a2 2 0 0 1 0 4zm.15-46c-5.027 0-9.463 2.53-12.15 6.392C44.314 75.53 39.878 73 34.85 73 26.649 73 20 79.716 20 88c0 8.284 6.649 15 14.85 15h24.3C67.352 103 74 96.284 74 88c0-8.284-6.648-15-14.85-15zm0 26C65.133 99 70 94.065 70 88s-4.867-11-10.85-11c-7.708 0-10.094 7.159-12.15 9.396C44.947 84.163 42.564 77 34.85 77 28.867 77 24 81.935 24 88s4.867 11 10.85 11h24.3zM39.994 83.104a.664.664 0 0 0-1.105.618c.064.415.111.841.111 1.278a6 6 0 0 1-9.456 4.905.667.667 0 1 0-1.03.753C29.572 93.203 32.074 95 35 95a7 7 0 0 0 7-7 6.958 6.958 0 0 0-2.006-4.896zm24 0a.664.664 0 0 0-1.105.618c.064.415.111.841.111 1.278a6 6 0 0 1-9.456 4.905.667.667 0 1 0-1.03.753C53.572 93.203 56.074 95 59 95a7 7 0 0 0 7-7 6.958 6.958 0 0 0-2.006-4.896zM79.978 73.304a1.16 1.16 0 0 1 1.966-1.135l2.279 2.547a1.155 1.155 0 0 0 1.226.329l3.247-1.067a1.16 1.16 0 0 1 1.135 1.966l-2.547 2.279a1.155 1.155 0 0 0-.329 1.226l1.067 3.247a1.16 1.16 0 0 1-1.966 1.135l-2.279-2.547a1.155 1.155 0 0 0-1.226-.329l-3.247 1.067a1.16 1.16 0 0 1-1.135-1.966l2.547-2.279a1.155 1.155 0 0 0 .329-1.226l-1.067-3.247z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 160 160",
	    fillRule: "evenodd",
	    clipRule: "evenodd"
	  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(4);
	
	var _presets = __webpack_require__(3);
	
	var _functions = __webpack_require__(5);
	
	var _typography = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var section = /*#__PURE__*/(0, _emotion.css)('margin:', (0, _functions.toRem)(_presets.baselineGrid * 6), ' 0;', _functions.mqObj.lap, '{margin:', (0, _functions.toRem)(_presets.baselineGrid * 8), ' 0;}', _functions.mqObj.desk, '{margin:', (0, _functions.toRem)(_presets.baselineGrid * 10), ' 0;}', 'label:section;');
	
	var sectionTitle = /*#__PURE__*/(0, _emotion.css)('margin:0;padding-top:calc(', (0, _functions.toRem)(_presets.baselineGrid * 5), ' + ', (0, _functions.toVW)(_presets.baselineGrid * 5), ');padding-left:10vw;padding-right:10vw;padding-bottom:', (0, _typography.rhythm)(_typography.options.blockMarginBottom), ';text-align:center;font-size:calc(', (0, _functions.toRem)(_presets.baselineGrid * 3), ' + ', (0, _functions.toVW)(_presets.baselineGrid), ');', 'label:sectionTitle;');
	
	var Section = function Section(_ref) {
	  var title = _ref.title,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'section',
	    { className: section },
	    title && _react2.default.createElement(
	      'h1',
	      { className: sectionTitle },
	      title
	    ),
	    children
	  );
	};
	
	Section.propTypes = {
	  title: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]).isRequired
	};
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _toTitleCase = __webpack_require__(20);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _striptags = __webpack_require__(80);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	var _config = __webpack_require__(13);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSchemaOrgJSONLD = function getSchemaOrgJSONLD(_ref) {
	  var isBlogPost = _ref.isBlogPost,
	      isArticle = _ref.isArticle,
	      isTheme = _ref.isTheme,
	      url = _ref.url,
	      title = _ref.title,
	      image = _ref.image,
	      description = _ref.description,
	      datePublished = _ref.datePublished,
	      dateModified = _ref.dateModified,
	      authorName = _ref.authorName,
	      price = _ref.price;
	
	  var schemaOrgJSONLD = [{
	    '@context': 'http://schema.org',
	    '@type': 'WebSite',
	    url: url,
	    name: title,
	    alternateName: _config2.default.siteTitle
	  }];
	
	  if (isBlogPost || isArticle) {
	    return [].concat(schemaOrgJSONLD, [{
	      '@context': 'http://schema.org',
	      '@type': 'BreadcrumbList',
	      itemListElement: [{
	        '@type': 'ListItem',
	        position: 1,
	        item: {
	          '@id': url,
	          name: title,
	          image: image
	        }
	      }]
	    }, _extends({
	      '@context': 'http://schema.org',
	      '@type': 'BlogPosting',
	      url: url,
	      name: title,
	      alternateName: _config2.default.siteTitle,
	      headline: title,
	      image: {
	        '@type': 'ImageObject',
	        url: image
	      },
	      description: description,
	      author: {
	        '@type': 'Person',
	        name: authorName || 'Sergio Chiavassa'
	      },
	      publisher: {
	        '@type': 'Organization',
	        url: 'https://pixelmoxie.net',
	        name: 'PixelMoxie',
	        logo: {
	          '@type': 'ImageObject',
	          name: 'PixelMoxie Logo',
	          width: '496',
	          height: '60',
	          url: _config2.default.siteLogo
	        }
	      },
	      mainEntityOfPage: {
	        '@type': 'WebSite',
	        '@id': _config2.default.siteUrl
	      },
	      datePublished: datePublished
	    }, dateModified && { dateModified: dateModified })]);
	  } else if (isTheme) {
	    return [].concat(schemaOrgJSONLD, [{
	      '@context': 'http://schema.org',
	      '@type': 'BreadcrumbList',
	      itemListElement: [{
	        '@type': 'ListItem',
	        position: 1,
	        item: {
	          '@id': url,
	          name: title,
	          image: image
	        }
	      }]
	    }, {
	      '@context': 'http://schema.org',
	      '@type': 'Product',
	      name: title,
	      description: description,
	      url: url,
	      image: {
	        '@type': 'ImageObject',
	        url: image
	      },
	      offers: {
	        '@type': 'Offer',
	        price: price,
	        priceCurrency: 'USD'
	      },
	      manufacturer: {
	        '@type': 'Organization',
	        url: 'https://pixelmoxie.net',
	        name: 'PixelMoxie',
	        logo: {
	          '@type': 'ImageObject',
	          name: 'PixelMoxie Logo',
	          width: '496',
	          height: '60',
	          url: _config2.default.siteLogo
	        }
	      },
	      mainEntityOfPage: {
	        '@type': 'WebSite',
	        '@id': _config2.default.siteUrl
	      }
	    }]);
	  }
	  return schemaOrgJSONLD;
	};
	
	var SEO = function SEO(_ref2) {
	  var postData = _ref2.postData,
	      postImage = _ref2.postImage,
	      pathPrefix = _ref2.pathPrefix,
	      isBlogPost = _ref2.isBlogPost,
	      isArticle = _ref2.isArticle,
	      isTheme = _ref2.isTheme;
	
	  var postMeta = postData.frontmatter || {};
	  var postSEO = postMeta.seo || {};
	  var fields = postData.fields || {};
	  var title = postSEO.title || fields.title || _config2.default.siteTitle;
	  var description = postSEO.description || postMeta.excerpt || postData.excerpt || _config2.default.siteDescription;
	  var image = postImage ? '' + _config2.default.siteUrl + postImage : _config2.default.siteImage;
	  var url = fields.slug ? '' + _config2.default.siteUrl + pathPrefix + fields.slug : _config2.default.siteUrl;
	  var datePublished = fields.datePublished;
	
	  var dateModified = postMeta.dateModified || postMeta.modified;
	  var authorName = postMeta.author && postMeta.author.name;
	  var isOGArticle = isBlogPost || isArticle || isTheme;
	
	  var schemaOrgJSONLD = getSchemaOrgJSONLD({
	    isBlogPost: isBlogPost,
	    isArticle: isArticle,
	    isTheme: isTheme,
	    url: url,
	    title: title,
	    image: image,
	    description: description,
	    datePublished: datePublished,
	    dateModified: dateModified,
	    authorName: authorName,
	    price: postMeta.price
	  });
	
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    null,
	    _react2.default.createElement(
	      'title',
	      null,
	      (0, _toTitleCase2.default)(title)
	    ),
	    _react2.default.createElement('meta', { name: 'description', content: (0, _striptags2.default)(description) }),
	    _react2.default.createElement('meta', { name: 'image', content: image }),
	    _react2.default.createElement(
	      'script',
	      { type: 'application/ld+json' },
	      JSON.stringify(schemaOrgJSONLD)
	    ),
	    _react2.default.createElement('meta', { property: 'og:url', content: url }),
	    isOGArticle && _react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
	    isOGArticle && datePublished && _react2.default.createElement('meta', { property: 'article:published_time', content: datePublished }),
	    isOGArticle && dateModified && _react2.default.createElement('meta', { property: 'article:modified_time', content: dateModified }),
	    isOGArticle && dateModified && _react2.default.createElement('meta', { property: 'og:updated_time', content: dateModified }),
	    _react2.default.createElement('meta', { property: 'og:title', content: title }),
	    _react2.default.createElement('meta', { property: 'og:description', content: description }),
	    _react2.default.createElement('meta', { property: 'og:image', content: image }),
	    _react2.default.createElement('meta', { property: 'fb:app_id', content: _config2.default.fbAppID }),
	    _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	    _react2.default.createElement('meta', { name: 'twitter:creator', content: _config2.default.twitter }),
	    _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	    _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	    _react2.default.createElement('meta', { name: 'twitter:image', content: image })
	  );
	};
	
	SEO.propTypes = {
	  postData: _propTypes2.default.shape({
	    frontmatter: _propTypes2.default.any,
	    excerpt: _propTypes2.default.any
	  }).isRequired,
	  postImage: _propTypes2.default.string,
	  pathPrefix: _propTypes2.default.string,
	  isBlogPost: _propTypes2.default.bool,
	  isArticle: _propTypes2.default.bool,
	  isTheme: _propTypes2.default.bool
	};
	
	SEO.defaultProps = {
	  isBlogPost: false,
	  isArticle: false,
	  isTheme: false,
	  postImage: null,
	  pathPrefix: ''
	};
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.themeDetailsFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(4);
	
	__webpack_require__(217);
	
	var _gray = __webpack_require__(10);
	
	var _gray2 = _interopRequireDefault(_gray);
	
	var _presets = __webpack_require__(3);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(7);
	
	var _functions = __webpack_require__(5);
	
	var _button = __webpack_require__(34);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _shapeCheck16px = __webpack_require__(179);
	
	var _shapeCheck16px2 = _interopRequireDefault(_shapeCheck16px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var detailList = /*#__PURE__*/(0, _emotion.css)('margin-bottom:', (0, _typography.rhythm)(_typography.options.blockMarginBottom), ';padding:', (0, _functions.toRem)(_presets.baselineGrid), ' calc(', (0, _functions.toRem)(_presets.baselineGrid * 3), ' + ', (0, _functions.toVW)(_presets.baselineGrid), ');&.has-title{padding-top:', (0, _functions.toRem)(_presets.baselineGrid * 2), ';}', 'label:detailList;');
	
	var themeMeta = /*#__PURE__*/(0, _emotion.css)((0, _typography.adjustFontSizeTo)('16px'), ';background-color:', _presets.colors.ui.whisper, ';border-radius:', _presets2.default.radius.default, ';box-shadow:0 1px 1px 0 ', (0, _gray2.default)(84), ';', 'label:themeMeta;');
	
	var detailHeader = /*#__PURE__*/(0, _emotion.css)('label:detailHeader;');
	
	var detailTitle = /*#__PURE__*/(0, _emotion.css)('margin:0;padding:', (0, _functions.toRem)(_presets.baselineGrid * 2), ' 0;', 'label:detailTitle;');
	
	var detailTable = /*#__PURE__*/(0, _emotion.css)('display:block;[class*=\'cols\'] &{display:flex;flex-wrap:wrap;justify-content:space-between;}', 'label:detailTable;');
	
	var detailCell = /*#__PURE__*/(0, _emotion.css)('padding:', (0, _functions.toRem)(_presets.baselineGrid * 2), ' 0;[class*=\'cols-2\'] &{width:50%;&:nth-child(2n + 1){padding-right:', (0, _functions.toRem)(_presets.baselineGrid), ';}&:nth-child(2n + 2){padding-left:', (0, _functions.toRem)(_presets.baselineGrid), ';}}[class*=\'split-cols\'] &{&:nth-child(2n + 1){width:45%;padding-right:', (0, _functions.toRem)(_presets.baselineGrid), ';}&:nth-child(2n + 2){width:55%;}}', 'label:detailCell;');
	
	var divider = /*#__PURE__*/(0, _emotion.css)('box-shadow:inset 0 1px 0 0 ', (0, _gray2.default)(92), ';', 'label:divider;');
	
	var detailLine = /*#__PURE__*/(0, _emotion.css)('display:flex;.icon{display:flex;flex:0 0 16px;height:', (0, _functions.toRem)(28), ';margin-right:', (0, _functions.toRem)(_presets.baselineGrid), ';svg{align-self:center;width:', (0, _functions.toRem)(16), ';height:', (0, _functions.toRem)(16), ';fill:', _presets.colors.accent.green, ';}}', 'label:detailLine;');
	
	var DetailList = function DetailList(_ref) {
	  var _cx;
	
	  var title = _ref.title,
	      data = _ref.data,
	      cols = _ref.cols,
	      split = _ref.split,
	      checklist = _ref.checklist;
	  return _react2.default.createElement(
	    'section',
	    {
	      className: (0, _emotion.cx)(detailList, themeMeta, (_cx = {
	        checklist: checklist
	      }, _cx['cols-' + cols] = cols, _cx['split-cols'] = split, _cx['has-title'] = title, _cx))
	    },
	    title && _react2.default.createElement(
	      'header',
	      { className: detailHeader },
	      _react2.default.createElement(
	        'h4',
	        { className: detailTitle },
	        title
	      )
	    ),
	    data && _react2.default.createElement(
	      'div',
	      { className: detailTable },
	      data.map(function (val, idx) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: idx,
	            className: (0, _emotion.cx)(detailCell, function () {
	              var idxAfter = 0;
	              if (cols) {
	                idxAfter = cols - 1;
	              } else if (split) {
	                idxAfter = 1;
	              }
	              if (!title && idx <= idxAfter) return false;
	              return divider;
	            })
	          },
	          checklist ? _react2.default.createElement(
	            'div',
	            { className: detailLine },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon' },
	              _react2.default.createElement(
	                'svg',
	                { viewBox: _shapeCheck16px2.default.viewBox },
	                _react2.default.createElement('use', { xlinkHref: '#' + _shapeCheck16px2.default.id })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              val
	            )
	          ) : val
	        );
	      })
	    )
	  );
	};
	
	DetailList.propTypes = {
	  title: _propTypes2.default.string,
	  data: _propTypes2.default.array.isRequired,
	  cols: _propTypes2.default.number,
	  split: _propTypes2.default.bool,
	  checklist: _propTypes2.default.bool
	};
	
	var ThemeDetails = function ThemeDetails(props) {
	  var name = props.name,
	      price = props.price,
	      purchaseURL = props.purchaseURL,
	      created = props.created,
	      updated = props.updated,
	      version = props.version,
	      details = props.details;
	
	
	  var purchaseBox = /*#__PURE__*/(0, _emotion.css)('display:flex;justify-content:space-between;align-items:baseline;margin-bottom:', (0, _typography.rhythm)(_typography.options.blockMarginBottom * 1.5), ';', 'label:purchaseBox;');
	
	  var purchaseBoxTitle = /*#__PURE__*/(0, _emotion.css)('margin:0;padding:', (0, _functions.toRem)(_presets.baselineGrid), ';padding-left:0;font-size:', (0, _functions.toRem)(24), ';', 'label:purchaseBoxTitle;');
	
	  var purchaseBoxButton = /*#__PURE__*/(0, _emotion.css)('margin:0;padding:', (0, _functions.toRem)(_presets.baselineGrid * 2), ' ', (0, _functions.toRem)(_presets.baselineGrid * 4), ';font-size:', (0, _functions.toRem)(18), ';', 'label:purchaseBoxButton;');
	
	  var buttonMobile = /*#__PURE__*/(0, _emotion.css)('display:block;', _functions.mqObj.desk, '{display:none;}', 'label:buttonMobile;');
	
	  var buttonDesktop = /*#__PURE__*/(0, _emotion.css)('display:none;', _functions.mqObj.desk, '{display:block;}', 'label:buttonDesktop;');
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: purchaseBox },
	      _react2.default.createElement(
	        'h4',
	        { className: purchaseBoxTitle },
	        name
	      ),
	      _react2.default.createElement(
	        _button2.default,
	        {
	          to: purchaseURL,
	          className: (0, _emotion.cx)(purchaseBoxButton, buttonMobile),
	          shadow: true,
	          gradient: {
	            rotate: -16,
	            lighten: 0.08
	          }
	        },
	        'Buy $' + price
	      ),
	      _react2.default.createElement(
	        _button2.default,
	        {
	          to: purchaseURL,
	          className: (0, _emotion.cx)(purchaseBoxButton, buttonDesktop),
	          shadow: true,
	          gradient: {
	            rotate: -16,
	            lighten: 0.08
	          }
	        },
	        'Buy Theme $' + price
	      )
	    ),
	    _react2.default.createElement(DetailList, {
	      data: ['Created on', created, 'Last updated', updated, 'Current version', version],
	      split: true
	    }),
	    _react2.default.createElement(DetailList, { title: 'What you get:', data: details, checklist: true })
	  );
	};
	
	ThemeDetails.propTypes = {
	  name: _propTypes2.default.string,
	  price: _propTypes2.default.string,
	  demos: _propTypes2.default.array,
	  purchaseURL: _propTypes2.default.string,
	  created: _propTypes2.default.string,
	  updated: _propTypes2.default.string,
	  version: _propTypes2.default.string,
	  details: _propTypes2.default.array,
	  platform: _propTypes2.default.string,
	  tags: _propTypes2.default.array
	};
	
	exports.default = ThemeDetails;
	var themeDetailsFragment = exports.themeDetailsFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.themeHeroFragment = undefined;
	
	var _emotion = __webpack_require__(4);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable global-require */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(51);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _color = __webpack_require__(8);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _shortid = __webpack_require__(272);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _smartypants = __webpack_require__(54);
	
	var _smartypants2 = _interopRequireDefault(_smartypants);
	
	__webpack_require__(217);
	
	var _gray = __webpack_require__(10);
	
	var _gray2 = _interopRequireDefault(_gray);
	
	var _config = __webpack_require__(13);
	
	var _presets = __webpack_require__(3);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(7);
	
	var _functions = __webpack_require__(5);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _button = __webpack_require__(34);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _shapeEye = __webpack_require__(180);
	
	var _shapeEye2 = _interopRequireDefault(_shapeEye);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _presets$animation = _presets2.default.animation,
	    curve = _presets$animation.curve,
	    speed = _presets$animation.speed;
	
	
	var browserChromeDotColor = _presets.colors.gray.calm;
	
	var browserChromeDotColors = [(0, _color2.default)(browserChromeDotColor).hsl().toString(), (0, _color2.default)(browserChromeDotColor).hsl().alpha(0.76).toString(), (0, _color2.default)(browserChromeDotColor).hsl().alpha(0.52).toString()];
	
	var cover = {
	  position: 'absolute',
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var heroBackgroundColor = (0, _color2.default)(_presets.colors.ui.darkPurple).hsl().alpha(0.8).string();
	
	var themeHero = /*#__PURE__*/(0, _emotion.css)('position:relative;margin-top:', (0, _functions.toRem)(_presets.baselineGrid * -15), ';padding-top:', (0, _functions.toRem)(_presets.baselineGrid * 15), ';@media (min-width:', _config.navBreakpoint, 'px){margin-top:', (0, _functions.toRem)(_presets.baselineGrid * -20), ';padding-top:', (0, _functions.toRem)(_presets.baselineGrid * 20), ';}', 'label:themeHero;');
	
	var themeHeroBackground = /*#__PURE__*/(0, _emotion.css)(cover, ';background-color:', _presets.colors.gray.dark, ';overflow:hidden;z-index:-1;&::before{', cover, ' content:\'\';display:block;background-color:', heroBackgroundColor, ';z-index:', _presets.zIndex[2], ';}', 'label:themeHeroBackground;');
	
	var themeHeroBackgroundImg = /*#__PURE__*/(0, _emotion.css)('width:100%;height:100%;margin:0;object-fit:cover;object-position:center;z-index:', _presets.zIndex[1], ';/* filter:url(\'#hero-blur\');*/\n  filter:blur(calc(', (0, _functions.toRem)(_presets.baselineGrid), ' + 1vw));transform:scale(1.2);', 'label:themeHeroBackgroundImg;');
	
	var themeHeroWrapper = /*#__PURE__*/(0, _emotion.css)('overflow-x:hidden;@media (min-width:', _config.navBreakpoint, 'px){margin-top:', (0, _functions.toRem)(_presets.baselineGrid * 4), ';}', _functions.mqObj.lapLarge, '{display:flex;flex-wrap:nowrap;justify-content:space-between;align-content:flex-end;}', _functions.mqObj.desk, '{margin-top:', (0, _functions.toRem)(_presets.baselineGrid * 6), ';}', 'label:themeHeroWrapper;');
	
	var themeHeader = /*#__PURE__*/(0, _emotion.css)('text-align:center;color:', _presets.colors.gray.dark, ';.dark-header &{color:', _presets.colors.ui.bright, ';}', _functions.mqObj.lapLarge, '{display:flex;flex-flow:column;justify-content:flex-start;flex:0 0 auto;width:40%;padding-right:', (0, _functions.toVW)(_presets.baselineGrid * 4), ';text-align:left;}', _functions.mqObj.desk, '{margin-top:', (0, _functions.toRem)(_presets.baselineGrid * 2), ';padding-right:', (0, _functions.toVW)(_presets.baselineGrid * 5), ';}', _functions.mqObj.deskLarge, '{margin-top:', (0, _functions.toRem)(_presets.baselineGrid * 6), ';}', 'label:themeHeader;');
	
	var themeName = /*#__PURE__*/(0, _emotion.css)('margin:', (0, _functions.toRem)(_presets.baselineGrid * 2), ' 0;font-size:', (0, _functions.toRem)(_presets.baselineGrid * 3), ';letter-spacing:', 1 / 24, 'em;color:', _presets.colors.gray.dark, ';.dark-header &{color:', _presets.colors.ui.bright, ';}', _functions.mqObj.lap, '{font-size:', (0, _functions.toRem)(_presets.baselineGrid * 4), ';}', _functions.mqObj.desk, '{font-size:', (0, _functions.toRem)(_presets.baselineGrid * 5), ';}', 'label:themeName;');
	
	var themeDescription = /*#__PURE__*/(0, _emotion.css)('font-size:16px;line-height:1.5;padding:0 ', (0, _functions.toRem)(_presets.baselineGrid * 2), ';color:', (0, _gray2.default)(13, 0, false), ';.dark-header &{color:', (0, _gray2.default)(64, 0, true), ';}', _functions.mqObj.lapLarge, '{padding:0 ', (0, _functions.toRem)(_presets.baselineGrid * 4), ' 0 0;}', 'label:themeDescription;');
	
	var themeHeroActions = /*#__PURE__*/(0, _emotion.css)('margin-bottom:', (0, _typography.rhythm)(_typography.options.blockMarginBottom), ';', 'label:themeHeroActions;');
	
	var themeShowcase = /*#__PURE__*/(0, _emotion.css)('align-self:flex-end;margin:0 ', (0, _functions.toRem)(_presets2.default.baselineGrid * -2), ';', _functions.mqObj.palm, '{margin:0 ', (0, _functions.toRem)(_presets2.default.baselineGrid * -3), ';}', _functions.mqObj.lap, '{margin:0 ', (0, _functions.toRem)(_presets2.default.baselineGrid * -4), ';}', _functions.mqObj.lapLarge, '{width:100%;flex:0 1 auto;margin:0;}', 'label:themeShowcase;');
	
	var screenshotWrapper = /*#__PURE__*/(0, _emotion.css)('width:90vw;padding:0 3vw;cursor:url(', (0, _gatsbyLink.withPrefix)('cursors/cursor-chevron-fat.svg'), ') 9 14,url(', (0, _gatsbyLink.withPrefix)('cursors/cursor-chevron-fat.png'), ') 9 14,pointer;&:first-child{padding:0 0 0 6vw;}&:last-child{padding:0 6vw 0 0;}', _functions.mqObj.lap, '{width:70vw;}', _functions.mqObj.lapLarge, '{width:100%;&,&:first-child,&:last-child{padding:0 2vw;}}', 'label:screenshotWrapper;');
	
	var screenshot = /*#__PURE__*/(0, _emotion.css)('position:relative;', 'label:screenshot;');
	
	var screenshotLarge = /*#__PURE__*/(0, _emotion.css)('position:relative;padding-top:', (0, _functions.toRem)(_presets.baselineGrid * 1.5), ';border-radius:3px 3px 0 0;box-shadow:0 2px 5px ', (0, _gray2.default)(80), ';opacity:0.72;transition:opacity ', speed.default, ' ', curve.default, ',transform ', speed.fast, ' ', curve.default, ';.carousel-cell.is-selected &{opacity:1;}/* browser chrome */\n  &::before{content:\'\';display:block;position:absolute;height:', (0, _functions.toRem)(_presets.baselineGrid * 1.5), ';top:0;right:0;left:0;background-color:', (0, _gray2.default)(70, 'cool'), ';border-radius:3px 3px 0 0;}&::after{content:\'\';display:block;position:absolute;width:4px;height:4px;top:', (0, _functions.toRem)(_presets.baselineGrid * 0.75), ';left:', (0, _functions.toRem)(_presets.baselineGrid * 0.75), ';background-color:', browserChromeDotColors[0], ';transform:translate(0,-50%);border-radius:50%;box-shadow:7px 0 0 0 ', browserChromeDotColors[1], ',14px 0 0 0 ', browserChromeDotColors[2], ';}', _functions.mqObj.desk, '{padding-top:', (0, _functions.toRem)(_presets.baselineGrid * 2), ';border-radius:5px 5px 0 0;&::before{height:', (0, _functions.toRem)(_presets.baselineGrid * 2), ';border-radius:5px 5px 0 0;}&::after{width:6px;height:6px;top:', (0, _functions.toRem)(_presets.baselineGrid), ';left:', (0, _functions.toRem)(_presets.baselineGrid), ';box-shadow:10px 0 0 0 ', browserChromeDotColors[1], ',20px 0 0 0 ', browserChromeDotColors[2], ';}}', 'label:screenshotLarge;');
	
	var screenshotLargeWrapper = /*#__PURE__*/(0, _emotion.css)('position:relative;padding-bottom:', 800 / 1280 * 100, '%;overflow:hidden;', 'label:screenshotLargeWrapper;');
	
	var screenshotMobile = /*#__PURE__*/(0, _emotion.css)('position:absolute;width:22%;max-height:52%;bottom:0;right:calc(-3vw + 1px);padding:4vw 2px 0;border-radius:1.8vw 1.8vw 0 0;background-color:', _presets.colors.gray.dark, ';z-index:', _presets.zIndex[1], ';overflow:hidden;visibility:hidden;opacity:0;transform:translate3d(0,16%,0);transition:opacity ', speed.default, ' ', curve.default, ',transform ', speed.default, ' ', curve.default, ';transition-delay:', speed.fast, ';&::after{content:\'\';display:block;position:absolute;width:20%;height:2px;top:2vw;left:50%;transform:translate3d(-50%,-50%,0);border-radius:1vw;background-color:', (0, _gray2.default)(32, 'cool', true), ';}.carousel-cell.is-selected &{visibility:visible;opacity:1;transform:translate3d(0,1%,0);}', _functions.mqObj.lap, '{padding:3.2vw 2px 0;border-radius:1.2vw 1.2vw 0 0;&::after{top:1.6vw;}}', _functions.mqObj.lapLarge, '{right:calc(-2vw + 1px);padding:2.6vw 3px 0;border-radius:1vw 1vw 0 0;&::after{top:1.3vw;}}', _functions.mqObj.deskLarge, '{right:calc(-2vw + 1px);padding:2.2vw 4px 0;border-radius:1vw 1vw 0 0;&::after{height:3px;top:1.1vw;}}', 'label:screenshotMobile;');
	
	var screenshotFrame = /*#__PURE__*/(0, _emotion.css)(_extends({}, cover), 'label:screenshotFrame;');
	
	var themeHeroButton = /*#__PURE__*/(0, _emotion.css)({
	  marginRight: (0, _functions.toRem)(_presets.baselineGrid * 2),
	  marginBottom: (0, _functions.toRem)(_presets.baselineGrid * 2)
	}, 'label:themeHeroButton;');
	
	var flickityOptions = {
	  draggable: true,
	  cellAlign: 'center',
	  cellSelector: '.carousel-cell',
	  prevNextButtons: false,
	  pageDots: false,
	  contain: true,
	  selectedAttraction: 0.08,
	  friction: 0.56
	};
	
	var ThemeHero = function (_Component) {
	  _inherits(ThemeHero, _Component);
	
	  function ThemeHero(props) {
	    _classCallCheck(this, ThemeHero);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      Flickity: null
	    };
	
	    if (typeof window !== 'undefined') {
	      var Flickity = __webpack_require__(659);
	      _this.state.Flickity = Flickity;
	    }
	    return _this;
	  }
	
	  ThemeHero.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.flkty.on('staticClick', function (event, pointer, cellElement, cellIndex) {
	      if (cellElement && cellIndex < _this2.flkty.cells.length) {
	        _this2.flkty.next(true);
	      }
	    });
	  };
	
	  ThemeHero.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.flkty.off('staticClick');
	  };
	
	  ThemeHero.prototype.render = function render() {
	    var _this3 = this;
	
	    var Flickity = this.state.Flickity;
	    var _props = this.props,
	        name = _props.name,
	        excerpt = _props.excerpt,
	        price = _props.price,
	        demos = _props.demos,
	        purchaseURL = _props.purchaseURL,
	        backgroundColor = _props.backgroundColor,
	        backgroundImage = _props.backgroundImage,
	        images = _props.images;
	
	
	    var coloredBackground = backgroundColor && /*#__PURE__*/(0, _emotion.css)('&::before{background-color:', backgroundColor, ';}', 'label:coloredBackground;');
	
	    return _react2.default.createElement(
	      'section',
	      { className: themeHero },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _emotion.cx)(themeHeroBackground, coloredBackground) },
	        backgroundImage && _react2.default.createElement('img', {
	          src: backgroundImage.childImageSharp.sizes.src,
	          className: themeHeroBackgroundImg
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)('position:absolute;top:0;left:-9999em;', 'label:ThemeHero;', 'label:ThemeHero;')
	          },
	          _react2.default.createElement(
	            'svg',
	            null,
	            _react2.default.createElement(
	              'defs',
	              null,
	              _react2.default.createElement(
	                'filter',
	                { id: 'hero-blur' },
	                _react2.default.createElement('feGaussianBlur', { 'in': 'SourceGraphic', stdDeviation: '16' }),
	                _react2.default.createElement(
	                  'feComponentTransfer',
	                  null,
	                  _react2.default.createElement('feFuncA', { type: 'discrete', tableValues: '1 1' })
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _innerWrapper2.default,
	        { className: themeHeroWrapper },
	        _react2.default.createElement(
	          'header',
	          { className: themeHeader },
	          _react2.default.createElement(
	            'h1',
	            { className: themeName },
	            name
	          ),
	          excerpt && _react2.default.createElement('div', {
	            className: themeDescription,
	            dangerouslySetInnerHTML: {
	              __html: excerpt.split('\n').map(function (p) {
	                return '<p>' + (0, _smartypants2.default)(p, 'qDew') + '</p>';
	              }).join('')
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: themeHeroActions },
	            _react2.default.createElement(
	              _button2.default,
	              {
	                to: purchaseURL,
	                className: themeHeroButton,
	                shadow: true,
	                gradient: {
	                  rotate: -16,
	                  lighten: 0.08
	                }
	              },
	              'Get it for $',
	              price
	            ),
	            demos.map(function (url, idx, arr) {
	              var label = arr.length === 1 ? 'Demo' : 'Demo ' + ['One', 'Two', 'Three'][idx];
	
	              return _react2.default.createElement(
	                _button2.default,
	                { key: idx, to: url, className: themeHeroButton, hollow: true },
	                _react2.default.createElement(
	                  'svg',
	                  { viewBox: _shapeEye2.default.viewBox },
	                  _react2.default.createElement('use', { xlinkHref: '#' + _shapeEye2.default.id })
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  label
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: themeShowcase },
	          Flickity && _react2.default.createElement(
	            Flickity,
	            {
	              className: 'carousel',
	              options: flickityOptions,
	              disableImagesLoaded: true,
	              reloadOnUpdate: true,
	              flickityRef: function flickityRef(c) {
	                return _this3.flkty = c;
	              } // eslint-disable-line no-return-assign
	            },
	            images.map(function (image) {
	              return _react2.default.createElement(
	                'div',
	                { key: _shortid2.default.generate(), className: (0, _emotion.css)(screenshotWrapper) + ' carousel-cell'
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: screenshot },
	                  _react2.default.createElement(
	                    'div',
	                    { className: screenshotLarge },
	                    _react2.default.createElement(
	                      'div',
	                      { className: screenshotLargeWrapper },
	                      _react2.default.createElement(
	                        'div',
	                        { className: screenshotFrame },
	                        _react2.default.createElement(_gatsbyImage2.default, { alt: '', sizes: image.desktop.childImageSharp.sizes })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: screenshotMobile },
	                    _react2.default.createElement(_gatsbyImage2.default, { alt: '', sizes: image.mobile.childImageSharp.sizes })
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return ThemeHero;
	}(_react.Component);
	
	ThemeHero.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  excerpt: _propTypes2.default.string.isRequired,
	  price: _propTypes2.default.string.isRequired,
	  demos: _propTypes2.default.array.isRequired,
	  purchaseURL: _propTypes2.default.string.isRequired,
	  backgroundColor: _propTypes2.default.string,
	  backgroundImage: _propTypes2.default.object,
	  images: _propTypes2.default.array.isRequired
	};
	
	exports.default = ThemeHero;
	var themeHeroFragment = exports.themeHeroFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.themeFeaturesFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _color = __webpack_require__(8);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _shortid = __webpack_require__(272);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _toTitleCase = __webpack_require__(20);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _gray = __webpack_require__(10);
	
	var _gray2 = _interopRequireDefault(_gray);
	
	var _styles = __webpack_require__(26);
	
	var _presets = __webpack_require__(3);
	
	var _typography = __webpack_require__(7);
	
	var _functions = __webpack_require__(5);
	
	var _section = __webpack_require__(304);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _button = __webpack_require__(34);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _desktopAndGadgets = __webpack_require__(322);
	
	var _tumblrPostTypes = __webpack_require__(330);
	
	var _themeOptions = __webpack_require__(329);
	
	var _googleFonts = __webpack_require__(323);
	
	var _socialSharing = __webpack_require__(328);
	
	var _commentingSystems = __webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var featuresIcons = {
	  DesktopAndGadgets: _desktopAndGadgets.ReactComponent,
	  TumblrPostTypes: _tumblrPostTypes.ReactComponent,
	  ThemeOptions: _themeOptions.ReactComponent,
	  GoogleFonts: _googleFonts.ReactComponent,
	  SocialSharing: _socialSharing.ReactComponent,
	  CommentingSystems: _commentingSystems.ReactComponent
	};
	
	var themeFeatures = /*#__PURE__*/(0, _reactEmotion.css)('text-align:left;@media (max-width:', _presets.breakpoints.lap - 1, 'px){text-align:center;}', 'label:themeFeatures;');
	
	var themeFeaturesWrapper = /*#__PURE__*/(0, _reactEmotion.css)('display:flex;flex-wrap:wrap;', 'label:themeFeaturesWrapper;');
	
	var themeFeaturesCell = /*#__PURE__*/(0, _reactEmotion.css)('position:relative;flex:0 1 100%;padding:', (0, _functions.toRem)(_presets.baselineGrid * 4), ' calc(', (0, _functions.toRem)(_presets.baselineGrid * 2), ' + ', (0, _functions.toVW)(_presets.baselineGrid * 4), ');&::before,&::after{content:\'\';display:block;position:absolute;z-index:-1;pointer-events:none;border-color:', (0, _gray2.default)(80, 'cool'), ';border-style:solid;border-width:0;}&::before{top:0;bottom:0;left:50%;width:', (0, _functions.toRem)(_presets.baselineGrid * 12), ';transform:translate(-50%,0);border-top-width:1px;}&::after{left:0;right:0;top:50%;height:', (0, _functions.toRem)(_presets.baselineGrid * 12), ';transform:translate(0,-50%);border-right-width:1px;}@media (max-width:', _presets.breakpoints.lap - 1, 'px){/* outline:1px dotted red;*/\n    &::after{border-right-width:0;}&:first-of-type{&::before{border-top-width:0;}}}@media (min-width:', _presets.breakpoints.lap, 'px) and (max-width:', _presets.breakpoints.lapLarge - 1, 'px){flex:0 1 50%;&:nth-child(-n + 2){&::before{border-top-width:0;}}&:nth-child(2n + 2){&::after{border-right-width:0;}}}@media (min-width:', _presets.breakpoints.lapLarge, 'px){flex:0 1 33.3333%;&:nth-child(-n + 3){&::before{border-top-width:0;}}&:nth-child(3n + 3){&::after{border-right-width:0;}}}', 'label:themeFeaturesCell;');
	
	var themeFeaturesIcon = /*#__PURE__*/(0, _reactEmotion.css)('display:block;max-width:', (0, _functions.toRem)(_presets.baselineGrid * 28), ';fill:', _presets.colors.gray.gunpowder, ';isolation:isolate;@media (max-width:', _presets.breakpoints.lap - 1, 'px){margin:0 auto;}@media (min-width:', _presets.breakpoints.lap, 'px) and (max-width:', _presets.breakpoints.lapLarge - 1, 'px){margin:0 0 ', (0, _typography.rhythm)(_typography.options.blockMarginBottom), ' 0;}@media (min-width:', _presets.breakpoints.lapLarge, 'px){margin:', (0, _typography.rhythm)(_typography.options.blockMarginBottom), ' 0;}[class^=\'fill\']{mix-blend-mode:screen;}.fill1{fill:', _presets.colors.pixelmoxie, ';fill-opacity:0.4;}.fill2{fill:', _presets.colors.accent.green, ';fill-opacity:0.5;}', 'label:themeFeaturesIcon;');
	
	var altColors = /*#__PURE__*/(0, _reactEmotion.css)('.fill1{fill:', _presets.colors.purple, ';fill-opacity:0.35;}.fill2{fill:', _presets.colors.accent.yellow, ';fill-opacity:0.6;}', 'label:altColors;');
	
	var themeFeaturesTitle = /*#__PURE__*/(0, _reactEmotion.css)('margin-bottom:', (0, _typography.rhythm)(_typography.options.blockMarginBottom * 0.5), ';', 'label:themeFeaturesTitle;');
	
	var themeFeaturesPlug = /*#__PURE__*/(0, _reactEmotion.css)('label:themeFeaturesPlug;');
	
	var ctaWrap = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;', 'label:ctaWrap;');
	
	var cta = /*#__PURE__*/(0, _reactEmotion.css)('margin-left:auto;margin-right:auto;', 'label:cta;');
	
	var featuresData = [{
	  icon: 'DesktopAndGadgets',
	  title: 'One Design For All Screens',
	  description: 'Fully responsive and retina ready, mobile-first design. Looks great on all devices.'
	}, {
	  icon: 'ThemeOptions',
	  title: 'Plenty of Theme Options',
	  description: 'Change fonts, colors, layouts, show or hide elements, and more.'
	}, {
	  icon: 'GoogleFonts',
	  title: 'Google Fonts Ready',
	  description: 'Customize headings and more with families from the Google Web Fonts repository.'
	}, {
	  icon: 'TumblrPostTypes',
	  title: 'Support For All Post Types',
	  description: 'Text, Photo, Quote, Link, Chat, Audio, Video and Answer posts are all supported.'
	}, {
	  icon: 'SocialSharing',
	  title: 'Social Sharing',
	  description: 'Share your posts on the main social media outlets with minimal fuss.'
	}, {
	  icon: 'CommentingSystems',
	  title: 'Comments Support',
	  description: 'Out of the box support for Disqus and Facebook commenting systems.'
	}];
	
	var ThemeFeaturesCell = function ThemeFeaturesCell(_ref) {
	  var _cx;
	
	  var data = _ref.data;
	  var icon = data.icon,
	      title = data.title,
	      description = data.description,
	      className = data.className,
	      alt = data.alt;
	
	  var Icon = featuresIcons[icon];
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _reactEmotion.cx)(themeFeaturesCell, className) },
	    _react2.default.createElement(Icon, { className: (0, _reactEmotion.cx)(themeFeaturesIcon, (_cx = {}, _cx[altColors] = alt, _cx)) }),
	    _react2.default.createElement(
	      'h4',
	      { className: themeFeaturesTitle },
	      (0, _toTitleCase2.default)(title)
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: themeFeaturesPlug },
	      description
	    )
	  );
	};
	
	ThemeFeaturesCell.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	var ThemeFeatures = function ThemeFeatures(_ref2) {
	  var name = _ref2.name,
	      features = _ref2.features;
	
	  var featuresArray = featuresData;
	
	  // Let individual themes override features entries.
	  if (features) {
	    var map = new Map(features.map(function (feat) {
	      return [feat.icon, feat];
	    }));
	    featuresArray = featuresData.map(function (feature) {
	      var icon = feature.icon;
	
	      var override = map.get(icon) || {};
	
	      return {
	        icon: String(icon),
	        title: override.title || feature.title,
	        description: override.description || feature.description
	      };
	    });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _reactEmotion.cx)(themeFeatures, _styles.rte) },
	    _react2.default.createElement(
	      _innerWrapper2.default,
	      { narrow: true },
	      _react2.default.createElement(
	        _section2.default,
	        { title: (0, _toTitleCase2.default)('Also included with ' + name) },
	        _react2.default.createElement(
	          'div',
	          { className: themeFeaturesWrapper },
	          featuresArray.map(function (data, index) {
	            data.alt = Boolean(index % 2);
	            return _react2.default.createElement(ThemeFeaturesCell, { key: _shortid2.default.generate(), data: data });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _section2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: ctaWrap },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              to: '/tumblr-themes/',
	              className: cta,
	              backgroundColor: (0, _color2.default)(_presets.colors.blue).hsl().lighten(0.1).desaturate(0.1).string(),
	              large: true,
	              arrow: true
	            },
	            'Browse More Themes'
	          )
	        )
	      )
	    )
	  );
	};
	
	ThemeFeatures.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  features: _propTypes2.default.array
	};
	
	exports.default = ThemeFeatures;
	var themeFeaturesFragment = exports.themeFeaturesFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(4);
	
	var _mediumZoom = __webpack_require__(78);
	
	var _mediumZoom2 = _interopRequireDefault(_mediumZoom);
	
	var _styles = __webpack_require__(26);
	
	var _presets = __webpack_require__(3);
	
	var _typography = __webpack_require__(7);
	
	var _functions = __webpack_require__(5);
	
	var _seo = __webpack_require__(56);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _themeHero = __webpack_require__(309);
	
	var _themeHero2 = _interopRequireDefault(_themeHero);
	
	var _themeDetails = __webpack_require__(308);
	
	var _themeDetails2 = _interopRequireDefault(_themeDetails);
	
	var _themesFeatures = __webpack_require__(310);
	
	var _themesFeatures2 = _interopRequireDefault(_themesFeatures);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bp = _functions.mqObj.lapLarge;
	
	var theme = /*#__PURE__*/(0, _emotion.css)('label:theme;');
	
	var themeBody = /*#__PURE__*/(0, _emotion.css)('margin:', (0, _functions.toRem)(_presets.baselineGrid * 8), ' 0;', _functions.mqObj.lapLarge, '{margin:', (0, _functions.toRem)(_presets.baselineGrid * 3), ' 0;}', _functions.mqObj.deskLarge, '{margin:', (0, _functions.toRem)(_presets.baselineGrid * 4), ' 0;}', 'label:themeBody;');
	
	var themeBodyWrapper = /*#__PURE__*/(0, _emotion.css)('display:block;', bp, '{display:flex;}', 'label:themeBodyWrapper;');
	
	var column = /*#__PURE__*/(0, _emotion.css)('margin:', (0, _typography.rhythm)(_typography.options.blockMarginBottom), ' 0;', 'label:column;');
	
	var themeMain = /*#__PURE__*/(0, _emotion.css)('flex:1 1 auto;', bp, '{padding-right:calc(', (0, _functions.toRem)(_presets.baselineGrid * 4), ' + ', (0, _functions.toVW)(_presets.baselineGrid * 4), ');}', _functions.mqObj.deskLarge, '{padding-right:calc(', (0, _functions.toRem)(_presets.baselineGrid * 4), ' + ', (0, _functions.toVW)(_presets.baselineGrid * 6), ');}', 'label:themeMain;');
	
	var themeDescription = /*#__PURE__*/(0, _emotion.css)('label:themeDescription;');
	
	var themeAside = /*#__PURE__*/(0, _emotion.css)('flex:0 0 auto;@media (max-width:', _presets.breakpoints.lapLarge - 1, 'px){margin-top:', (0, _functions.toRem)(_presets.baselineGrid * 12), ';}', bp, '{width:calc(', (0, _functions.toRem)(_presets.baselineGrid * 30), ' + 5vw);align-self:flex-start;}', _functions.mqObj.desk, '{width:calc(', (0, _functions.toRem)(_presets.baselineGrid * 30), ' + 8vw);}@media (min-width:', _presets.breakpoints.lapLarge, 'px) and (min-height:769px){position:sticky;top:calc(', (0, _functions.toRem)(_presets.baselineGrid * 10), ' + ', (0, _typography.rhythm)(_typography.options.blockMarginBottom), ');}', 'label:themeAside;');
	
	var ThemePage = function (_Component) {
	  _inherits(ThemePage, _Component);
	
	  function ThemePage(props) {
	    _classCallCheck(this, ThemePage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      imageZoomSelector: "[class$='themeDescription'] .gatsby-resp-image-image, [class$='themeDescription'] .remark-image-wrapper img"
	    };
	
	    _this.setImageZoom = _this.setImageZoom.bind(_this);
	    return _this;
	  }
	
	  ThemePage.prototype.setImageZoom = function setImageZoom() {
	    this.zoom = (0, _mediumZoom2.default)(this.state.imageZoomSelector);
	  };
	
	  ThemePage.prototype.componentDidMount = function componentDidMount() {
	    this.setImageZoom();
	  };
	
	  ThemePage.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.zoom) {
	      this.zoom.detach();
	      this.zoom = undefined;
	    }
	  };
	
	  ThemePage.prototype.render = function render() {
	    var _props = this.props,
	        _props$data = _props.data,
	        themeData = _props$data.themeData,
	        _props$data$themeData = _props$data.themeData,
	        themeID = _props$data$themeData.internal.contentDigest,
	        html = _props$data$themeData.html,
	        _props$data$themeData2 = _props$data$themeData.frontmatter,
	        created = _props$data$themeData2.created,
	        demos = _props$data$themeData2.demos,
	        details = _props$data$themeData2.details,
	        excerpt = _props$data$themeData2.excerpt,
	        features = _props$data$themeData2.features,
	        heroBackgroundColor = _props$data$themeData2.heroBackgroundColor,
	        heroBackgroundImage = _props$data$themeData2.heroBackgroundImage,
	        heroImages = _props$data$themeData2.heroImages,
	        name = _props$data$themeData2.name,
	        platform = _props$data$themeData2.platform,
	        price = _props$data$themeData2.price,
	        purchaseURL = _props$data$themeData2.purchaseURL,
	        tags = _props$data$themeData2.tags,
	        updated = _props$data$themeData2.updated,
	        version = _props$data$themeData2.version,
	        pathPrefix = _props.pathContext.pathPrefix;
	
	
	    var detailsProps = {
	      created: created,
	      demos: demos,
	      details: details,
	      name: name,
	      platform: platform,
	      price: price,
	      purchaseURL: purchaseURL,
	      tags: tags,
	      updated: updated,
	      version: version
	    };
	
	    var imageSharp = heroImages[0] && heroImages[0].desktop && heroImages[0].desktop.childImageSharp;
	
	    return _react2.default.createElement(
	      'article',
	      { className: theme },
	      _react2.default.createElement(
	        _seo2.default,
	        {
	          key: 'seo-' + themeID,
	          postData: themeData,
	          postImage: imageSharp && imageSharp.sizes && imageSharp.sizes.src,
	          pathPrefix: pathPrefix,
	          isTheme: true
	        },
	        _react2.default.createElement(
	          'title',
	          null,
	          name
	        )
	      ),
	      _react2.default.createElement(_themeHero2.default, {
	        key: 'theme-hero-' + themeID,
	        name: name,
	        excerpt: excerpt,
	        price: price,
	        demos: demos,
	        purchaseURL: purchaseURL,
	        backgroundColor: heroBackgroundColor,
	        backgroundImage: heroBackgroundImage,
	        images: heroImages
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: themeBody },
	        _react2.default.createElement(
	          _innerWrapper2.default,
	          { className: themeBodyWrapper, narrow: true },
	          _react2.default.createElement(
	            'section',
	            { className: (0, _emotion.cx)(column, themeMain, _styles.rte) },
	            _react2.default.createElement('div', { className: themeDescription, dangerouslySetInnerHTML: { __html: html } })
	          ),
	          _react2.default.createElement(
	            'aside',
	            { className: (0, _emotion.cx)(column, themeAside) },
	            _react2.default.createElement(_themeDetails2.default, detailsProps)
	          )
	        ),
	        _react2.default.createElement(_themesFeatures2.default, { name: name, features: features })
	      )
	    );
	  };
	
	  return ThemePage;
	}(_react.Component);
	
	ThemePage.propTypes = {
	  data: _propTypes2.default.object,
	  pathContext: _propTypes2.default.object
	};
	
	exports.default = ThemePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-theme-page-js-694ca9281690e9604119.js